// This file is auto-generated by @hey-api/openapi-ts

export const $AsrProxyProviderWebhookBodyDto = {
  type: 'object',
  properties: {
    transcript_id: {
      type: 'string',
    },
    status: {
      enum: ['completed', 'error'],
      type: 'string',
    },
  },
  required: ['transcript_id', 'status'],
} as const;

export const $BrowserDataBodyDto = {
  type: 'object',
  properties: {
    browserName: {
      type: 'string',
    },
    browserVersion: {
      type: 'string',
    },
    osName: {
      type: 'string',
    },
    deviceName: {
      type: 'string',
    },
    userAgent: {
      type: 'string',
    },
  },
  required: ['browserName', 'browserVersion', 'osName', 'deviceName', 'userAgent'],
} as const;

export const $KeysDto = {
  type: 'object',
  properties: {
    auth: {
      type: 'string',
    },
    p256dh: {
      type: 'string',
    },
  },
  required: ['auth', 'p256dh'],
} as const;

export const $SubscriptionDto = {
  type: 'object',
  properties: {
    endpoint: {
      type: 'string',
    },
    expirationTime: {
      type: 'string',
      nullable: true,
    },
    keys: {
      $ref: '#/components/schemas/KeysDto',
    },
  },
  required: ['endpoint', 'expirationTime', 'keys'],
} as const;

export const $SaveSubscriptionBodyDto = {
  type: 'object',
  properties: {
    browserData: {
      $ref: '#/components/schemas/BrowserDataBodyDto',
    },
    subscription: {
      $ref: '#/components/schemas/SubscriptionDto',
    },
  },
  required: ['browserData', 'subscription'],
} as const;

export const $SaveSubscriptionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    browserName: {
      type: 'string',
    },
    browserVersion: {
      type: 'string',
    },
    osName: {
      type: 'string',
    },
    deviceName: {
      type: 'string',
    },
    userAgent: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    subscription: {
      type: 'object',
      description: 'Push subscription (JSON value from storage)',
    },
  },
  required: [
    'id',
    'createdAt',
    'browserName',
    'browserVersion',
    'osName',
    'deviceName',
    'userAgent',
    'userId',
    'subscription',
  ],
} as const;

export const $SubscriptionsListResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    browserName: {
      type: 'string',
    },
    browserVersion: {
      type: 'string',
    },
    osName: {
      type: 'string',
    },
    deviceName: {
      type: 'string',
    },
    userAgent: {
      type: 'string',
    },
    subscription: {
      $ref: '#/components/schemas/SubscriptionDto',
    },
  },
  required: ['id', 'browserName', 'browserVersion', 'osName', 'deviceName', 'userAgent', 'subscription'],
} as const;

export const $LastNotificationResponseDtoOrganization = {
  type: 'object',
  properties: {
    image: {
      type: 'string',
      nullable: true,
    },
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $LastNotificationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    userId: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    url: {
      type: 'string',
    },
    seen: {
      type: 'boolean',
    },
    Organization: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/LastNotificationResponseDtoOrganization',
        },
      ],
    },
  },
  required: ['id', 'createdAt', 'userId', 'title', 'message', 'url', 'seen', 'Organization'],
} as const;

export const $GetNotificationSettingsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    userId: {
      type: 'string',
    },
    emailNotifications: {
      type: 'boolean',
    },
    pushNotifications: {
      type: 'boolean',
    },
    jobAssignedEmail: {
      type: 'boolean',
    },
    jobAssignedPush: {
      type: 'boolean',
    },
    repositoryAssignedEmail: {
      type: 'boolean',
    },
    repositoryAssignedPush: {
      type: 'boolean',
    },
    jobSubscriptionsStatusEmail: {
      type: 'boolean',
    },
    jobSubscriptionsStatusPush: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneeEmail: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneePush: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsEmail: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsPush: {
      type: 'boolean',
    },
    workspaceSubscriptionsEmail: {
      type: 'boolean',
    },
    workspaceSubscriptionsPush: {
      type: 'boolean',
    },
    editorSubscriptionsEmail: {
      type: 'boolean',
    },
    editorSubscriptionsPush: {
      type: 'boolean',
    },
    proofreaderSubscriptionsEmail: {
      type: 'boolean',
    },
    proofreaderSubscriptionsPush: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'createdAt',
    'userId',
    'emailNotifications',
    'pushNotifications',
    'jobAssignedEmail',
    'jobAssignedPush',
    'repositoryAssignedEmail',
    'repositoryAssignedPush',
    'jobSubscriptionsStatusEmail',
    'jobSubscriptionsStatusPush',
    'jobSubscriptionsAssigneeEmail',
    'jobSubscriptionsAssigneePush',
    'jobSubscriptionsCommentsEmail',
    'jobSubscriptionsCommentsPush',
    'workspaceSubscriptionsEmail',
    'workspaceSubscriptionsPush',
    'editorSubscriptionsEmail',
    'editorSubscriptionsPush',
    'proofreaderSubscriptionsEmail',
    'proofreaderSubscriptionsPush',
  ],
} as const;

export const $UpdateNotificationSettingsBodyDto = {
  type: 'object',
  properties: {
    emailNotifications: {
      type: 'boolean',
    },
    pushNotifications: {
      type: 'boolean',
    },
    jobAssignedEmail: {
      type: 'boolean',
    },
    jobAssignedPush: {
      type: 'boolean',
    },
    repositoryAssignedEmail: {
      type: 'boolean',
    },
    repositoryAssignedPush: {
      type: 'boolean',
    },
    jobSubscriptionsStatusEmail: {
      type: 'boolean',
    },
    jobSubscriptionsStatusPush: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneeEmail: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneePush: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsEmail: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsPush: {
      type: 'boolean',
    },
    workspaceSubscriptionsEmail: {
      type: 'boolean',
    },
    workspaceSubscriptionsPush: {
      type: 'boolean',
    },
    editorSubscriptionsEmail: {
      type: 'boolean',
    },
    editorSubscriptionsPush: {
      type: 'boolean',
    },
    proofreaderSubscriptionsEmail: {
      type: 'boolean',
    },
    proofreaderSubscriptionsPush: {
      type: 'boolean',
    },
  },
  required: [
    'emailNotifications',
    'pushNotifications',
    'jobAssignedEmail',
    'jobAssignedPush',
    'repositoryAssignedEmail',
    'repositoryAssignedPush',
    'jobSubscriptionsStatusEmail',
    'jobSubscriptionsStatusPush',
    'jobSubscriptionsAssigneeEmail',
    'jobSubscriptionsAssigneePush',
    'jobSubscriptionsCommentsEmail',
    'jobSubscriptionsCommentsPush',
    'workspaceSubscriptionsEmail',
    'workspaceSubscriptionsPush',
    'editorSubscriptionsEmail',
    'editorSubscriptionsPush',
    'proofreaderSubscriptionsEmail',
    'proofreaderSubscriptionsPush',
  ],
} as const;

export const $UpdateNotificationSettingsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    userId: {
      type: 'string',
    },
    emailNotifications: {
      type: 'boolean',
    },
    pushNotifications: {
      type: 'boolean',
    },
    jobAssignedEmail: {
      type: 'boolean',
    },
    jobAssignedPush: {
      type: 'boolean',
    },
    repositoryAssignedEmail: {
      type: 'boolean',
    },
    repositoryAssignedPush: {
      type: 'boolean',
    },
    jobSubscriptionsStatusEmail: {
      type: 'boolean',
    },
    jobSubscriptionsStatusPush: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneeEmail: {
      type: 'boolean',
    },
    jobSubscriptionsAssigneePush: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsEmail: {
      type: 'boolean',
    },
    jobSubscriptionsCommentsPush: {
      type: 'boolean',
    },
    workspaceSubscriptionsEmail: {
      type: 'boolean',
    },
    workspaceSubscriptionsPush: {
      type: 'boolean',
    },
    editorSubscriptionsEmail: {
      type: 'boolean',
    },
    editorSubscriptionsPush: {
      type: 'boolean',
    },
    proofreaderSubscriptionsEmail: {
      type: 'boolean',
    },
    proofreaderSubscriptionsPush: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'createdAt',
    'userId',
    'emailNotifications',
    'pushNotifications',
    'jobAssignedEmail',
    'jobAssignedPush',
    'repositoryAssignedEmail',
    'repositoryAssignedPush',
    'jobSubscriptionsStatusEmail',
    'jobSubscriptionsStatusPush',
    'jobSubscriptionsAssigneeEmail',
    'jobSubscriptionsAssigneePush',
    'jobSubscriptionsCommentsEmail',
    'jobSubscriptionsCommentsPush',
    'workspaceSubscriptionsEmail',
    'workspaceSubscriptionsPush',
    'editorSubscriptionsEmail',
    'editorSubscriptionsPush',
    'proofreaderSubscriptionsEmail',
    'proofreaderSubscriptionsPush',
  ],
} as const;

export const $SetAllNotificationsReadResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
      description: 'Number of notifications updated',
    },
  },
  required: ['count'],
} as const;

export const $NoticeExtractorJobAttachmentBodyDto = {
  type: 'object',
  properties: {
    generateKeyterms: {
      type: 'boolean',
      default: true,
      description: 'Whether to run the AssemblyAI keyterms LLM extraction step.',
    },
  },
} as const;

export const $NoticeExtractorWorkflowResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
  },
  required: ['jobId'],
} as const;

export const $NoticeExtractorTextBodyDto = {
  type: 'object',
  properties: {
    textContent: {
      type: 'string',
    },
    path: {
      type: 'string',
      description: 'S3 folder key where the extracted JSON result will be saved.',
    },
    filename: {
      type: 'string',
      description: 'Result file base name. The -extracted.json postfix will be added.',
    },
  },
  required: ['textContent', 'path', 'filename'],
} as const;

export const $NoticeExtractorSourceFileBodyDto = {
  type: 'object',
  properties: {
    sourceFilePath: {
      type: 'string',
      description: 'S3 object key for the source PDF file.',
    },
  },
  required: ['sourceFilePath'],
} as const;

export const $NoticeExtractorFieldBoundsResponseDto = {
  type: 'object',
  properties: {
    left: {
      type: 'number',
    },
    right: {
      type: 'number',
    },
    top: {
      type: 'number',
    },
    bottom: {
      type: 'number',
    },
  },
  required: ['left', 'right', 'top', 'bottom'],
} as const;

export const $NoticeExtractorFieldSourceResponseDto = {
  type: 'object',
  properties: {
    pageNumber: {
      type: 'number',
    },
    lineNumber: {
      type: 'number',
    },
    snippet: {
      type: 'string',
    },
    bounds: {
      $ref: '#/components/schemas/NoticeExtractorFieldBoundsResponseDto',
    },
  },
  required: ['pageNumber', 'lineNumber', 'snippet', 'bounds'],
} as const;

export const $NoticeExtractorExtractionSummaryResponseDto = {
  type: 'object',
  properties: {
    found: {
      type: 'number',
    },
    total: {
      type: 'number',
    },
    foundFields: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    missingFields: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['found', 'total', 'foundFields', 'missingFields'],
} as const;

export const $NoticeExtractorCaseInformationResponseDto = {
  type: 'object',
  properties: {
    case_name: {
      type: 'string',
    },
    case_number: {
      type: 'string',
    },
    court: {
      type: 'string',
    },
    division: {
      type: 'string',
    },
  },
  required: ['case_name', 'case_number', 'court', 'division'],
} as const;

export const $NoticeExtractorPartyResponseDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    role: {
      enum: ['Attorney', 'Defendant', 'Deponent', 'Plaintiff'],
      type: 'string',
    },
    represented_by: {
      type: 'string',
    },
  },
  required: ['name', 'role', 'represented_by'],
} as const;

export const $NoticeExtractorLawFirmAttorneyResponseDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    bar_number: {
      type: 'string',
    },
  },
  required: ['name', 'bar_number'],
} as const;

export const $NoticeExtractorLawFirmResponseDto = {
  type: 'object',
  properties: {
    firm_name: {
      type: 'string',
    },
    representing: {
      type: 'string',
    },
    attorneys: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorLawFirmAttorneyResponseDto',
      },
    },
    address: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    fax: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
  },
  required: ['firm_name', 'representing', 'attorneys', 'address', 'phone', 'fax', 'email'],
} as const;

export const $NoticeExtractorDocumentDetailsResponseDto = {
  type: 'object',
  properties: {
    title: {
      type: 'string',
    },
    filing_date: {
      type: 'string',
    },
    service_date: {
      type: 'string',
    },
  },
  required: ['title', 'filing_date', 'service_date'],
} as const;

export const $NoticeExtractorScheduledEventResponseDto = {
  type: 'object',
  properties: {
    event_type: {
      type: 'string',
    },
    date: {
      type: 'string',
    },
    time: {
      type: 'string',
    },
    location: {
      type: 'string',
    },
    participants: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    service_provider: {
      type: 'string',
    },
  },
  required: ['event_type', 'date', 'time', 'location', 'participants', 'service_provider'],
} as const;

export const $NoticeExtractorAttachmentResponseDto = {
  type: 'object',
  properties: {
    identifier: {
      type: 'string',
    },
    content_summary: {
      type: 'string',
    },
  },
  required: ['identifier', 'content_summary'],
} as const;

export const $NoticeExtractorLegalDataResponseDto = {
  type: 'object',
  properties: {
    case_information: {
      $ref: '#/components/schemas/NoticeExtractorCaseInformationResponseDto',
    },
    parties: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorPartyResponseDto',
      },
    },
    law_firms: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorLawFirmResponseDto',
      },
    },
    document_details: {
      $ref: '#/components/schemas/NoticeExtractorDocumentDetailsResponseDto',
    },
    scheduled_events: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorScheduledEventResponseDto',
      },
    },
    attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorAttachmentResponseDto',
      },
    },
  },
  required: ['case_information', 'parties', 'law_firms', 'document_details', 'scheduled_events', 'attachments'],
} as const;

export const $NoticeExtractorKeytermResponseDto = {
  type: 'object',
  properties: {
    term: {
      type: 'string',
    },
    rank: {
      type: 'number',
    },
    importanceScore: {
      type: 'number',
    },
    category: {
      type: 'string',
    },
    reason: {
      type: 'string',
    },
    source: {
      type: 'string',
    },
  },
  required: ['term', 'rank', 'importanceScore', 'category', 'reason', 'source'],
} as const;

export const $NoticeExtractorKeytermsResponseDto = {
  type: 'object',
  properties: {
    filename: {
      type: 'string',
    },
    generatedFor: {
      type: 'string',
      enum: ['assemblyai_keyterms_prompt'],
    },
    maxRecommendedTerms: {
      type: 'number',
    },
    keytermsPrompt: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    terms: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/NoticeExtractorKeytermResponseDto',
      },
    },
  },
  required: ['filename', 'generatedFor', 'maxRecommendedTerms', 'keytermsPrompt', 'terms'],
} as const;

export const $NoticeExtractorProcessResponseDto = {
  type: 'object',
  properties: {
    filename: {
      type: 'string',
    },
    extractionSummary: {
      $ref: '#/components/schemas/NoticeExtractorExtractionSummaryResponseDto',
    },
    legalData: {
      $ref: '#/components/schemas/NoticeExtractorLegalDataResponseDto',
    },
    fieldSources: {
      type: 'object',
      additionalProperties: {
        type: 'array',
        items: {
          $ref: '#/components/schemas/NoticeExtractorFieldSourceResponseDto',
        },
      },
    },
    keyterms: {
      $ref: '#/components/schemas/NoticeExtractorKeytermsResponseDto',
    },
  },
  required: ['filename', 'extractionSummary', 'legalData'],
} as const;

export const $NoticeExtractorWorkflowStatusResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    state: {
      type: 'string',
    },
    failedReason: {
      type: 'string',
    },
    result: {
      $ref: '#/components/schemas/NoticeExtractorProcessResponseDto',
    },
  },
  required: ['jobId', 'state'],
} as const;

export const $ResultResponseDto = {
  type: 'object',
  properties: {
    result: {
      type: 'boolean',
      description: 'Result value',
    },
  },
  required: ['result'],
} as const;

export const $JobLicenseUsageHistoryLicenseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
  },
  required: ['id', 'transcriptUnlockType', 'asOneBackupRecordingAllowed'],
} as const;

export const $JobLicenseUsageHistoryUserDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'email', 'name', 'lastname'],
} as const;

export const $JobLicenseUsageHistoryAssigneeDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    User: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobLicenseUsageHistoryUserDto',
        },
      ],
    },
  },
  required: ['id'],
} as const;

export const $JobLicenseUsageHistorySubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType'],
} as const;

export const $JobLicenseUsageHistorySubscriptionProductDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'description'],
} as const;

export const $JobLicenseUsageHistoryResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    jobId: {
      type: 'string',
    },
    licenseId: {
      type: 'string',
      nullable: true,
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    actorId: {
      type: 'string',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
    subscriptionId: {
      type: 'string',
      nullable: true,
    },
    subscriptionProductId: {
      type: 'string',
      nullable: true,
    },
    subscriptionStatus: {
      nullable: true,
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    eventType: {
      enum: ['SUBMIT', 'RESUBMIT'],
      type: 'string',
    },
    License: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobLicenseUsageHistoryLicenseDto',
        },
      ],
    },
    Assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobLicenseUsageHistoryAssigneeDto',
        },
      ],
    },
    Actor: {
      $ref: '#/components/schemas/JobLicenseUsageHistoryUserDto',
    },
    Subscription: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobLicenseUsageHistorySubscriptionDto',
        },
      ],
    },
    SubscriptionProduct: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobLicenseUsageHistorySubscriptionProductDto',
        },
      ],
    },
  },
  required: [
    'id',
    'createdAt',
    'jobId',
    'actorId',
    'transcriptUnlockType',
    'asOneBackupRecordingAllowed',
    'allowedToChooseTranscriptUnlockType',
    'eventType',
    'Actor',
  ],
} as const;

export const $CommonBullJobResponseDto = {
  type: 'object',
  properties: {
    progress: {
      oneOf: [
        {
          type: 'boolean',
        },
        {
          type: 'string',
        },
        {
          type: 'number',
        },
        {
          type: 'object',
        },
      ],
    },
    returnvalue: {
      type: 'object',
      description: 'Job return value; shape depends on job type',
    },
    failedReason: {
      type: 'string',
    },
  },
  required: ['progress', 'returnvalue', 'failedReason'],
} as const;

export const $AdminUpdateJobStatusResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $UpdateJobTranscriptUnlockTypeBodyDto = {
  type: 'object',
  properties: {
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT'],
      type: 'string',
    },
  },
  required: ['transcriptUnlockType'],
} as const;

export const $MoveJobBodyDto = {
  type: 'object',
  properties: {
    workspaceId: {
      type: 'string',
    },
  },
  required: ['workspaceId'],
} as const;

export const $RegenerateSpeakerLabelOverrideDto = {
  type: 'object',
  properties: {
    from: {
      type: 'string',
    },
    to: {
      type: 'string',
    },
  },
  required: ['from', 'to'],
} as const;

export const $RegenerateWithNewLayoutBodyDto = {
  type: 'object',
  properties: {
    layoutId: {
      type: 'string',
    },
    speakerLabelOverrides: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RegenerateSpeakerLabelOverrideDto',
      },
    },
  },
  required: ['layoutId'],
} as const;

export const $ResubmitByAdminQueryDto = {
  type: 'object',
  properties: {
    chosenTranscriptionModel: {
      type: 'string',
      description: 'Override ASR proxy transcription model',
    },
    forceRetranscribe: {
      type: 'boolean',
      description: 'Force retranscription',
    },
    priority: {
      type: 'string',
      description: 'Job priority',
    },
    clearStylefixCache: {
      type: 'boolean',
      description: 'Clear stylefix chunk cache before resubmitting',
    },
    rushedJob: {
      type: 'boolean',
      description: 'Mark job as rushed to process it in a higher priority queue',
    },
    noShow: {
      type: 'object',
      default: false,
      description: 'Mark job as No Show to process it through the No Show route instead of the transcription pipeline',
    },
    forcePreprocessing: {
      type: 'boolean',
      description: 'Force recreating preprocessing audio output',
    },
    useAssemblyTwoStageClustering: {
      type: 'boolean',
      description: 'Override Assembly option to use two stage clustering',
    },
    speakersExpected: {
      type: 'number',
      minimum: 1,
      maximum: 10,
      description: 'Exact Assembly speaker count. Cannot be combined with the speaker range or two-stage clustering.',
    },
    minSpeakersExpected: {
      type: 'number',
      minimum: 1,
      maximum: 10,
      description: 'Minimum Assembly speaker count. Must be provided together with the maximum speaker count.',
    },
    maxSpeakersExpected: {
      type: 'number',
      minimum: 1,
      maximum: 10,
      description: 'Maximum Assembly speaker count. Must be provided together with the minimum speaker count.',
    },
    llmTranscriptSelectionMode: {
      enum: ['auto', 'force_asone', 'force_assembly'],
      type: 'string',
      description: 'LLM enhancement transcript selection mode (auto | force_asone | force_assembly)',
    },
  },
} as const;

export const $AdminCloneJobBodyDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'Source job id to clone from the specified environment',
    },
    sourceEnvironment: {
      enum: ['production', 'staging', 'demo', 'development'],
      type: 'string',
      description: 'Environment the source job resides in',
    },
    targetWorkspaceId: {
      type: 'string',
      description: 'Target workspace id in the current environment',
    },
    targetUserEmail: {
      type: 'string',
      description: 'Target user id (creator) in the current environment',
    },
    jobStatus: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
    recordingSessionType: {
      enum: ['RECORDING_SESSION_REMOTE', 'RECORDING_SESSION_HYBRID', 'RECORDING_SESSION_IN_PERSON'],
      type: 'string',
    },
    jobName: {
      type: 'string',
      description: 'Optional explicit job name',
    },
    rawASRResponse: {
      type: 'string',
      description: 'Optional raw ASR response payload for analysis',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT'],
      type: 'string',
      description: 'Transcript Unlock Type',
    },
    processedAudioFileName: {
      enum: ['output.mp3', 'output.wav', 'output.flac'],
      type: 'string',
      description: 'Processed audio file name',
    },
    resubmitAfterCloning: {
      type: 'boolean',
      description: 'Resubmit after cloning',
    },
    reportingType: {
      enum: ['UNKNOWN', 'REGULAR', 'FTR', 'MIXDOWN', 'CONCATENATE'],
      type: 'string',
      description: 'Reporting type',
    },
    multipleFilesHandling: {
      enum: ['concat', 'mixdown'],
      type: 'string',
      description: 'Multiple files handling method',
    },
    preprocessedAudioChannelCount: {
      type: 'number',
      nullable: true,
      description: 'Preprocessed audio channel count',
    },
    useSourceJobData: {
      type: 'boolean',
    },
    resubmitOptions: {
      description: 'Resubmit options',
      allOf: [
        {
          $ref: '#/components/schemas/ResubmitByAdminQueryDto',
        },
      ],
    },
  },
  required: ['jobId', 'sourceEnvironment', 'targetWorkspaceId', 'targetUserEmail'],
} as const;

export const $AdminCloneJobEnqueueResponseDto = {
  type: 'object',
  properties: {
    queueJobId: {
      type: 'string',
      description: 'Bull queue job id to use for polling status',
    },
  },
  required: ['queueJobId'],
} as const;

export const $AdminBulkCloneJobItemDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'Source job id to clone from the specified environment',
    },
    jobName: {
      type: 'string',
      description: 'Optional explicit job name for this cloned job',
    },
    rawASRResponse: {
      type: 'string',
      description: 'Optional raw ASR response payload for analysis',
    },
    issueSummary: {
      type: 'string',
      description: 'Known issue summary from regression diagnosis output',
    },
    issueDescription: {
      type: 'string',
      description: 'Known issue description from regression diagnosis output',
    },
  },
  required: ['jobId'],
} as const;

export const $AdminBulkCloneJobBodyDto = {
  type: 'object',
  properties: {
    jobIds: {
      description: 'Source job ids to clone. Use either jobIds or jobs.',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    jobs: {
      description: 'Source jobs with optional regression issue metadata. Use either jobs or jobIds.',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminBulkCloneJobItemDto',
      },
    },
    sourceEnvironment: {
      enum: ['production', 'staging', 'demo', 'development'],
      type: 'string',
      description: 'Environment the source jobs reside in',
    },
    targetWorkspaceId: {
      type: 'string',
      description: 'Target workspace id in the current environment',
    },
    targetUserEmail: {
      type: 'string',
      description: 'Target user email (creator) in the current environment',
    },
    jobStatus: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
    recordingSessionType: {
      enum: ['RECORDING_SESSION_REMOTE', 'RECORDING_SESSION_HYBRID', 'RECORDING_SESSION_IN_PERSON'],
      type: 'string',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT'],
      type: 'string',
      description: 'Transcript Unlock Type',
    },
    processedAudioFileName: {
      enum: ['output.mp3', 'output.wav', 'output.flac'],
      type: 'string',
      description: 'Processed audio file name',
    },
    resubmitAfterCloning: {
      type: 'boolean',
      description: 'Resubmit after cloning. Defaults to true for regression QA bulk clones.',
    },
    reportingType: {
      enum: ['UNKNOWN', 'REGULAR', 'FTR', 'MIXDOWN', 'CONCATENATE'],
      type: 'string',
      description: 'Reporting type',
    },
    multipleFilesHandling: {
      enum: ['concat', 'mixdown'],
      type: 'string',
      description: 'Multiple files handling method',
    },
    preprocessedAudioChannelCount: {
      type: 'number',
      nullable: true,
      description: 'Preprocessed audio channel count',
    },
    useSourceJobData: {
      type: 'boolean',
      description: 'Use source job metadata from export-for-clone',
    },
    resubmitOptions: {
      description: 'Resubmit options applied to every cloned job',
      allOf: [
        {
          $ref: '#/components/schemas/ResubmitByAdminQueryDto',
        },
      ],
    },
    concurrency: {
      type: 'number',
      description: 'Number of source jobs cloned concurrently inside the bulk queue job',
    },
    enqueueDelayInMs: {
      type: 'number',
      description: 'Delay between clone starts inside each worker',
    },
  },
  required: ['sourceEnvironment', 'targetWorkspaceId', 'targetUserEmail'],
} as const;

export const $AdminCloneJobStatusResponseDto = {
  type: 'object',
  properties: {
    queueJobId: {
      type: 'string',
      description: 'Bull queue job id',
    },
    status: {
      enum: [
        'active',
        'completed',
        'delayed',
        'failed',
        'paused',
        'prioritized',
        'waiting',
        'waiting-children',
        'unknown',
        'not_found',
      ],
      type: 'string',
      description: 'Bull queue state',
      example: 'waiting',
    },
    success: {
      type: 'boolean',
      description: 'Whether the clone job completed successfully',
    },
    clonedJobId: {
      type: 'string',
      nullable: true,
      description: 'Cloned job id on success',
    },
    failedReason: {
      type: 'string',
      nullable: true,
      description: 'Failure reason when queue job failed',
    },
  },
  required: ['queueJobId', 'status', 'success'],
} as const;

export const $AdminBulkCloneJobResultResponseDto = {
  type: 'object',
  properties: {
    sourceJobId: {
      type: 'string',
      description: 'Source job id',
    },
    status: {
      enum: ['completed', 'failed'],
      type: 'string',
      description: 'Per-source clone status',
    },
    clonedJobId: {
      type: 'string',
      nullable: true,
      description: 'Cloned job id on success',
    },
    failedReason: {
      type: 'string',
      nullable: true,
      description: 'Failure reason when cloning failed',
    },
    issueSummary: {
      type: 'string',
      description: 'Known issue summary from regression diagnosis output',
    },
    issueDescription: {
      type: 'string',
      description: 'Known issue description from regression diagnosis output',
    },
  },
  required: ['sourceJobId', 'status'],
} as const;

export const $AdminBulkCloneJobStatusResponseDto = {
  type: 'object',
  properties: {
    queueJobId: {
      type: 'string',
      description: 'Bull queue job id',
    },
    status: {
      enum: [
        'active',
        'completed',
        'delayed',
        'failed',
        'paused',
        'prioritized',
        'waiting',
        'waiting-children',
        'unknown',
        'not_found',
      ],
      type: 'string',
      description: 'Bull queue state',
      example: 'waiting',
    },
    success: {
      type: 'boolean',
      description: 'Whether the bulk clone job completed and every source job cloned successfully',
    },
    results: {
      description: 'Per-source clone results',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminBulkCloneJobResultResponseDto',
      },
    },
    failedReason: {
      type: 'string',
      nullable: true,
      description: 'Failure reason for the bulk queue job',
    },
  },
  required: ['queueJobId', 'status', 'success', 'results'],
} as const;

export const $MediaExportDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    fileExtension: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    duration: {
      type: 'number',
      description: 'Media duration in seconds',
    },
  },
  required: ['fileName', 'fileExtension', 'fileSize'],
} as const;

export const $RecordingSessionExportDto = {
  type: 'object',
  properties: {
    sessionType: {
      enum: ['RECORDING_SESSION_REMOTE', 'RECORDING_SESSION_HYBRID', 'RECORDING_SESSION_IN_PERSON'],
      type: 'string',
    },
    status: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
  },
  required: ['sessionType', 'status'],
} as const;

export const $AdminCloneJobExportResponseDto = {
  type: 'object',
  properties: {
    status: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
    name: {
      type: 'string',
    },
    duration: {
      type: 'number',
      description: 'Audio duration in seconds',
    },
    rawASRResponse: {
      type: 'string',
      nullable: true,
    },
    processedAudioFilename: {
      type: 'string',
      nullable: true,
    },
    transcriptUnlockType: {
      nullable: true,
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    transcriptUnlockTypeSetExplicitly: {
      type: 'boolean',
      description: 'Whether the transcript unlock type was explicitly set on the source job',
    },
    preprocessedAudioChannelCount: {
      type: 'number',
      nullable: true,
    },
    multichannel: {
      type: 'boolean',
      description: 'Whether the job was processed as multichannel audio',
    },
    reportingType: {
      enum: ['SINGLEFILE', 'MIXDOWN', 'CONCATENATE', 'FTR', 'NONE'],
      type: 'string',
      description: 'Reporting type',
    },
    multipleFilesHandling: {
      type: 'string',
      nullable: true,
      description: 'Multiple files handling method',
      enum: ['concat', 'mixdown'],
    },
    Media: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MediaExportDto',
      },
    },
    RecordingSession: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/RecordingSessionExportDto',
        },
      ],
    },
  },
  required: [
    'status',
    'name',
    'duration',
    'rawASRResponse',
    'processedAudioFilename',
    'transcriptUnlockType',
    'transcriptUnlockTypeSetExplicitly',
    'multichannel',
    'reportingType',
    'Media',
    'RecordingSession',
  ],
} as const;

export const $UpdateJobNoShowBodyDto = {
  type: 'object',
  properties: {
    noShow: {
      type: 'boolean',
      description: 'Mark the job as a No Show or return it to regular processing',
    },
  },
  required: ['noShow'],
} as const;

export const $Object = {
  type: 'object',
  properties: {},
} as const;

export const $MarkJobReportedByAdminDto = {
  type: 'object',
  properties: {
    description: {
      type: 'string',
    },
    summary: {
      type: 'string',
    },
  },
  required: ['description', 'summary'],
} as const;

export const $QuarantineStatusResponseDto = {
  type: 'object',
  properties: {
    quarantined: {
      type: 'boolean',
    },
  },
  required: ['quarantined'],
} as const;

export const $GetJobLinkResponseDto = {
  type: 'object',
  properties: {
    baseUrl: {
      type: 'string',
    },
    path: {
      type: 'string',
    },
  },
  required: ['baseUrl', 'path'],
} as const;

export const $JobAttachmentType = {
  type: 'string',
  enum: ['REPORTER_NOTES', 'GENERAL', 'NOTICE'],
} as const;

export const $JobDtoAttachment = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    fileName: {
      type: 'string',
    },
    path: {
      type: 'string',
    },
    fileSize: {
      type: 'number',
    },
    extracted: {
      type: 'boolean',
    },
    attachmentType: {
      allOf: [
        {
          $ref: '#/components/schemas/JobAttachmentType',
        },
      ],
    },
  },
  required: ['id', 'fileName', 'path', 'extracted', 'attachmentType'],
} as const;

export const $JobDtoRepository = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    zipUrl: {
      type: 'string',
      nullable: true,
    },
  },
} as const;

export const $JobDtoUser = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'email', 'name', 'lastname'],
} as const;

export const $JobDtoAssigneeHistory = {
  type: 'object',
  properties: {
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    user: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    createdByUser: {
      $ref: '#/components/schemas/JobDtoUser',
    },
  },
  required: ['assigneeId', 'createdAt'],
} as const;

export const $JobDtoComment = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    comment: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    creator: {
      $ref: '#/components/schemas/JobDtoUser',
    },
  },
  required: ['id', 'comment', 'createdAt', 'creator'],
} as const;

export const $JobDtoVersionMetric = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    editsCount: {
      type: 'number',
    },
    pagesCount: {
      type: 'number',
    },
    startedEditingAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    finishedEditingAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'editsCount', 'pagesCount'],
} as const;

export const $JobDtoInitialVersion = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    predecessorId: {
      type: 'string',
      nullable: true,
    },
    metricsId: {
      type: 'string',
      nullable: true,
    },
    jobFilesCheckoutEventId: {
      type: 'string',
      nullable: true,
    },
    Metrics: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobDtoVersionMetric',
        },
      ],
    },
  },
  required: ['id', 'createdAt'],
} as const;

export const $JobDtoCheckoutEventPredecessor = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    user: {
      $ref: '#/components/schemas/JobDtoUser',
    },
  },
  required: ['id', 'createdAt', 'user'],
} as const;

export const $JobDtoCheckoutEvent = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    finalizedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    user: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    jobStatus: {
      type: 'string',
    },
    initialVersionId: {
      type: 'string',
      nullable: true,
    },
    initialVersion: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobDtoInitialVersion',
        },
      ],
    },
    finalVersion: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobDtoInitialVersion',
        },
      ],
    },
    finalVersionId: {
      type: 'string',
      nullable: true,
    },
    predecessor: {
      $ref: '#/components/schemas/JobDtoCheckoutEventPredecessor',
    },
  },
  required: ['id', 'createdAt', 'user', 'jobStatus'],
} as const;

export const $JobDtoVersion = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    user: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    metrics: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/JobDtoVersionMetric',
        },
      ],
    },
    predecessorId: {
      type: 'string',
      nullable: true,
    },
    metricsId: {
      type: 'string',
      nullable: true,
    },
    jobFilesCheckoutEventId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'createdAt', 'user'],
} as const;

export const $JobResponseAttorneyAccessDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    connected: {
      type: 'boolean',
    },
    recordingSessionId: {
      type: 'string',
    },
    disabledByAdmin: {
      type: 'boolean',
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    url: {
      type: 'string',
    },
  },
  required: ['id', 'email', 'connected', 'recordingSessionId', 'disabledByAdmin', 'createdAt'],
} as const;

export const $PrismaAttorneyPasscodeDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
      nullable: true,
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    recordingSessionId: {
      type: 'string',
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'recordingSessionId', 'createdAt'],
} as const;

export const $JobDtoWatcher = {
  type: 'object',
  properties: {
    userId: {
      type: 'string',
    },
    status: {
      type: 'boolean',
    },
    assignee: {
      type: 'boolean',
    },
    comments: {
      type: 'boolean',
    },
  },
  required: ['userId', 'status', 'assignee', 'comments'],
} as const;

export const $JobResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    creatorId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
    statusChangeDate: {
      type: 'string',
      format: 'date-time',
    },
    deadline: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    notes: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    reportedByAdmin: {
      type: 'boolean',
    },
    abandonedProcessing: {
      type: 'boolean',
    },
    multipleFilesHandling: {
      type: 'string',
      nullable: true,
    },
    reportingType: {
      type: 'string',
    },
    status: {
      type: 'string',
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
    },
    removed: {
      type: 'boolean',
    },
    deletedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    deletedByUserId: {
      type: 'string',
      nullable: true,
    },
    rushed: {
      type: 'boolean',
    },
    submitted: {
      type: 'boolean',
    },
    results: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    keyTerms: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAttachment',
      },
    },
    reporterNotes: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    sourceFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    backupFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    exhibitFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    filesCount: {
      type: 'number',
    },
    bucket: {
      type: 'string',
    },
    region: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    repository: {
      $ref: '#/components/schemas/JobDtoRepository',
    },
    editingProgress: {
      type: 'number',
    },
    transcriptConfidence: {
      type: 'number',
    },
    averageJobAudioScore: {
      type: 'number',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    assignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    draftAssigneeId: {
      type: 'string',
      nullable: true,
    },
    assigneeComment: {
      type: 'string',
      nullable: true,
    },
    draftAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    assigneeHistory: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    comments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoComment',
      },
    },
    workspaceId: {
      type: 'string',
    },
    workspaceSlug: {
      type: 'string',
    },
    workspaceName: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    scheduledDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    meetingTime: {
      type: 'string',
      nullable: true,
    },
    meetingTimezone: {
      type: 'string',
      nullable: true,
    },
    meetingAddress: {
      type: 'string',
      nullable: true,
    },
    meetingLink: {
      type: 'string',
      nullable: true,
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    meetingAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    checkoutEvents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoCheckoutEvent',
      },
    },
    versions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoVersion',
      },
    },
    asOneLocked: {
      type: 'boolean',
    },
    processedAudioFilename: {
      type: 'string',
    },
    playbackAudioFilename: {
      type: 'string',
    },
    layoutId: {
      type: 'string',
      nullable: true,
    },
    layoutName: {
      type: 'string',
    },
    partialUnlocked: {
      type: 'boolean',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    speakerLabels: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    enhancedCharged: {
      type: 'boolean',
    },
    attorneyAccesses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobResponseAttorneyAccessDto',
      },
    },
    attorneyPasscodes: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaAttorneyPasscodeDto',
      },
    },
    watchers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoWatcher',
      },
    },
    noShow: {
      type: 'boolean',
    },
    pipelineErrorMessage: {
      type: 'string',
    },
    clonedFromJobId: {
      type: 'string',
      nullable: true,
    },
    clonedFromEnvironment: {
      type: 'string',
      nullable: true,
    },
  },
  required: [
    'id',
    'notes',
    'name',
    'reportedByAdmin',
    'abandonedProcessing',
    'status',
    'results',
    'attachments',
    'filesCount',
    'workspaceId',
    'noShow',
  ],
} as const;

export const $PaginatedJobResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobResponseDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $BulkUpdateJobItemDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    layoutId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'name'],
} as const;

export const $BulkUpdateJobsBodyDto = {
  type: 'object',
  properties: {
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/BulkUpdateJobItemDto',
      },
    },
  },
  required: ['jobs'],
} as const;

export const $BulkUpdateJobsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $BulkCreateRepositoryJobsBodyDto = {
  type: 'object',
  properties: {
    workspaceId: {
      type: 'string',
    },
  },
  required: ['workspaceId'],
} as const;

export const $PrismaMediaDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    fileExtension: {
      type: 'string',
    },
    weight: {
      type: 'number',
      nullable: true,
    },
    channels: {
      type: 'number',
      nullable: true,
    },
    jobId: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    silenceDuration: {
      type: 'number',
    },
    analysisStatus: {
      nullable: true,
      enum: ['PENDING', 'CORE_READY', 'COMPLETE', 'FAILED'],
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'fileName', 'fileSize', 'fileExtension', 'jobId', 'duration', 'silenceDuration', 'createdAt'],
} as const;

export const $BulkCreateJobFromRepositoryResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    creatorId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
    statusChangeDate: {
      type: 'string',
      format: 'date-time',
    },
    deadline: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    notes: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    reportedByAdmin: {
      type: 'boolean',
    },
    abandonedProcessing: {
      type: 'boolean',
    },
    multipleFilesHandling: {
      type: 'string',
      nullable: true,
    },
    reportingType: {
      type: 'string',
    },
    status: {
      type: 'string',
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
    },
    removed: {
      type: 'boolean',
    },
    deletedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    deletedByUserId: {
      type: 'string',
      nullable: true,
    },
    rushed: {
      type: 'boolean',
    },
    submitted: {
      type: 'boolean',
    },
    results: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    keyTerms: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAttachment',
      },
    },
    reporterNotes: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    sourceFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    backupFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    exhibitFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    filesCount: {
      type: 'number',
    },
    bucket: {
      type: 'string',
    },
    region: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    repository: {
      $ref: '#/components/schemas/JobDtoRepository',
    },
    editingProgress: {
      type: 'number',
    },
    transcriptConfidence: {
      type: 'number',
    },
    averageJobAudioScore: {
      type: 'number',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    assignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    draftAssigneeId: {
      type: 'string',
      nullable: true,
    },
    assigneeComment: {
      type: 'string',
      nullable: true,
    },
    draftAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    assigneeHistory: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    comments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoComment',
      },
    },
    workspaceId: {
      type: 'string',
    },
    workspaceSlug: {
      type: 'string',
    },
    workspaceName: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    scheduledDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    meetingTime: {
      type: 'string',
      nullable: true,
    },
    meetingTimezone: {
      type: 'string',
      nullable: true,
    },
    meetingAddress: {
      type: 'string',
      nullable: true,
    },
    meetingLink: {
      type: 'string',
      nullable: true,
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    meetingAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    checkoutEvents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoCheckoutEvent',
      },
    },
    versions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoVersion',
      },
    },
    asOneLocked: {
      type: 'boolean',
    },
    processedAudioFilename: {
      type: 'string',
    },
    playbackAudioFilename: {
      type: 'string',
    },
    layoutId: {
      type: 'string',
      nullable: true,
    },
    layoutName: {
      type: 'string',
    },
    partialUnlocked: {
      type: 'boolean',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    speakerLabels: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    enhancedCharged: {
      type: 'boolean',
    },
    attorneyAccesses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobResponseAttorneyAccessDto',
      },
    },
    attorneyPasscodes: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaAttorneyPasscodeDto',
      },
    },
    watchers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoWatcher',
      },
    },
    noShow: {
      type: 'boolean',
    },
    pipelineErrorMessage: {
      type: 'string',
    },
    clonedFromJobId: {
      type: 'string',
      nullable: true,
    },
    clonedFromEnvironment: {
      type: 'string',
      nullable: true,
    },
    createdMedia: {
      $ref: '#/components/schemas/PrismaMediaDto',
    },
  },
  required: [
    'id',
    'notes',
    'name',
    'reportedByAdmin',
    'abandonedProcessing',
    'status',
    'results',
    'attachments',
    'filesCount',
    'workspaceId',
    'noShow',
    'createdMedia',
  ],
} as const;

export const $JobStatusHistoryItemDto = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
      format: 'date-time',
    },
    status: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['date'],
} as const;

export const $GetJobStatusHistoryResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobStatusHistoryItemDto',
      },
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $GetJobAssigneeHistoryResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $GetJobLockedStatusResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $JobPartialUnlockedSourceAudioDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    downloadUrl: {
      type: 'string',
    },
    fileSize: {
      type: 'number',
    },
  },
  required: ['fileName', 'downloadUrl'],
} as const;

export const $JobPartialUnlockedFilesResponseDto = {
  type: 'object',
  properties: {
    downloadOutputUrl: {
      type: 'string',
    },
    downloadSummaryUrl: {
      type: 'string',
    },
    downloadOutputFileSize: {
      type: 'number',
    },
    downloadSummaryFileSize: {
      type: 'number',
    },
    downloadReporterNotesRtf: {
      type: 'string',
    },
    downloadReporterNotesTxt: {
      type: 'string',
    },
    downloadReporterNotesTxtFileSize: {
      type: 'number',
    },
    downloadReporterNotesRtfFileSize: {
      type: 'number',
    },
    sourceAudioFiles: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobPartialUnlockedSourceAudioDto',
      },
    },
    error: {
      type: 'boolean',
    },
  },
  required: ['downloadOutputUrl', 'downloadSummaryUrl', 'downloadReporterNotesRtf', 'downloadReporterNotesTxt'],
} as const;

export const $MoveJobsBodyDto = {
  type: 'object',
  properties: {
    jobIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    workspaceId: {
      type: 'string',
    },
  },
  required: ['jobIds', 'workspaceId'],
} as const;

export const $JobUpdateResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
  },
  required: ['id', 'workspaceId'],
} as const;

export const $UpdateEditingProgressBodyDto = {
  type: 'object',
  properties: {
    progress: {
      type: 'number',
    },
  },
  required: ['progress'],
} as const;

export const $CreateJobBodyDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    deadline: {
      type: 'string',
    },
    notes: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    multipleFilesHandling: {
      type: 'string',
    },
    reportingType: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
    },
    draftAssigneeId: {
      type: 'string',
    },
    assigneeComment: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    keyTerms: {
      type: 'array',
      items: {
        type: 'string',
      },
      maxItems: 1000,
      description: 'AssemblyAI keyterms. English characters only. Up to 1000 total words, max 6 words per phrase.',
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
    },
    meetingTime: {
      type: 'string',
    },
    meetingTimezone: {
      type: 'string',
    },
    meetingAddress: {
      type: 'string',
    },
    meetingLink: {
      type: 'string',
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    rushed: {
      type: 'boolean',
    },
    layoutId: {
      type: 'string',
    },
  },
  required: ['id', 'notes', 'name', 'status'],
} as const;

export const $EditJobBodyDto = {
  type: 'object',
  properties: {
    deadline: {
      type: 'string',
    },
    notes: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    multipleFilesHandling: {
      type: 'string',
    },
    reportingType: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
    },
    draftAssigneeId: {
      type: 'string',
    },
    assigneeComment: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    keyTerms: {
      type: 'array',
      items: {
        type: 'string',
      },
      maxItems: 1000,
      description: 'AssemblyAI keyterms. English characters only. Up to 1000 total words, max 6 words per phrase.',
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
    },
    meetingTime: {
      type: 'string',
    },
    meetingTimezone: {
      type: 'string',
    },
    meetingAddress: {
      type: 'string',
    },
    meetingLink: {
      type: 'string',
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    rushed: {
      type: 'boolean',
    },
    layoutId: {
      type: 'string',
    },
  },
} as const;

export const $AttorneyAccessResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    recordingSessionId: {
      type: 'string',
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    url: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'email', 'recordingSessionId', 'url', 'createdAt'],
} as const;

export const $SoftDeleteWSJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $DeleteJobsBodyDto = {
  type: 'object',
  properties: {
    jobIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['jobIds'],
} as const;

export const $SoftDeleteJobsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $CommentJobBodyDto = {
  type: 'object',
  properties: {
    comment: {
      type: 'string',
    },
  },
  required: ['comment'],
} as const;

export const $CommentJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $ClaimJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $ReassignJobBodyDto = {
  type: 'object',
  properties: {
    status: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    assigneeComment: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['status'],
} as const;

export const $ReassignJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $EditCaseBodyDto = {
  type: 'object',
  properties: {
    repositoryId: {
      type: 'string',
    },
  },
  required: ['repositoryId'],
} as const;

export const $UpdateJobNotesBodyDto = {
  type: 'object',
  properties: {
    notes: {
      type: 'string',
    },
  },
  required: ['notes'],
} as const;

export const $EditJobNotesResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $EditTagsBodyDto = {
  type: 'object',
  properties: {
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['tags'],
} as const;

export const $EditJobTagsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $UpdateDeadlineBodyDto = {
  type: 'object',
  properties: {
    deadline: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['deadline'],
} as const;

export const $UpdateDeadlineResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $UpdateJobTitleBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
  },
  required: ['name'],
} as const;

export const $UpdateJobLayoutBodyDto = {
  type: 'object',
  properties: {
    layoutId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['layoutId'],
} as const;

export const $UpdateJobLayoutResponseDto = {
  type: 'object',
  properties: {
    layoutId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['layoutId'],
} as const;

export const $DeleteJobTagBodyDto = {
  type: 'object',
  properties: {
    tag: {
      type: 'string',
    },
  },
  required: ['tag'],
} as const;

export const $JobWorkspacePermissionsResponseDto = {
  type: 'object',
  properties: {
    viewJobs: {
      enum: ['none', 'all', 'assigned', 'assignedAndUnassigned'],
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    belongsToTheWorkspace: {
      type: 'boolean',
    },
  },
} as const;

export const $JobAttachmentUploadLinkResponseDto = {
  type: 'object',
  properties: {
    url: {
      type: 'string',
      description: 'Pre-signed S3 upload URL',
    },
    fields: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
      description: 'Form fields to include in the multipart upload request',
    },
  },
  required: ['url', 'fields'],
} as const;

export const $JobAttachmentResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    filename: {
      type: 'string',
    },
    attachmentType: {
      enum: ['REPORTER_NOTES', 'GENERAL', 'NOTICE'],
      type: 'string',
    },
    fileSize: {
      type: 'number',
    },
    extracted: {
      type: 'boolean',
    },
    jobId: {
      type: 'string',
      format: 'uuid',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'filename', 'attachmentType', 'extracted', 'jobId', 'createdAt'],
} as const;

export const $PipelineProgressDto = {
  type: 'object',
  properties: {
    percentage: {
      type: 'number',
      description: 'Progress percentage (0-100)',
    },
    currentStage: {
      type: 'string',
      nullable: true,
      description: 'Currently executing stage',
    },
    completedStages: {
      description: 'List of completed stages',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    remainingStages: {
      description: 'List of remaining stages',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    estimatedTimeRemainingMs: {
      type: 'number',
      nullable: true,
      description: 'Estimated time remaining in milliseconds',
    },
  },
  required: ['percentage', 'completedStages', 'remainingStages'],
} as const;

export const $PipelineEventDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    service: {
      type: 'string',
    },
    stage: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    startedAt: {
      type: 'string',
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    metadata: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    errorDetails: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
  },
  required: ['id', 'service', 'stage', 'status', 'startedAt'],
} as const;

export const $AttemptSummaryDto = {
  type: 'object',
  properties: {
    attemptId: {
      type: 'string',
    },
    startedAt: {
      type: 'string',
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    status: {
      type: 'string',
    },
    autoRetried: {
      type: 'boolean',
    },
    eventCount: {
      type: 'number',
    },
    duration: {
      type: 'number',
    },
  },
  required: ['attemptId', 'startedAt', 'status', 'autoRetried', 'eventCount'],
} as const;

export const $PipelineEtaEstimateDto = {
  type: 'object',
  properties: {
    percentage: {
      type: 'number',
      description: 'History-based progress percentage (0-100)',
    },
    estimatedTimeRemainingMs: {
      type: 'number',
      description: 'Median estimated time remaining in milliseconds',
    },
    estimatedTimeRemainingP90Ms: {
      type: 'number',
      description: 'P90 (pessimistic) estimated time remaining in milliseconds',
    },
    estimatedTotalMs: {
      type: 'number',
      description: 'Median total attempt duration for comparable jobs in milliseconds',
    },
    elapsedInStageMs: {
      type: 'number',
      description: 'Time already spent in the current stage in milliseconds',
    },
    runningLong: {
      type: 'boolean',
      description: 'True when the current stage has exceeded its P90 historical duration',
    },
    audioBucket: {
      type: 'string',
      description: 'Audio-duration cohort the estimate was drawn from',
    },
    sampleSize: {
      type: 'number',
      description: 'Number of historical attempts behind the estimate',
    },
    windowDays: {
      type: 'number',
      description: 'Rolling window size in days',
    },
  },
  required: [
    'percentage',
    'estimatedTimeRemainingMs',
    'estimatedTimeRemainingP90Ms',
    'estimatedTotalMs',
    'elapsedInStageMs',
    'runningLong',
    'audioBucket',
    'sampleSize',
    'windowDays',
  ],
} as const;

export const $TemporalPendingActivityDto = {
  type: 'object',
  properties: {
    activityType: {
      type: 'string',
      nullable: true,
    },
    state: {
      type: 'string',
      nullable: true,
      description: 'SCHEDULED, STARTED or CANCEL_REQUESTED',
    },
    attempt: {
      type: 'number',
      nullable: true,
    },
    maximumAttempts: {
      type: 'number',
      nullable: true,
    },
    lastHeartbeatAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastFailureMessage: {
      type: 'string',
      nullable: true,
    },
  },
} as const;

export const $TemporalWorkflowStatusDto = {
  type: 'object',
  properties: {
    workflowId: {
      type: 'string',
    },
    runId: {
      type: 'string',
    },
    type: {
      type: 'string',
      description: 'Workflow type, e.g. preprocessingWorkflow',
    },
    taskQueue: {
      type: 'string',
    },
    status: {
      type: 'string',
      description: 'RUNNING, COMPLETED, FAILED, CANCELLED, TERMINATED, TIMED_OUT…',
    },
    startedAt: {
      type: 'string',
      format: 'date-time',
    },
    closedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    pendingActivities: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TemporalPendingActivityDto',
      },
    },
  },
  required: ['workflowId', 'runId', 'type', 'taskQueue', 'status', 'startedAt', 'pendingActivities'],
} as const;

export const $JobPipelineStatusResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    currentAttemptId: {
      type: 'string',
      nullable: true,
    },
    currentState: {
      type: 'string',
      nullable: true,
    },
    currentStage: {
      type: 'string',
      nullable: true,
    },
    progress: {
      $ref: '#/components/schemas/PipelineProgressDto',
    },
    timeline: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineEventDto',
      },
    },
    canRetry: {
      type: 'boolean',
    },
    previousAttempts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AttemptSummaryDto',
      },
    },
    eta: {
      nullable: true,
      description: 'History-based ETA; null when there is no current attempt or not enough recent history',
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PipelineEtaEstimateDto',
        },
      ],
    },
    temporal: {
      nullable: true,
      description:
        'Temporal workflows for this job; null when the HTTP pipeline is disabled or Temporal is unreachable',
      type: 'array',
      items: {
        $ref: '#/components/schemas/TemporalWorkflowStatusDto',
      },
    },
  },
  required: ['jobId', 'progress', 'timeline', 'canRetry', 'previousAttempts'],
} as const;

export const $EventTimelineItemDto = {
  type: 'object',
  properties: {
    timestamp: {
      type: 'string',
      format: 'date-time',
    },
    service: {
      type: 'string',
    },
    stage: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    metadata: {
      type: 'object',
      additionalProperties: true,
    },
  },
  required: ['timestamp', 'service', 'stage', 'status'],
} as const;

export const $PerformanceMetricsDto = {
  type: 'object',
  properties: {
    totalDuration: {
      type: 'number',
    },
    averageEventDuration: {
      type: 'number',
    },
    slowestEvent: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/EventTimelineItemDto',
        },
      ],
    },
    fastestEvent: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/EventTimelineItemDto',
        },
      ],
    },
    errorRate: {
      type: 'number',
    },
  },
  required: ['totalDuration', 'averageEventDuration', 'errorRate'],
} as const;

export const $AttemptDetailsResponseDto = {
  type: 'object',
  properties: {
    attemptId: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    startedAt: {
      type: 'string',
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    status: {
      type: 'string',
    },
    autoRetried: {
      type: 'boolean',
    },
    xstateSnapshot: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    detailedLogsS3Key: {
      type: 'string',
      nullable: true,
    },
    events: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineEventDto',
      },
    },
    timeline: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EventTimelineItemDto',
      },
    },
    errors: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineEventDto',
      },
    },
    performance: {
      $ref: '#/components/schemas/PerformanceMetricsDto',
    },
  },
  required: ['attemptId', 'jobId', 'startedAt', 'status', 'autoRetried', 'events', 'timeline', 'errors', 'performance'],
} as const;

export const $AttemptLogsResponseDto = {
  type: 'object',
  properties: {
    logs: {
      type: 'string',
    },
  },
  required: ['logs'],
} as const;

export const $JobSummaryDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
    currentAttemptId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'name', 'status', 'createdAt', 'updatedAt'],
} as const;

export const $StatusBreakdownDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
    },
    _count: {
      type: 'object',
      properties: {
        attemptId: {
          type: 'number',
        },
      },
      required: ['attemptId'],
    },
  },
  required: ['status', '_count'],
} as const;

export const $PipelineStatisticsResponseDto = {
  type: 'object',
  properties: {
    totalAttempts: {
      type: 'number',
    },
    statusBreakdown: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/StatusBreakdownDto',
      },
    },
    timeRange: {
      type: 'object',
      properties: {
        from: {
          type: 'string',
          format: 'date-time',
        },
        to: {
          type: 'string',
          format: 'date-time',
        },
      },
    },
  },
  required: ['totalAttempts', 'statusBreakdown', 'timeRange'],
} as const;

export const $CreateMediaBodyDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    weight: {
      type: 'number',
    },
  },
  required: ['jobId', 'fileName', 'fileSize', 'weight'],
} as const;

export const $FileDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    weight: {
      type: 'number',
    },
  },
  required: ['fileName', 'fileSize', 'weight'],
} as const;

export const $CopyRepositoryAttachmentsAsMediaBodyDto = {
  type: 'object',
  properties: {
    files: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/FileDto',
      },
    },
    jobId: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
  },
  required: ['files', 'jobId', 'workspaceId', 'repositoryId'],
} as const;

export const $UpdateMediaWeightBodyDto = {
  type: 'object',
  properties: {
    weight: {
      type: 'number',
      description: 'Media weight/order',
    },
  },
  required: ['weight'],
} as const;

export const $DeleteMediaResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'True if media was deleted successfully',
    },
  },
  required: ['success'],
} as const;

export const $SignedUrlResponseDto = {
  type: 'object',
  properties: {
    signedUrl: {
      type: 'string',
      description: 'The signed url for the media',
    },
  },
  required: ['signedUrl'],
} as const;

export const $FileDetails = {
  type: 'object',
  properties: {},
} as const;

export const $GetFilesListResponseDto = {
  type: 'object',
  properties: {
    media: {
      description: 'List of media files',
      type: 'array',
      items: {
        $ref: '#/components/schemas/FileDetails',
      },
    },
  },
  required: ['media'],
} as const;

export const $DesktopDownloadLinksResponseDto = {
  type: 'object',
  properties: {
    jobName: {
      type: 'string',
      description: 'Job name',
    },
    audio: {
      type: 'string',
      description: 'Signed URL for audio download',
    },
    transcript: {
      type: 'string',
      description: 'Signed URL for transcript download',
    },
  },
  required: ['jobName', 'audio', 'transcript'],
} as const;

export const $CreateSubscriptionBodyDto = {
  type: 'object',
  properties: {
    subscriptionProductId: {
      type: 'string',
    },
    licenseCount: {
      type: 'number',
    },
  },
  required: ['subscriptionProductId', 'licenseCount'],
} as const;

export const $CreateSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
    id: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $UpgradeSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $RetrySubscriptionPaymentResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    outcome: {
      enum: ['paid', 'processing', 'requires_action', 'failed'],
      type: 'string',
    },
    error: {
      type: 'string',
    },
    paymentIntentClientSecret: {
      type: 'string',
    },
  },
  required: ['success', 'outcome'],
} as const;

export const $AdminCreateSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $AdminRetrySubscriptionPaymentResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    outcome: {
      enum: ['paid', 'processing', 'requires_action', 'failed'],
      type: 'string',
    },
    error: {
      type: 'string',
    },
    paymentIntentClientSecret: {
      type: 'string',
    },
  },
  required: ['success', 'outcome'],
} as const;

export const $PrismaSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType', 'billingAccountId', 'createdAt'],
} as const;

export const $PrismaUserDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    profile: {
      type: 'object',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    agreement: {
      type: 'boolean',
    },
    haveSeenOnboarding: {
      type: 'boolean',
    },
    org: {
      type: 'string',
    },
    asrUsage: {
      type: 'number',
    },
    createdByAdmin: {
      type: 'boolean',
    },
    downloadedDesktop: {
      type: 'boolean',
    },
    signedInWithDesktop: {
      type: 'boolean',
    },
    signupUrl: {
      type: 'string',
    },
    emailVerified: {
      type: 'boolean',
    },
    confirmed: {
      type: 'boolean',
    },
    disabled: {
      type: 'boolean',
    },
    elasticKey: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastActiveDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastIpAddress: {
      type: 'string',
      nullable: true,
    },
    hasClaimedFreeBalance: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'phone',
    'company',
    'accountType',
    'profile',
    'email',
    'roles',
    'agreement',
    'haveSeenOnboarding',
    'org',
    'asrUsage',
    'createdByAdmin',
    'downloadedDesktop',
    'signedInWithDesktop',
    'signupUrl',
    'emailVerified',
    'confirmed',
    'disabled',
    'elasticKey',
    'createdAt',
    'hasClaimedFreeBalance',
  ],
} as const;

export const $FindOneSubscriptionLicenseAssigneeResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    concurrentJobsLimit: {
      type: 'number',
      nullable: true,
    },
    canManageLayouts: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    User: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaUserDto',
        },
      ],
    },
  },
  required: ['id', 'disabled', 'canManageLayouts', 'organizationId', 'userId', 'createdAt', 'User'],
} as const;

export const $FindOneSubscriptionLicenseResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    subscriptionId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
    Assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/FindOneSubscriptionLicenseAssigneeResponseDto',
        },
      ],
    },
  },
  required: ['id', 'createdAt', 'subscriptionId', 'transcriptUnlockType', 'asOneBackupRecordingAllowed', 'Assignee'],
} as const;

export const $FindOneSubscriptionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/FindOneSubscriptionLicenseResponseDto',
      },
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType', 'billingAccountId', 'createdAt', 'Licenses'],
} as const;

export const $FindOneSubscriptionForAdminLicenseAssigneeResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    concurrentJobsLimit: {
      type: 'number',
      nullable: true,
    },
    canManageLayouts: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    User: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaUserDto',
        },
      ],
    },
  },
  required: ['id', 'disabled', 'canManageLayouts', 'organizationId', 'userId', 'createdAt', 'User'],
} as const;

export const $FindOneSubscriptionForAdminLicenseResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    subscriptionId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
    Assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/FindOneSubscriptionForAdminLicenseAssigneeResponseDto',
        },
      ],
    },
  },
  required: ['id', 'createdAt', 'subscriptionId', 'transcriptUnlockType', 'asOneBackupRecordingAllowed', 'Assignee'],
} as const;

export const $FindOneSubscriptionForAdminResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/FindOneSubscriptionForAdminLicenseResponseDto',
      },
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType', 'billingAccountId', 'createdAt', 'Licenses'],
} as const;

export const $UpdateSubscriptionBodyDto = {
  type: 'object',
  properties: {
    subscriptionProductId: {
      type: 'string',
    },
    licenseCount: {
      type: 'number',
    },
  },
} as const;

export const $UpdateSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $AdminUpdateSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $PrismaOrganizationRoleDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    colour: {
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewJobs: {
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'id',
    'default',
    'name',
    'slug',
    'colour',
    'owner',
    'viewRepositories',
    'editRepositories',
    'viewBilling',
    'manageBilling',
    'viewJobs',
    'editJobs',
    'reassignJobs',
    'deleteJobs',
    'submitJobs',
    'viewJobCost',
    'editJobTranscript',
    'proofreadJobTranscript',
    'finalizeJobTranscript',
    'markJobComplete',
    'viewReports',
    'manageMembers',
    'managePermissions',
    'manageWorkspaces',
    'manageOrganization',
    'viewLicenses',
    'manageLicenses',
    'organizationId',
    'createdAt',
  ],
} as const;

export const $GetOrgMembersMemberResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    profile: {
      type: 'object',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    agreement: {
      type: 'boolean',
    },
    haveSeenOnboarding: {
      type: 'boolean',
    },
    org: {
      type: 'string',
    },
    asrUsage: {
      type: 'number',
    },
    createdByAdmin: {
      type: 'boolean',
    },
    downloadedDesktop: {
      type: 'boolean',
    },
    signedInWithDesktop: {
      type: 'boolean',
    },
    signupUrl: {
      type: 'string',
    },
    emailVerified: {
      type: 'boolean',
    },
    confirmed: {
      type: 'boolean',
    },
    disabled: {
      type: 'boolean',
    },
    elasticKey: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastActiveDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastIpAddress: {
      type: 'string',
      nullable: true,
    },
    hasClaimedFreeBalance: {
      type: 'boolean',
    },
    canManageLayouts: {
      type: 'boolean',
      nullable: true,
    },
    concurrentJobsLimit: {
      type: 'number',
      nullable: true,
    },
    teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
    membershipId: {
      type: 'string',
    },
    disabledInOrg: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'phone',
    'company',
    'accountType',
    'profile',
    'email',
    'roles',
    'agreement',
    'haveSeenOnboarding',
    'org',
    'asrUsage',
    'createdByAdmin',
    'downloadedDesktop',
    'signedInWithDesktop',
    'signupUrl',
    'emailVerified',
    'confirmed',
    'disabled',
    'elasticKey',
    'createdAt',
    'hasClaimedFreeBalance',
    'teams',
    'membershipId',
    'disabledInOrg',
  ],
} as const;

export const $GetOrgMembersResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetOrgMembersMemberResponseDto',
      },
    },
    count: {
      type: 'number',
    },
  },
  required: ['data', 'count'],
} as const;

export const $AssignLicenseBodyDto = {
  type: 'object',
  properties: {
    subscriptionId: {
      type: 'string',
    },
    licenseId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['subscriptionId', 'licenseId', 'assigneeId'],
} as const;

export const $AssignLicenseResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $UpdateLicenseTranscriptUnlockTypeBodyDto = {
  type: 'object',
  properties: {
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
  },
  required: ['transcriptUnlockType'],
} as const;

export const $UpdateLicenseBackupRecordingFlagBodyDto = {
  type: 'object',
  properties: {
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
  },
  required: ['asOneBackupRecordingAllowed'],
} as const;

export const $PrismaLicenseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    subscriptionId: {
      type: 'string',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
  },
  required: ['id', 'createdAt', 'subscriptionId', 'transcriptUnlockType', 'asOneBackupRecordingAllowed'],
} as const;

export const $CancelSubscriptionResponseDto = {
  type: 'object',
  properties: {
    subscription: {
      $ref: '#/components/schemas/PrismaSubscriptionDto',
    },
    licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaLicenseDto',
      },
    },
  },
  required: ['subscription', 'licenses'],
} as const;

export const $CreateOrganizationBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['name', 'slug'],
} as const;

export const $SsoLoginHttpErrorResponseDto = {
  type: 'object',
  properties: {
    statusCode: {
      type: 'number',
      example: 403,
    },
    error: {
      enum: [
        'SSO_PROVISIONING_PENDING',
        'SSO_EMAIL_CLAIM_MISSING',
        'SSO_EMAIL_MISMATCH',
        'SSO_EMAIL_NOT_VERIFIED',
        'SSO_IDENTITY_ALREADY_LINKED',
        'SSO_AMBIGUOUS_EMAIL_MATCH',
        'SSO_NOT_PROVISIONED',
        'SSO_ONLY_AUTHENTICATION_REQUIRED',
        'SSO_ORG_CREATION_BLOCKED',
      ],
      type: 'string',
      example: 'SSO_ONLY_AUTHENTICATION_REQUIRED',
    },
    message: {
      type: 'string',
      example: 'This email is managed by your company single sign-on.',
    },
  },
  required: ['statusCode', 'error', 'message'],
} as const;

export const $PrismaOrganizationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    asOneAllowed: {
      type: 'boolean',
      nullable: true,
    },
    asOneBackupRecordingTermsAccepted: {
      type: 'boolean',
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    serviceUserId: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'asOneAllowed',
    'asOneBackupRecordingTermsAccepted',
    'managementSource',
    'createdAt',
  ],
} as const;

export const $AssignedLicenseResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    subscriptionId: {
      type: 'string',
    },
    transcriptUnlockType: {
      enum: [
        'GL1000',
        'GL1001',
        'GL2000',
        'GL2001',
        'GL2003',
        'GL2002',
        'GL2005',
        'GL2006',
        'GL2004',
        'GL2007',
        'GL2008',
        'GL2100',
        'GL4000',
        'GL4001',
        'GL4002',
        'GL4003',
        'GL5000',
        'GL5001',
        'GL5002',
        'GL5003',
        'GL6000',
        'GL6666',
        'GL6667',
        'GL6669',
        'GL6671',
        'GL6672',
        'GL6668',
        'GL6670',
        'GL6250',
        'GL6251',
        'GL6252',
        'GL7000',
        'GL7001',
        'GL8000',
        'GL8001',
        'GL9000',
      ],
      type: 'string',
    },
    subscriptionProductId: {
      type: 'string',
      nullable: true,
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    organizationName: {
      type: 'string',
    },
  },
  required: [
    'id',
    'userId',
    'subscriptionId',
    'transcriptUnlockType',
    'asOneBackupRecordingAllowed',
    'organizationId',
    'organizationName',
  ],
} as const;

export const $MeResponseDtoOrganizationWorkspace = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    editorsNotifications: {
      type: 'boolean',
      nullable: true,
    },
    proofreadersNotifications: {
      type: 'boolean',
      nullable: true,
    },
    jobSubmissionNotifications: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'editorsNotifications',
    'proofreadersNotifications',
    'jobSubmissionNotifications',
    'organizationId',
    'createdAt',
    'Teams',
  ],
} as const;

export const $PrismaBillingConfigurationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    realTimeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    realTimeRate: {
      type: 'number',
    },
    postProcessingRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    postProcessingRate: {
      type: 'number',
    },
    partialUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    partialUnlockRate: {
      type: 'number',
    },
    fullUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockRate: {
      type: 'number',
    },
    fullUnlockChargeType: {
      enum: ['PAY_DIFFERENCE', 'ADDITIONAL_CHARGE'],
      type: 'string',
    },
    enhancedOnDemandRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    enhancedOnDemandRate: {
      type: 'number',
    },
    attorneyConnectFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRate: {
      type: 'number',
    },
    attorneyInviteFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyInviteFeeRate: {
      type: 'number',
    },
    rushLabelFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    rushLabelFeeRate: {
      type: 'number',
    },
  },
  required: [
    'id',
    'realTimeRateType',
    'realTimeRate',
    'postProcessingRateType',
    'postProcessingRate',
    'partialUnlockRateType',
    'partialUnlockRate',
    'fullUnlockRateType',
    'fullUnlockRate',
    'fullUnlockChargeType',
    'enhancedOnDemandRateType',
    'enhancedOnDemandRate',
    'attorneyConnectFeeRateType',
    'attorneyConnectFeeRate',
    'attorneyInviteFeeRateType',
    'attorneyInviteFeeRate',
    'rushLabelFeeRateType',
    'rushLabelFeeRate',
  ],
} as const;

export const $PrismaBalanceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    type: {
      enum: ['FREE_CREDIT', 'MAIN'],
      type: 'string',
    },
    currentBalance: {
      type: 'number',
    },
  },
  required: ['id', 'type', 'currentBalance'],
} as const;

export const $PrismaAutoTopUpSettingsDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    enabled: {
      type: 'boolean',
    },
    lowLimitAmount: {
      type: 'number',
    },
    rechargeAmount: {
      type: 'number',
    },
    billingAccountId: {
      type: 'string',
    },
  },
  required: ['id', 'enabled', 'lowLimitAmount', 'rechargeAmount', 'billingAccountId'],
} as const;

export const $MeResponseDtoOrganizationBillingAccountActiveSubscription = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    BillingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
  },
  required: [
    'id',
    'status',
    'allowedToChooseTranscriptUnlockType',
    'billingAccountId',
    'createdAt',
    'BillingConfiguration',
  ],
} as const;

export const $MeResponseDtoOrganizationBillingAccount = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    tierRate: {
      type: 'number',
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    fixedRate: {
      type: 'boolean',
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    freeCreditBalanceId: {
      type: 'string',
    },
    mainBalanceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    activeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    billingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
    MainBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    FreeCreditBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    AutoTopUpSettings: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaAutoTopUpSettingsDto',
        },
      ],
    },
    ActiveSubscription: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/MeResponseDtoOrganizationBillingAccountActiveSubscription',
        },
      ],
    },
    currentBalance: {
      type: 'number',
    },
  },
  required: [
    'id',
    'name',
    'stripeCustomerId',
    'deleted',
    'autoRenew',
    'tierRate',
    'autoscriptOneFreeTrial',
    'fixedRate',
    'defaultBillingConfigurationId',
    'freeCreditBalanceId',
    'mainBalanceId',
    'createdAt',
    'billingConfiguration',
    'MainBalance',
    'FreeCreditBalance',
    'AutoTopUpSettings',
    'ActiveSubscription',
    'currentBalance',
  ],
} as const;

export const $PrismaOrganizationFeatureFlagDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    value: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'value', 'organizationId', 'createdAt'],
} as const;

export const $MeResponseDtoOrganization = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    asOneAllowed: {
      type: 'boolean',
      nullable: true,
    },
    asOneBackupRecordingTermsAccepted: {
      type: 'boolean',
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    serviceUserId: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    permissions: {
      type: 'object',
      additionalProperties: true,
    },
    licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AssignedLicenseResponseDto',
      },
    },
    featureFlags: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
    workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeResponseDtoOrganizationWorkspace',
      },
    },
    billingAccount: {
      $ref: '#/components/schemas/MeResponseDtoOrganizationBillingAccount',
    },
    userTeams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
    orgTeams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
    orgSubscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaSubscriptionDto',
      },
    },
    FeatureFlags: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationFeatureFlagDto',
      },
    },
    userCount: {
      type: 'number',
    },
    wsCount: {
      type: 'number',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'asOneAllowed',
    'asOneBackupRecordingTermsAccepted',
    'managementSource',
    'createdAt',
    'permissions',
    'licenses',
    'featureFlags',
    'workspaces',
    'billingAccount',
    'userTeams',
    'orgTeams',
    'orgSubscriptions',
    'FeatureFlags',
    'userCount',
    'wsCount',
  ],
} as const;

export const $GetAllAttorneysTransactionsResponseTransactionRecordingSessionJobWorkspaceDto = {
  type: 'object',
  properties: {
    slug: {
      type: 'string',
    },
  },
  required: ['slug'],
} as const;

export const $GetAllAttorneysTransactionsResponseTransactionRecordingSessionJobDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    Workspace: {
      $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseTransactionRecordingSessionJobWorkspaceDto',
    },
  },
  required: ['id', 'name', 'Workspace'],
} as const;

export const $GetAllAttorneysTransactionsResponseTransactionRecordingSessionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'ID',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    jobId: {
      type: 'string',
    },
    job: {
      $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseTransactionRecordingSessionJobDto',
    },
  },
  required: ['id', 'jobId', 'job'],
} as const;

export const $GetAllAttorneysTransactionsResponseTransactionInviterDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'ID',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'name', 'lastname', 'email', 'phone'],
} as const;

export const $GetAllAttorneysTransactionsResponseTransactionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'ID',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    priceAmount: {
      type: 'number',
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    recordingSessionId: {
      type: 'string',
      nullable: true,
    },
    status: {
      type: 'string',
    },
    type: {
      enum: ['attorney_invitation', 'attorney_connection'],
      type: 'string',
    },
    attorneyEmail: {
      type: 'string',
      nullable: true,
    },
    transactionCodeCode: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    RecordingSession: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseTransactionRecordingSessionDto',
        },
      ],
    },
    Inviter: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseTransactionInviterDto',
        },
      ],
    },
  },
  required: ['id', 'priceAmount', 'status', 'type', 'createdAt'],
} as const;

export const $GetAllAttorneysTransactionsResponseStatsDto = {
  type: 'object',
  properties: {
    connects: {
      type: 'number',
      description: 'Total number of connections',
      example: 5,
    },
    invites: {
      type: 'number',
      description: 'Total number of invitations',
      example: 5,
    },
    amount: {
      type: 'number',
      description: 'Total amount',
      example: 5,
    },
  },
  required: ['connects', 'invites', 'amount'],
} as const;

export const $GetAllAttorneysTransactionsResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
      description: 'Total number of results',
      example: 5,
    },
    data: {
      description: 'Transactions',
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseTransactionDto',
      },
    },
    stats: {
      description: 'Stats',
      allOf: [
        {
          $ref: '#/components/schemas/GetAllAttorneysTransactionsResponseStatsDto',
        },
      ],
    },
  },
  required: ['count', 'data', 'stats'],
} as const;

export const $DisableUserBodyDto = {
  type: 'object',
  properties: {
    disable: {
      type: 'boolean',
    },
  },
  required: ['disable'],
} as const;

export const $SuccessErrorResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the operation succeeded',
    },
    error: {
      type: 'string',
      description: 'Error message when success is false',
    },
  },
  required: ['success'],
} as const;

export const $UpdateOrganizationBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
  },
} as const;

export const $S3SignedUrlResponseDto = {
  type: 'object',
  properties: {
    fields: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
    },
    url: {
      type: 'string',
    },
  },
  required: ['fields', 'url'],
} as const;

export const $RemoveOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    asOneAllowed: {
      type: 'boolean',
      nullable: true,
    },
    asOneBackupRecordingTermsAccepted: {
      type: 'boolean',
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    serviceUserId: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'asOneAllowed',
    'asOneBackupRecordingTermsAccepted',
    'managementSource',
    'createdAt',
  ],
} as const;

export const $SuccessBooleanResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the operation succeeded',
    },
  },
  required: ['success'],
} as const;

export const $AvailableResponseDto = {
  type: 'object',
  properties: {
    available: {
      type: 'boolean',
      description: 'Whether the value is available',
    },
  },
  required: ['available'],
} as const;

export const $SetMemberCanManageLayoutDTO = {
  type: 'object',
  properties: {
    value: {
      type: 'boolean',
    },
  },
  required: ['value'],
} as const;

export const $GetOrgMemberReportsCheckoutJobWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $GetOrgMemberReportsCheckoutJobDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    Workspace: {
      $ref: '#/components/schemas/GetOrgMemberReportsCheckoutJobWorkspaceDto',
    },
    removed: {
      type: 'boolean',
    },
  },
  required: ['id', 'name', 'Workspace', 'removed'],
} as const;

export const $GetOrgMemberReportsCheckoutMetricsDto = {
  type: 'object',
  properties: {
    pagesCount: {
      type: 'number',
    },
    editsCount: {
      type: 'number',
    },
  },
  required: ['pagesCount', 'editsCount'],
} as const;

export const $GetOrgMemberReportsCheckoutFinalVersionDto = {
  type: 'object',
  properties: {
    Metrics: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/GetOrgMemberReportsCheckoutMetricsDto',
        },
      ],
    },
  },
} as const;

export const $GetOrgMemberReportsCheckoutEventDto = {
  type: 'object',
  properties: {
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    jobStatus: {
      type: 'string',
    },
    finalizedAt: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    Job: {
      $ref: '#/components/schemas/GetOrgMemberReportsCheckoutJobDto',
    },
    FinalVersion: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/GetOrgMemberReportsCheckoutFinalVersionDto',
        },
      ],
    },
  },
  required: ['createdAt', 'jobStatus', 'Job'],
} as const;

export const $GetOrgMemberReportsItemDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    profile: {
      type: 'object',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    agreement: {
      type: 'boolean',
    },
    haveSeenOnboarding: {
      type: 'boolean',
    },
    org: {
      type: 'string',
    },
    asrUsage: {
      type: 'number',
    },
    createdByAdmin: {
      type: 'boolean',
    },
    downloadedDesktop: {
      type: 'boolean',
    },
    signedInWithDesktop: {
      type: 'boolean',
    },
    signupUrl: {
      type: 'string',
    },
    emailVerified: {
      type: 'boolean',
    },
    confirmed: {
      type: 'boolean',
    },
    disabled: {
      type: 'boolean',
    },
    elasticKey: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastActiveDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastIpAddress: {
      type: 'string',
      nullable: true,
    },
    hasClaimedFreeBalance: {
      type: 'boolean',
    },
    membershipId: {
      type: 'string',
    },
    disabledInOrg: {
      type: 'boolean',
    },
    canManageLayouts: {
      type: 'boolean',
    },
    teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
    activeJobs: {
      type: 'number',
    },
    completedJobs: {
      type: 'number',
    },
    totalPages: {
      type: 'number',
    },
    totalEdits: {
      type: 'number',
    },
    checkoutEvents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetOrgMemberReportsCheckoutEventDto',
      },
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'phone',
    'company',
    'accountType',
    'profile',
    'email',
    'roles',
    'agreement',
    'haveSeenOnboarding',
    'org',
    'asrUsage',
    'createdByAdmin',
    'downloadedDesktop',
    'signedInWithDesktop',
    'signupUrl',
    'emailVerified',
    'confirmed',
    'disabled',
    'elasticKey',
    'createdAt',
    'hasClaimedFreeBalance',
    'teams',
    'checkoutEvents',
  ],
} as const;

export const $GetOrgMemberReportsResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetOrgMemberReportsItemDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $ChangeConcurrentJobsLimitBodyDto = {
  type: 'object',
  properties: {
    concurrentJobsLimit: {
      type: 'number',
    },
  },
  required: ['concurrentJobsLimit'],
} as const;

export const $ChangeConcurrentJobsLimitResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    code: {
      type: 'number',
    },
    message: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $WorkspaceWithStatusesResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    editorsNotifications: {
      type: 'boolean',
      nullable: true,
    },
    proofreadersNotifications: {
      type: 'boolean',
      nullable: true,
    },
    jobSubmissionNotifications: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    jobsProcessing: {
      type: 'number',
    },
    jobsReadyForTranscribing: {
      type: 'number',
    },
    jobsComplete: {
      type: 'number',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'editorsNotifications',
    'proofreadersNotifications',
    'jobSubmissionNotifications',
    'organizationId',
    'createdAt',
    'jobsProcessing',
    'jobsReadyForTranscribing',
    'jobsComplete',
  ],
} as const;

export const $InvitationWithTeams = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    status: {
      enum: ['CREATED', 'ACCEPTED', 'DECLINED'],
      type: 'string',
    },
    expiry: {
      type: 'string',
      format: 'date-time',
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    userId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
  },
  required: ['id', 'email', 'status', 'expiry', 'createdAt', 'Teams'],
} as const;

export const $CreateInvitationBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
    teamIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['email', 'teamIds'],
} as const;

export const $CreateInvitationsBodyDto = {
  type: 'object',
  properties: {
    invitations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CreateInvitationBodyDto',
      },
    },
  },
  required: ['invitations'],
} as const;

export const $PrismaRepositoryDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    notes: {
      type: 'string',
      nullable: true,
    },
    zipUrl: {
      type: 'string',
      nullable: true,
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'slug', 'createdAt'],
} as const;

export const $RepositoryWithStatusesDto = {
  type: 'object',
  properties: {
    jobsProcessing: {
      type: 'number',
    },
    jobsReadyForTranscribing: {
      type: 'number',
    },
    jobsComplete: {
      type: 'number',
    },
    totalJobs: {
      type: 'number',
    },
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
  },
  required: [
    'jobsProcessing',
    'jobsReadyForTranscribing',
    'jobsComplete',
    'totalJobs',
    'id',
    'name',
    'slug',
    'createdAt',
  ],
} as const;

export const $RepositoriesWithStatusesResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RepositoryWithStatusesDto',
      },
    },
    count: {
      type: 'number',
    },
  },
  required: ['data', 'count'],
} as const;

export const $PrismaWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    editorsNotifications: {
      type: 'boolean',
      nullable: true,
    },
    proofreadersNotifications: {
      type: 'boolean',
      nullable: true,
    },
    jobSubmissionNotifications: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'editorsNotifications',
    'proofreadersNotifications',
    'jobSubmissionNotifications',
    'organizationId',
    'createdAt',
  ],
} as const;

export const $OrganizationTeamResponseDto = {
  type: 'object',
  properties: {
    members: {
      type: 'number',
    },
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    slug: {
      type: 'string',
    },
    colour: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    updatedAt: {
      type: 'object',
    },
    Workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaWorkspaceDto',
      },
    },
  },
  required: ['members', 'id', 'name', 'owner', 'slug', 'colour', 'default', 'createdAt', 'updatedAt'],
} as const;

export const $SearchJobWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id'],
} as const;

export const $SearchJobItemDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    workspace: {
      $ref: '#/components/schemas/SearchJobWorkspaceDto',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'workspace', 'createdAt'],
} as const;

export const $SearchUserItemDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'userId'],
} as const;

export const $SearchResponseDto = {
  type: 'object',
  properties: {
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SearchJobItemDto',
      },
    },
    users: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SearchUserItemDto',
      },
    },
  },
  required: ['jobs', 'users'],
} as const;

export const $SetBackupRecordingAllowedFlagBodyDto = {
  type: 'object',
  properties: {
    value: {
      type: 'boolean',
    },
  },
  required: ['value'],
} as const;

export const $GetAllSubscriptionPlansPlanResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    index: {
      type: 'number',
    },
    type: {
      type: 'string',
    },
    public: {
      type: 'boolean',
    },
    trialPeriodDays: {
      type: 'number',
    },
    freeSeats: {
      type: 'number',
    },
    price: {
      type: 'number',
    },
    stripeProductId: {
      type: 'string',
      nullable: true,
    },
    stripeItemPriceId: {
      type: 'string',
      nullable: true,
    },
    defaultBillingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    audioHoursPerMonth: {
      type: 'number',
      nullable: true,
    },
    unlimitedHoursPerMonth: {
      type: 'boolean',
    },
    inPersonCaptureChannels: {
      type: 'number',
      nullable: true,
    },
    shouldBeCanceledAfterInHours: {
      type: 'number',
      nullable: true,
    },
    realtimeASREnabled: {
      type: 'boolean',
    },
    DefaultBillingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
  },
  required: [
    'id',
    'name',
    'description',
    'index',
    'type',
    'public',
    'trialPeriodDays',
    'freeSeats',
    'price',
    'stripeProductId',
    'stripeItemPriceId',
    'allowedToChooseTranscriptUnlockType',
    'unlimitedHoursPerMonth',
    'inPersonCaptureChannels',
    'shouldBeCanceledAfterInHours',
    'realtimeASREnabled',
    'DefaultBillingConfiguration',
  ],
} as const;

export const $GetBillingAccountResponseSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaLicenseDto',
      },
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType', 'billingAccountId', 'createdAt', 'licenses'],
} as const;

export const $GetBillingAccountResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    currentBalance: {
      type: 'number',
    },
    organization: {
      $ref: '#/components/schemas/PrismaOrganizationDto',
    },
    subscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetBillingAccountResponseSubscriptionDto',
      },
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    autoscriptOnePartialRate: {
      type: 'number',
    },
    autoscriptOneRealTimeRate: {
      type: 'number',
    },
    enhancedOnDemandRate: {
      type: 'number',
    },
    enhancedOnDemandRateType: {
      type: 'string',
    },
    fixedRate: {
      type: 'boolean',
    },
    tierRate: {
      type: 'number',
    },
    autoTopUpSettings: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaAutoTopUpSettingsDto',
        },
      ],
    },
    billingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
  },
  required: [
    'id',
    'currentBalance',
    'organization',
    'subscriptions',
    'name',
    'stripeCustomerId',
    'autoscriptOnePartialRate',
    'autoscriptOneRealTimeRate',
    'enhancedOnDemandRate',
    'enhancedOnDemandRateType',
    'fixedRate',
    'tierRate',
  ],
} as const;

export const $PendingTopUpResponseDto = {
  type: 'object',
  properties: {
    paymentIntentId: {
      type: 'string',
    },
    amount: {
      type: 'number',
      description: 'Amount in cents',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    settled: {
      type: 'boolean',
    },
  },
  required: ['paymentIntentId', 'amount', 'createdAt', 'settled'],
} as const;

export const $PrismaBillingAccountDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    tierRate: {
      type: 'number',
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    fixedRate: {
      type: 'boolean',
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    freeCreditBalanceId: {
      type: 'string',
    },
    mainBalanceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    activeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
  },
  required: [
    'id',
    'name',
    'stripeCustomerId',
    'deleted',
    'autoRenew',
    'tierRate',
    'autoscriptOneFreeTrial',
    'fixedRate',
    'defaultBillingConfigurationId',
    'freeCreditBalanceId',
    'mainBalanceId',
    'createdAt',
  ],
} as const;

export const $SetAutoTopUpSettingsBodyDto = {
  type: 'object',
  properties: {
    enabled: {
      type: 'boolean',
    },
    lowLimitAmount: {
      type: 'number',
    },
    rechargeAmount: {
      type: 'number',
    },
  },
  required: ['enabled', 'lowLimitAmount', 'rechargeAmount'],
} as const;

export const $UpdateBillingAccountBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    paymentModelId: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    autoRenew: {
      type: 'boolean',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['autoRenew'],
} as const;

export const $GetTransactionsTransactionCodeDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
  },
  required: ['name'],
} as const;

export const $GetTransactionsTransactionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    codeId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    realTimePending: {
      type: 'boolean',
      nullable: true,
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    dontUseForBalanceCalculation: {
      type: 'boolean',
      nullable: true,
    },
    balanceId: {
      type: 'string',
    },
    code: {
      $ref: '#/components/schemas/GetTransactionsTransactionCodeDto',
    },
  },
  required: ['id', 'amount', 'codeId', 'title', 'description', 'createdAt', 'balanceId', 'code'],
} as const;

export const $TransactionCodeDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
  },
  required: ['name'],
} as const;

export const $TransactionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    codeId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    realTimePending: {
      type: 'boolean',
      nullable: true,
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    dontUseForBalanceCalculation: {
      type: 'boolean',
      nullable: true,
    },
    balanceId: {
      type: 'string',
    },
    code: {
      $ref: '#/components/schemas/TransactionCodeDto',
    },
  },
  required: ['id', 'amount', 'codeId', 'title', 'description', 'createdAt', 'balanceId', 'code'],
} as const;

export const $TransactionListResponseDto = {
  type: 'object',
  properties: {
    transactions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TransactionResponseDto',
      },
    },
  },
  required: ['transactions'],
} as const;

export const $BillingAccountTierRatesHistoryUserDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
  },
  required: ['name', 'email'],
} as const;

export const $GetBillingAccountTierRatesHistoryDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    billingAccountId: {
      type: 'string',
      format: 'uuid',
    },
    oldTierRate: {
      type: 'number',
      example: 10.5,
    },
    newTierRate: {
      type: 'number',
      example: 12,
    },
    changedAt: {
      type: 'string',
      format: 'date-time',
    },
    changedBy: {
      type: 'string',
    },
    user: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/BillingAccountTierRatesHistoryUserDto',
        },
      ],
    },
  },
  required: ['id', 'billingAccountId', 'oldTierRate', 'newTierRate', 'changedAt', 'changedBy'],
} as const;

export const $UnlockJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $BillingUsageResponseDto = {
  type: 'object',
  properties: {
    ASRUsageInMinutes: {
      type: 'number',
      description: 'ASR usage in minutes (rounded to 2 decimals)',
    },
    CurrentTotalCost: {
      type: 'number',
      description: 'Current total cost',
    },
  },
  required: ['ASRUsageInMinutes', 'CurrentTotalCost'],
} as const;

export const $CalculateJobPricingResultDto = {
  type: 'object',
  properties: {
    price: {
      type: 'number',
    },
    duration: {
      type: 'number',
    },
    ASRRate: {
      type: 'number',
    },
  },
  required: ['price', 'duration', 'ASRRate'],
} as const;

export const $CalculateJobPricingResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      $ref: '#/components/schemas/CalculateJobPricingResultDto',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $CalculateJobEnhancementPricingResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      $ref: '#/components/schemas/CalculateJobPricingResultDto',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $CalculateJobUnlockPricingResultDto = {
  type: 'object',
  properties: {
    alreadyPaid: {
      type: 'number',
    },
    totalJobCost: {
      type: 'number',
    },
    amount: {
      type: 'number',
    },
    duration: {
      type: 'number',
    },
    mixdownFinished: {
      type: 'boolean',
    },
    partialUnlocked: {
      type: 'boolean',
    },
    partialUnlockRate: {
      type: 'number',
    },
  },
  required: [
    'alreadyPaid',
    'totalJobCost',
    'amount',
    'duration',
    'mixdownFinished',
    'partialUnlocked',
    'partialUnlockRate',
  ],
} as const;

export const $CalculateJobUnlockPricingResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      $ref: '#/components/schemas/CalculateJobUnlockPricingResultDto',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $StripeWebhookResponseDto = {
  type: 'object',
  properties: {
    message: {
      type: 'string',
      example: 'ok',
      description: 'Webhook processed successfully',
    },
  },
  required: ['message'],
} as const;

export const $AdminGetWorkspaceResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      $ref: '#/components/schemas/PrismaWorkspaceDto',
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $OrganizationTeamWithMembersResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    colour: {
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewJobs: {
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    members: {
      type: 'number',
    },
  },
  required: [
    'id',
    'default',
    'name',
    'slug',
    'colour',
    'owner',
    'viewRepositories',
    'editRepositories',
    'viewBilling',
    'manageBilling',
    'viewJobs',
    'editJobs',
    'reassignJobs',
    'deleteJobs',
    'submitJobs',
    'viewJobCost',
    'editJobTranscript',
    'proofreadJobTranscript',
    'finalizeJobTranscript',
    'markJobComplete',
    'viewReports',
    'manageMembers',
    'managePermissions',
    'manageWorkspaces',
    'manageOrganization',
    'viewLicenses',
    'manageLicenses',
    'organizationId',
    'createdAt',
    'members',
  ],
} as const;

export const $GetTeamsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/OrganizationTeamWithMembersResponseDto',
      },
    },
  },
  required: ['success', 'result'],
} as const;

export const $CreateWorkspaceBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
  },
  required: ['name', 'slug', 'organizationId'],
} as const;

export const $UpdateWorkspaceBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    editorsNotifications: {
      type: 'boolean',
    },
    proofreadersNotifications: {
      type: 'boolean',
    },
    jobSubmissionNotifications: {
      type: 'boolean',
    },
  },
  required: ['name', 'slug'],
} as const;

export const $AddTeamsBodyDto = {
  type: 'object',
  properties: {
    teamIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['teamIds'],
} as const;

export const $GetWorkspaceBySlugsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    editorsNotifications: {
      type: 'boolean',
    },
    proofreadersNotifications: {
      type: 'boolean',
    },
    jobSubmissionNotifications: {
      type: 'boolean',
    },
    watchers: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'organizationId',
    'editorsNotifications',
    'proofreadersNotifications',
    'jobSubmissionNotifications',
    'watchers',
  ],
} as const;

export const $RepositoryUploadParamsResponseDto = {
  type: 'object',
  properties: {
    url: {
      type: 'string',
      description: 'Pre-signed S3 upload URL',
    },
    fields: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
      description: 'Form fields to include in the multipart upload request',
    },
  },
  required: ['url', 'fields'],
} as const;

export const $CreateRepositoryBodyDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    notes: {
      type: 'string',
    },
    files: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    organizationSlug: {
      type: 'string',
    },
    assignee: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'name', 'slug', 'notes', 'organizationSlug'],
} as const;

export const $PrismaRepositoryAttachmentDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    fileExtension: {
      type: 'string',
    },
    weight: {
      type: 'number',
    },
    isAudio: {
      type: 'boolean',
    },
    audioDuration: {
      type: 'number',
      nullable: true,
    },
    repositoryId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'fileName', 'fileSize', 'fileExtension', 'weight', 'isAudio', 'repositoryId', 'createdAt'],
} as const;

export const $FindOneRepositoryResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    notes: {
      type: 'string',
      nullable: true,
    },
    zipUrl: {
      type: 'string',
      nullable: true,
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaRepositoryAttachmentDto',
      },
    },
    Assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaUserDto',
        },
      ],
    },
  },
  required: ['id', 'name', 'slug', 'createdAt', 'Attachments', 'Assignee'],
} as const;

export const $SlugAvailableResponseDto = {
  type: 'object',
  properties: {
    available: {
      type: 'boolean',
      description: 'Whether the slug is available for use',
    },
  },
  required: ['available'],
} as const;

export const $UpdateRepositoryBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    notes: {
      type: 'string',
    },
  },
} as const;

export const $RemoveRepositoryResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the operation succeeded',
    },
    error: {
      type: 'string',
      description: 'Error message when success is false',
    },
  },
  required: ['success'],
} as const;

export const $CreateAttachmentBodyDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    weight: {
      type: 'number',
    },
    organizationSlug: {
      type: 'string',
    },
    isAudio: {
      type: 'boolean',
    },
    audioDuration: {
      type: 'number',
    },
  },
  required: ['fileName', 'fileSize', 'repositoryId', 'weight', 'organizationSlug', 'isAudio'],
} as const;

export const $CreateAttachmentResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'ID of the created repository attachment',
      format: 'uuid',
    },
  },
  required: ['id'],
} as const;

export const $DownloadAttachmentResponseDto = {
  type: 'object',
  properties: {
    url: {
      type: 'string',
      description: 'Pre-signed download URL for the attachment',
    },
  },
  required: ['url'],
} as const;

export const $ReassignRepoBodyDto = {
  type: 'object',
  properties: {
    assigneeId: {
      type: 'string',
      nullable: true,
    },
  },
} as const;

export const $ReassignRepoResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the reassignment succeeded',
    },
    result: {
      type: 'object',
      additionalProperties: true,
      description: 'Result data',
    },
    error: {
      type: 'string',
      description: 'Error message when success is false',
    },
  },
  required: ['success'],
} as const;

export const $CreateSsoProviderBodyDto = {
  type: 'object',
  properties: {
    identityProvider: {
      type: 'string',
    },
    type: {
      enum: ['COGNITO_ONLY', 'AUTH0', 'WORKOS'],
      type: 'string',
    },
    issuerDomain: {
      type: 'string',
    },
    clientId: {
      type: 'string',
    },
    domains: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    emails: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    defaultOrganizationRoleId: {
      type: 'string',
      nullable: true,
    },
    requiresPreProvisionedUser: {
      type: 'boolean',
    },
    trustProviderEmailVerification: {
      type: 'boolean',
    },
    enforceSsoOnlyAuthentication: {
      type: 'boolean',
    },
  },
  required: ['identityProvider'],
} as const;

export const $PrismaSSOProviderDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    identityProvider: {
      type: 'string',
    },
    type: {
      enum: ['COGNITO_ONLY', 'AUTH0', 'WORKOS'],
      type: 'string',
    },
    issuerDomain: {
      type: 'string',
      nullable: true,
    },
    clientId: {
      type: 'string',
      nullable: true,
    },
    domains: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    emails: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    defaultOrganizationRoleId: {
      type: 'string',
      nullable: true,
    },
    requiresPreProvisionedUser: {
      type: 'boolean',
    },
    trustProviderEmailVerification: {
      type: 'boolean',
    },
    enforceSsoOnlyAuthentication: {
      type: 'boolean',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'id',
    'identityProvider',
    'type',
    'domains',
    'emails',
    'organizationId',
    'defaultOrganizationRoleId',
    'requiresPreProvisionedUser',
    'trustProviderEmailVerification',
    'enforceSsoOnlyAuthentication',
    'createdAt',
  ],
} as const;

export const $FindAllSsoProvidersResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaSSOProviderDto',
      },
    },
    count: {
      type: 'number',
    },
  },
  required: ['data', 'count'],
} as const;

export const $UpdateSsoProviderBodyDto = {
  type: 'object',
  properties: {
    identityProvider: {
      type: 'string',
    },
    type: {
      enum: ['COGNITO_ONLY', 'AUTH0', 'WORKOS'],
      type: 'string',
    },
    issuerDomain: {
      type: 'string',
    },
    clientId: {
      type: 'string',
    },
    domains: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    emails: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    defaultOrganizationRoleId: {
      type: 'string',
      nullable: true,
    },
    requiresPreProvisionedUser: {
      type: 'boolean',
    },
    trustProviderEmailVerification: {
      type: 'boolean',
    },
    enforceSsoOnlyAuthentication: {
      type: 'boolean',
    },
  },
} as const;

export const $CheckDomainBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'Exact email address to resolve before domain fallback',
    },
    domain: {
      type: 'string',
      description: 'Legacy domain-only SSO lookup',
    },
    consumeSsoSessionMarker: {
      type: 'boolean',
      description: 'Clear and return the current SSO provider session marker',
    },
  },
} as const;

export const $CheckDomainResponseDto = {
  type: 'object',
  properties: {
    ssoRedirectUrl: {
      type: 'string',
      nullable: true,
      description: 'SSO redirect URL if the email or domain is configured',
    },
    ssoLogoutUrl: {
      type: 'string',
      nullable: true,
      description: 'SSO logout URL if the email or domain is configured',
    },
    shouldLogoutPreviousSsoSession: {
      type: 'boolean',
      description: 'Whether an SSO provider session was previously observed',
    },
  },
  required: ['ssoRedirectUrl', 'ssoLogoutUrl', 'shouldLogoutPreviousSsoSession'],
} as const;

export const $RecordingSessionLivenessStatusResponseDto = {
  type: 'object',
  properties: {
    isActive: {
      type: 'boolean',
      description: 'Whether the recording session is currently active (has received a heartbeat recently)',
      example: true,
    },
    lastActivityTimestamp: {
      type: 'number',
      nullable: true,
      description: 'Unix timestamp of the last activity (heartbeat)',
      example: 1696204800000,
    },
    lastActivityDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
      description: 'ISO date string of the last activity (heartbeat)',
      example: '2023-10-02T00:00:00.000Z',
    },
  },
  required: ['isActive'],
} as const;

export const $ExhibitsUploadFileBodyDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    recordingSessionId: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
  },
  required: ['fileName', 'recordingSessionId', 'email'],
} as const;

export const $ExhibitsUploadParamsBodyDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    recordingSessionId: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
  },
  required: ['fileName', 'recordingSessionId', 'email'],
} as const;

export const $InviteAttorneyBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
  },
  required: ['email'],
} as const;

export const $UsePasscodeBodyDto = {
  type: 'object',
  properties: {
    passcode: {
      type: 'string',
    },
  },
  required: ['passcode'],
} as const;

export const $UsePasscodeResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    recordingSessionId: {
      type: 'string',
      format: 'uuid',
    },
  },
  required: ['success', 'recordingSessionId'],
} as const;

export const $AttorneyPasscodeErrorResponseDto = {
  type: 'object',
  properties: {
    code: {
      enum: ['ATTORNEY_PASSCODE_INVALID', 'ATTORNEY_INVITATION_EMAIL_MISMATCH'],
      type: 'string',
    },
    message: {
      enum: [
        'Passcode does not exist.',
        'This invitation is linked to a different email address. Please contact the Court Reporter for a new invitation.',
      ],
      type: 'string',
    },
  },
  required: ['code', 'message'],
} as const;

export const $SendTranscriptQuestionToAIBodyDto = {
  type: 'object',
  properties: {
    userQuestion: {
      type: 'string',
    },
  },
  required: ['userQuestion'],
} as const;

export const $PrismaRecordingSessionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    status: {
      enum: [
        'RECORDING_SESSION_PENDING',
        'RECORDING_SESSION_COMPLETED',
        'RECORDING_SESSION_FAILED',
        'RECORDING_SESSION_LIVE',
      ],
      type: 'string',
    },
    sessionType: {
      enum: ['RECORDING_SESSION_REMOTE', 'RECORDING_SESSION_HYBRID', 'RECORDING_SESSION_IN_PERSON'],
      type: 'string',
    },
    scheduledDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    scheduledTime: {
      type: 'string',
      nullable: true,
    },
    scheduledTimezone: {
      type: 'string',
      nullable: true,
    },
    physicalAddress: {
      type: 'string',
      nullable: true,
    },
    meetingLink: {
      type: 'string',
      nullable: true,
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'jobId', 'status', 'sessionType'],
} as const;

export const $CreateBodyDto = {
  type: 'object',
  properties: {
    organizationId: {
      type: 'string',
    },
    sessionType: {
      enum: ['RECORDING_SESSION_REMOTE', 'RECORDING_SESSION_HYBRID', 'RECORDING_SESSION_IN_PERSON'],
      type: 'string',
    },
    jobName: {
      type: 'string',
    },
    noShow: {
      type: 'boolean',
    },
  },
  required: ['organizationId'],
} as const;

export const $CreateDraftJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    recordingSessionId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['success'],
} as const;

export const $CheckAllowanceResponseDto = {
  type: 'object',
  properties: {
    allowed: {
      type: 'boolean',
    },
  },
  required: ['allowed'],
} as const;

export const $SubmitPreprocessingBodyDto = {
  type: 'object',
  properties: {
    status: {
      enum: [
        'RECORDING_SESSION_PENDING',
        'RECORDING_SESSION_COMPLETED',
        'RECORDING_SESSION_FAILED',
        'RECORDING_SESSION_LIVE',
      ],
      type: 'string',
      description: 'Recording session status',
    },
    rushedJob: {
      type: 'boolean',
      description: 'Whether this is a rushed job',
      default: false,
    },
    realtimeASRDisabled: {
      type: 'boolean',
      description: 'Whether realtime ASR is disabled',
      default: false,
    },
    noShow: {
      type: 'boolean',
      description: 'Whether this is no show',
      default: false,
    },
    usedASRModel: {
      type: 'string',
      description: 'ASR model used during the live recording session (e.g. AssemblyAiV3, AssemblyAiV3Pro)',
    },
  },
} as const;

export const $CreateBillingCheckpointBodyDto = {
  type: 'object',
  properties: {
    totalDuration: {
      type: 'number',
    },
    realtimeASRDisabled: {
      type: 'boolean',
    },
  },
  required: ['totalDuration'],
} as const;

export const $AddBillingCheckpointResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'success',
    },
    billingCheckpointId: {
      type: 'string',
      nullable: true,
      description: 'Created billing checkpoint ID',
    },
  },
  required: ['status'],
} as const;

export const $RecordingSessionFileItemResponseDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'number',
    },
    s3FileSize: {
      type: 'number',
    },
    s3Key: {
      type: 'string',
    },
  },
  required: ['fileName', 'fileSize', 's3FileSize', 's3Key'],
} as const;

export const $CreatePaymentIntentBodyDto = {
  type: 'object',
  properties: {
    paymentMethodId: {
      type: 'string',
    },
    paymentModelId: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    jobId: {
      type: 'string',
    },
    balanceTopup: {
      type: 'boolean',
    },
    canRenew: {
      type: 'boolean',
    },
  },
  required: ['amount'],
} as const;

export const $CardDeclinedResponseDto = {
  type: 'object',
  properties: {
    statusCode: {
      type: 'number',
      example: 402,
    },
    message: {
      type: 'string',
      example: 'Your card was declined.',
    },
  },
  required: ['statusCode', 'message'],
} as const;

export const $StripePaymentIntentResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    object: {
      type: 'string',
      enum: ['payment_intent'],
    },
    amount: {
      type: 'number',
    },
    amount_capturable: {
      type: 'number',
    },
    amount_details: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    amount_received: {
      type: 'number',
    },
    application: {
      type: 'string',
      nullable: true,
    },
    application_fee_amount: {
      type: 'number',
      nullable: true,
    },
    automatic_payment_methods: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    canceled_at: {
      type: 'number',
      nullable: true,
    },
    cancellation_reason: {
      type: 'string',
      nullable: true,
    },
    capture_method: {
      type: 'string',
    },
    client_secret: {
      type: 'string',
      nullable: true,
    },
    confirmation_method: {
      type: 'string',
    },
    created: {
      type: 'number',
      description: 'Unix timestamp (seconds)',
    },
    currency: {
      type: 'string',
    },
    customer: {
      type: 'object',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    invoice: {
      type: 'object',
      nullable: true,
    },
    last_payment_error: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    latest_charge: {
      type: 'object',
      nullable: true,
    },
    livemode: {
      type: 'boolean',
    },
    metadata: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
    },
    next_action: {
      type: 'object',
    },
    on_behalf_of: {
      type: 'object',
      nullable: true,
    },
    payment_method: {
      type: 'object',
      nullable: true,
    },
    payment_method_configuration_details: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    payment_method_options: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    payment_method_types: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    processing: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    receipt_email: {
      type: 'string',
      nullable: true,
    },
    review: {
      type: 'object',
      nullable: true,
    },
    setup_future_usage: {
      type: 'string',
      nullable: true,
    },
    shipping: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    source: {
      type: 'object',
      nullable: true,
    },
    statement_descriptor: {
      type: 'string',
      nullable: true,
    },
    statement_descriptor_suffix: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: [
        'canceled',
        'processing',
        'requires_action',
        'requires_capture',
        'requires_confirmation',
        'requires_payment_method',
        'succeeded',
      ],
      type: 'string',
    },
    transfer_data: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    transfer_group: {
      type: 'string',
      nullable: true,
    },
  },
  required: [
    'id',
    'object',
    'amount',
    'amount_capturable',
    'amount_received',
    'application',
    'application_fee_amount',
    'automatic_payment_methods',
    'canceled_at',
    'cancellation_reason',
    'capture_method',
    'client_secret',
    'confirmation_method',
    'created',
    'currency',
    'customer',
    'description',
    'invoice',
    'last_payment_error',
    'latest_charge',
    'livemode',
    'metadata',
    'next_action',
    'on_behalf_of',
    'payment_method',
    'payment_method_configuration_details',
    'payment_method_options',
    'payment_method_types',
    'processing',
    'receipt_email',
    'review',
    'setup_future_usage',
    'shipping',
    'source',
    'statement_descriptor',
    'statement_descriptor_suffix',
    'status',
    'transfer_data',
    'transfer_group',
  ],
} as const;

export const $ConfirmPaymentIntentBodyDto = {
  type: 'object',
  properties: {
    customerEmail: {
      type: 'string',
    },
    paymentMethodId: {
      type: 'string',
    },
    returnUrl: {
      type: 'string',
    },
    paymentIntentsId: {
      type: 'string',
    },
  },
  required: ['customerEmail', 'paymentMethodId', 'returnUrl', 'paymentIntentsId'],
} as const;

export const $PaymentMethodNestedExpDateDto = {
  type: 'object',
  properties: {
    month: {
      type: 'string',
    },
    year: {
      type: 'string',
    },
  },
  required: ['month', 'year'],
} as const;

export const $PaymentMethodResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    type: {
      type: 'string',
    },
    last4: {
      type: 'string',
    },
    created: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    expDate: {
      $ref: '#/components/schemas/PaymentMethodNestedExpDateDto',
    },
  },
  required: ['id', 'type', 'last4', 'created', 'default', 'expDate'],
} as const;

export const $HasPaymentMethodResponseDto = {
  type: 'object',
  properties: {
    result: {
      type: 'boolean',
      description: 'Whether the billing account has at least one payment method',
    },
  },
  required: ['result'],
} as const;

export const $ReceiptResponseDto = {
  type: 'object',
  properties: {
    created: {
      type: 'number',
      description: 'Unix timestamp when the charge was created',
    },
    chargeId: {
      type: 'string',
      description: 'Stripe charge ID',
    },
    amount: {
      type: 'number',
      description: 'Amount in cents',
    },
    receiptUrl: {
      type: 'string',
      nullable: true,
      description: 'URL to the receipt',
    },
    jobId: {
      type: 'string',
      nullable: true,
      description: 'Job ID from charge metadata',
    },
    description: {
      type: 'string',
      nullable: true,
      description: 'Charge description',
    },
    status: {
      type: 'string',
      nullable: true,
      description: 'Charge status',
    },
  },
  required: ['created', 'chargeId', 'amount'],
} as const;

export const $CreateBankAccountResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Stripe source ID (card or bank_account)',
    },
    object: {
      type: 'string',
      description: 'Stripe object type',
      enum: ['card', 'bank_account'],
    },
    last4: {
      type: 'string',
      description: 'Last 4 digits of the account',
    },
  },
  required: ['id', 'object'],
} as const;

export const $BillingAccountAddPaymentMethodBodyDto = {
  type: 'object',
  properties: {
    paymentMethodId: {
      type: 'string',
    },
    paymentMethodType: {
      type: 'string',
    },
  },
  required: ['paymentMethodId', 'paymentMethodType'],
} as const;

export const $BillingAccountAddPaymentMethodResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $InvoiceListItemResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Stripe invoice ID',
    },
    amount: {
      type: 'number',
      description: 'Amount due in cents',
    },
    created: {
      type: 'number',
      description: 'Unix timestamp when invoice was created',
    },
    dueDate: {
      type: 'number',
      nullable: true,
      description: 'Unix timestamp for due date',
    },
    status: {
      type: 'string',
      nullable: true,
      description: 'Invoice status',
    },
    invoicePdf: {
      type: 'string',
      nullable: true,
      description: 'URL to invoice PDF',
    },
  },
  required: ['id', 'amount', 'created'],
} as const;

export const $InvoiceLineItemResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Line item ID',
    },
    amount: {
      type: 'number',
      description: 'Amount in cents',
    },
    currency: {
      type: 'string',
      nullable: true,
      description: 'Currency code',
    },
    quantity: {
      type: 'number',
      nullable: true,
      description: 'Quantity',
    },
    description: {
      type: 'string',
      nullable: true,
      description: 'Line item description',
    },
  },
  required: ['id', 'amount'],
} as const;

export const $InvoiceWithLinesResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Stripe invoice ID',
    },
    amount: {
      type: 'number',
      description: 'Amount due in cents',
    },
    created: {
      type: 'number',
      description: 'Unix timestamp when invoice was created',
    },
    dueDate: {
      type: 'number',
      nullable: true,
      description: 'Unix timestamp for due date',
    },
    status: {
      type: 'string',
      nullable: true,
      description: 'Invoice status',
    },
    invoicePdf: {
      type: 'string',
      nullable: true,
      description: 'URL to invoice PDF',
    },
    lines: {
      description: 'Invoice line items',
      type: 'array',
      items: {
        $ref: '#/components/schemas/InvoiceLineItemResponseDto',
      },
    },
  },
  required: ['id', 'amount', 'created', 'lines'],
} as const;

export const $GetUserDetailsJobDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    title: {
      type: 'string',
    },
    completed: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    versionId: {
      type: 'string',
      nullable: true,
    },
    workspaceSlug: {
      type: 'string',
      nullable: true,
    },
    workspaceId: {
      type: 'string',
    },
  },
  required: ['jobId', 'createdAt', 'title', 'workspaceId'],
} as const;

export const $GetUserDetailsOrgRelationDto = {
  type: 'object',
  properties: {
    membershipId: {
      type: 'string',
    },
    canManageLayouts: {
      type: 'boolean',
    },
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    userCount: {
      type: 'number',
    },
    wsCount: {
      type: 'number',
    },
  },
  required: ['membershipId', 'canManageLayouts', 'id', 'name', 'slug', 'deleted', 'userCount', 'wsCount'],
} as const;

export const $GetUserDetailsResultDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    concurrentJobsLimit: {
      type: 'number',
    },
    teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetUserDetailsJobDto',
      },
    },
    orgRelations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetUserDetailsOrgRelationDto',
      },
    },
    workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeResponseDtoOrganizationWorkspace',
      },
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'email',
    'phone',
    'concurrentJobsLimit',
    'teams',
    'jobs',
    'orgRelations',
    'workspaces',
  ],
} as const;

export const $GetUserDetailsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      $ref: '#/components/schemas/GetUserDetailsResultDto',
    },
  },
  required: ['success'],
} as const;

export const $UpdateAccountBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
  },
  required: ['name', 'lastname'],
} as const;

export const $UpdateAccountResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $UploadAvatarBodyDto = {
  type: 'object',
  properties: {
    avatar: {
      type: 'string',
      description: 'Avatar URL or identifier',
    },
  },
  required: ['avatar'],
} as const;

export const $PrismaInvitationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    status: {
      enum: ['CREATED', 'ACCEPTED', 'DECLINED'],
      type: 'string',
    },
    expiry: {
      type: 'string',
      format: 'date-time',
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    userId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'email', 'status', 'expiry', 'createdAt'],
} as const;

export const $MeResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    profile: {
      type: 'object',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    agreement: {
      type: 'boolean',
    },
    haveSeenOnboarding: {
      type: 'boolean',
    },
    org: {
      type: 'string',
    },
    asrUsage: {
      type: 'number',
    },
    createdByAdmin: {
      type: 'boolean',
    },
    downloadedDesktop: {
      type: 'boolean',
    },
    signedInWithDesktop: {
      type: 'boolean',
    },
    signupUrl: {
      type: 'string',
    },
    emailVerified: {
      type: 'boolean',
    },
    confirmed: {
      type: 'boolean',
    },
    disabled: {
      type: 'boolean',
    },
    elasticKey: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastActiveDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastIpAddress: {
      type: 'string',
      nullable: true,
    },
    hasClaimedFreeBalance: {
      type: 'boolean',
    },
    invitations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaInvitationDto',
      },
    },
    organizations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeResponseDtoOrganization',
      },
    },
    assignedRepositories: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaRepositoryDto',
      },
    },
    canCreateOrganizations: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'phone',
    'company',
    'accountType',
    'profile',
    'email',
    'roles',
    'agreement',
    'haveSeenOnboarding',
    'org',
    'asrUsage',
    'createdByAdmin',
    'downloadedDesktop',
    'signedInWithDesktop',
    'signupUrl',
    'emailVerified',
    'confirmed',
    'disabled',
    'elasticKey',
    'createdAt',
    'hasClaimedFreeBalance',
    'invitations',
    'organizations',
    'assignedRepositories',
    'canCreateOrganizations',
  ],
} as const;

export const $TestJwtPayloadDto = {
  type: 'object',
  properties: {
    sub: {
      type: 'string',
    },
    scope: {
      type: 'string',
    },
    token_use: {
      type: 'string',
    },
    iss: {
      type: 'string',
    },
    username: {
      type: 'string',
    },
  },
} as const;

export const $TestJwtResponseDto = {
  type: 'object',
  properties: {
    payload: {
      $ref: '#/components/schemas/TestJwtPayloadDto',
    },
  },
} as const;

export const $AuthHttpErrorResponseDto = {
  type: 'object',
  properties: {
    statusCode: {
      type: 'number',
      example: 400,
    },
    message: {
      type: 'string',
      example: 'Incorrect username or password',
    },
  },
  required: ['statusCode', 'message'],
} as const;

export const $RegisterBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    lastName: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    redirectUrl: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    agreement: {
      type: 'boolean',
    },
    goto: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
    },
    howDidYouHearAboutUsReferral: {
      type: 'string',
    },
    howDidYouHearAboutUsComment: {
      type: 'string',
    },
  },
  required: [
    'name',
    'lastName',
    'password',
    'email',
    'accountType',
    'redirectUrl',
    'phone',
    'company',
    'agreement',
    'goto',
    'howDidYouHearAboutUs',
    'howDidYouHearAboutUsReferral',
    'howDidYouHearAboutUsComment',
  ],
} as const;

export const $LoginBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
    product: {
      type: 'string',
    },
    handoff: {
      type: 'string',
      description:
        'Hash the desktop app published. When given, the session is kept for that app and no auth cookies are set',
    },
  },
  required: ['email', 'password', 'product'],
} as const;

export const $ValidationHttpErrorResponseDto = {
  type: 'object',
  properties: {
    statusCode: {
      type: 'number',
      example: 400,
    },
    message: {
      example: ['password should not be empty'],
      type: 'array',
      items: {
        type: 'string',
      },
    },
    error: {
      type: 'string',
      example: 'Bad Request',
    },
  },
  required: ['statusCode', 'message', 'error'],
} as const;

export const $CognitoTokenIdentityResponseDto = {
  type: 'object',
  properties: {
    providerName: {
      type: 'string',
    },
  },
} as const;

export const $CognitoTokenPayloadResponseDto = {
  type: 'object',
  properties: {
    sub: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    family_name: {
      type: 'string',
    },
    username: {
      type: 'string',
    },
    iss: {
      type: 'string',
    },
    scope: {
      type: 'string',
    },
    token_use: {
      type: 'string',
    },
    'cognito:username': {
      type: 'string',
    },
    'custom:phone': {
      type: 'string',
    },
    'custom:company': {
      type: 'string',
    },
    'cognito:groups': {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    identities: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CognitoTokenIdentityResponseDto',
      },
    },
  },
} as const;

export const $CognitoIdTokenResponseDto = {
  type: 'object',
  properties: {
    jwtToken: {
      type: 'string',
    },
    payload: {
      $ref: '#/components/schemas/CognitoTokenPayloadResponseDto',
    },
  },
  required: ['jwtToken'],
} as const;

export const $CognitoAccessTokenResponseDto = {
  type: 'object',
  properties: {
    jwtToken: {
      type: 'string',
    },
    payload: {
      $ref: '#/components/schemas/CognitoTokenPayloadResponseDto',
    },
  },
  required: ['jwtToken'],
} as const;

export const $CognitoRefreshTokenResponseDto = {
  type: 'object',
  properties: {
    token: {
      type: 'string',
    },
  },
  required: ['token'],
} as const;

export const $AuthSessionResponseDto = {
  type: 'object',
  properties: {
    idToken: {
      $ref: '#/components/schemas/CognitoIdTokenResponseDto',
    },
    accessToken: {
      $ref: '#/components/schemas/CognitoAccessTokenResponseDto',
    },
    refreshToken: {
      $ref: '#/components/schemas/CognitoRefreshTokenResponseDto',
    },
    clockDrift: {
      type: 'number',
      nullable: true,
    },
  },
  required: ['idToken', 'accessToken', 'refreshToken'],
} as const;

export const $LoginResponseDto = {
  type: 'object',
  properties: {
    session: {
      description: 'Left out when the session is kept for a desktop app',
      allOf: [
        {
          $ref: '#/components/schemas/AuthSessionResponseDto',
        },
      ],
    },
    userId: {
      type: 'string',
    },
  },
  required: ['userId'],
} as const;

export const $SsoLoginBodyDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    state: {
      type: 'string',
    },
    handoff: {
      type: 'string',
      description:
        'Hash the desktop app published. When given, the session is kept for that app and no auth cookies are set',
    },
  },
  required: ['code', 'state'],
} as const;

export const $RecoverBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
  },
  required: ['email'],
} as const;

export const $PasswdBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
    code: {
      type: 'string',
    },
  },
  required: ['email', 'password', 'code'],
} as const;

export const $RefreshResponseDto = {
  type: 'object',
  properties: {
    refresh: {
      type: 'boolean',
    },
  },
  required: ['refresh'],
} as const;

export const $LogoutResponseDto = {
  type: 'object',
  properties: {
    logoutUrl: {
      type: 'string',
      format: 'uri',
    },
  },
  required: ['logoutUrl'],
} as const;

export const $CheckPhoneNumberBodyDto = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
    },
  },
  required: ['phone'],
} as const;

export const $CheckPhoneNumberResponseDto = {
  type: 'object',
  properties: {
    valid: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['valid'],
} as const;

export const $CheckEmailBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
  },
  required: ['email'],
} as const;

export const $CheckEmailResponseDto = {
  type: 'object',
  properties: {
    valid: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
  },
  required: ['valid'],
} as const;

export const $SendOtpCodeBodyDto = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
    },
  },
  required: ['phone'],
} as const;

export const $SendOtpCodeResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
  },
  required: ['success'],
} as const;

export const $VerifyPhoneBodyDto = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
    },
    code: {
      type: 'string',
    },
  },
  required: ['phone', 'code'],
} as const;

export const $VerifyPhoneResponseDto = {
  type: 'object',
  properties: {
    result: {
      type: 'boolean',
    },
  },
  required: ['result'],
} as const;

export const $DesktopResultBodyDto = {
  type: 'object',
  properties: {
    secret: {
      type: 'string',
      description: 'Secret behind the hash, proving the caller is the app that started this sign-in',
    },
  },
  required: ['secret'],
} as const;

export const $DesktopAuthResultResponseDto = {
  type: 'object',
  properties: {
    userId: {
      type: 'string',
      nullable: true,
      description: 'Signed-in user id, set on the response that also carries the session cookies',
    },
  },
  required: ['userId'],
} as const;

export const $PayForJobDto = {
  type: 'object',
  properties: {
    enhanced: {
      type: 'boolean',
    },
  },
} as const;

export const $PayForBulkJobsBodyDto = {
  type: 'object',
  properties: {
    ids: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['ids'],
} as const;

export const $PrismaClassifiedPipelineErrorDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    error: {
      type: 'string',
    },
    aiConclusion: {
      type: 'string',
      nullable: true,
    },
    wasSuccessfullyRetriedByAI: {
      type: 'boolean',
      nullable: true,
    },
    wasSuccessfullyRetriedManually: {
      type: 'boolean',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'error', 'jobId', 'createdAt'],
} as const;

export const $GetDashboardInfoResponse = {
  type: 'object',
  properties: {
    organizationsCount: {
      type: 'number',
    },
    workspacesCount: {
      type: 'number',
    },
    usersCount: {
      type: 'number',
    },
    transactionsCount: {
      type: 'number',
    },
    onlineUsers: {
      type: 'number',
    },
    failedTranscriptSubmitterJobs: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    activeTranscriptSubmitterJobs: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    classifiedPipelineErrors: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaClassifiedPipelineErrorDto',
      },
    },
  },
  required: [
    'organizationsCount',
    'workspacesCount',
    'usersCount',
    'transactionsCount',
    'onlineUsers',
    'failedTranscriptSubmitterJobs',
    'activeTranscriptSubmitterJobs',
    'classifiedPipelineErrors',
  ],
} as const;

export const $AdminJobsLiveDashboardJobDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    statusChangeDate: {
      type: 'string',
    },
    statusDurationSeconds: {
      type: 'number',
    },
    workspaceId: {
      type: 'string',
    },
    workspaceName: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    organizationName: {
      type: 'string',
    },
  },
  required: [
    'id',
    'name',
    'status',
    'statusChangeDate',
    'statusDurationSeconds',
    'workspaceId',
    'workspaceName',
    'organizationId',
    'organizationName',
  ],
} as const;

export const $AdminJobsLiveDashboardResponseDto = {
  type: 'object',
  properties: {
    generatedAt: {
      type: 'string',
    },
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminJobsLiveDashboardJobDto',
      },
    },
  },
  required: ['generatedAt', 'jobs'],
} as const;

export const $UpdateUserEmailBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'New user email',
    },
  },
  required: ['email'],
} as const;

export const $UpdateUserPhoneBodyDto = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
      description: 'New user phone',
    },
  },
  required: ['phone'],
} as const;

export const $AdminCreateUserBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    lastName: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    redirectUrl: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    agreement: {
      type: 'boolean',
    },
    goto: {
      type: 'string',
    },
    fromEmail: {
      type: 'boolean',
    },
  },
  required: ['name', 'lastName', 'accountType', 'email', 'phone', 'company'],
} as const;

export const $AdminCreateUserResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    code: {
      type: 'number',
    },
    message: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $AdminGetAllAsonePlansPlanResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    index: {
      type: 'number',
    },
    type: {
      type: 'string',
    },
    public: {
      type: 'boolean',
    },
    trialPeriodDays: {
      type: 'number',
    },
    freeSeats: {
      type: 'number',
    },
    price: {
      type: 'number',
    },
    stripeProductId: {
      type: 'string',
      nullable: true,
    },
    stripeItemPriceId: {
      type: 'string',
      nullable: true,
    },
    defaultBillingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    audioHoursPerMonth: {
      type: 'number',
      nullable: true,
    },
    unlimitedHoursPerMonth: {
      type: 'boolean',
    },
    inPersonCaptureChannels: {
      type: 'number',
      nullable: true,
    },
    shouldBeCanceledAfterInHours: {
      type: 'number',
      nullable: true,
    },
    realtimeASREnabled: {
      type: 'boolean',
    },
    DefaultBillingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
  },
  required: [
    'id',
    'name',
    'description',
    'index',
    'type',
    'public',
    'trialPeriodDays',
    'freeSeats',
    'price',
    'stripeProductId',
    'stripeItemPriceId',
    'allowedToChooseTranscriptUnlockType',
    'unlimitedHoursPerMonth',
    'inPersonCaptureChannels',
    'shouldBeCanceledAfterInHours',
    'realtimeASREnabled',
    'DefaultBillingConfiguration',
  ],
} as const;

export const $AdminGetInvitationsItemResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    status: {
      enum: ['CREATED', 'ACCEPTED', 'DECLINED'],
      type: 'string',
    },
    expiry: {
      type: 'string',
      format: 'date-time',
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    userId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationRoleDto',
      },
    },
  },
  required: ['id', 'email', 'status', 'expiry', 'createdAt', 'Teams'],
} as const;

export const $PaginatedWorkspaceResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaWorkspaceDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $CreateWSInvitationBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
    teamIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['email', 'teamIds'],
} as const;

export const $EditInvitationBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
  },
  required: ['email'],
} as const;

export const $ChangeASOneAllowedBodyDto = {
  type: 'object',
  properties: {
    value: {
      type: 'boolean',
      description: 'ASOne allowed flag',
    },
  },
  required: ['value'],
} as const;

export const $PrismaSubscriptionProductDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    index: {
      type: 'number',
    },
    type: {
      type: 'string',
    },
    public: {
      type: 'boolean',
    },
    trialPeriodDays: {
      type: 'number',
    },
    freeSeats: {
      type: 'number',
    },
    price: {
      type: 'number',
    },
    stripeProductId: {
      type: 'string',
      nullable: true,
    },
    stripeItemPriceId: {
      type: 'string',
      nullable: true,
    },
    defaultBillingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    audioHoursPerMonth: {
      type: 'number',
      nullable: true,
    },
    unlimitedHoursPerMonth: {
      type: 'boolean',
    },
    inPersonCaptureChannels: {
      type: 'number',
      nullable: true,
    },
    shouldBeCanceledAfterInHours: {
      type: 'number',
      nullable: true,
    },
    realtimeASREnabled: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'name',
    'description',
    'index',
    'type',
    'public',
    'trialPeriodDays',
    'freeSeats',
    'price',
    'stripeProductId',
    'stripeItemPriceId',
    'allowedToChooseTranscriptUnlockType',
    'unlimitedHoursPerMonth',
    'inPersonCaptureChannels',
    'shouldBeCanceledAfterInHours',
    'realtimeASREnabled',
  ],
} as const;

export const $AdminOrganizationsListOrganizationSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Product: {
      $ref: '#/components/schemas/PrismaSubscriptionProductDto',
    },
    BillingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
  },
  required: [
    'id',
    'status',
    'allowedToChooseTranscriptUnlockType',
    'billingAccountId',
    'createdAt',
    'Product',
    'BillingConfiguration',
  ],
} as const;

export const $AdminOrganizationsListOrganizationBillingAccountDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    tierRate: {
      type: 'number',
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    fixedRate: {
      type: 'boolean',
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    freeCreditBalanceId: {
      type: 'string',
    },
    mainBalanceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    activeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    MainBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    FreeCreditBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    DefaultBillingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
    billingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
    ActiveSubscription: {
      $ref: '#/components/schemas/AdminOrganizationsListOrganizationSubscriptionDto',
    },
  },
  required: [
    'id',
    'name',
    'stripeCustomerId',
    'deleted',
    'autoRenew',
    'tierRate',
    'autoscriptOneFreeTrial',
    'fixedRate',
    'defaultBillingConfigurationId',
    'freeCreditBalanceId',
    'mainBalanceId',
    'createdAt',
    'MainBalance',
    'FreeCreditBalance',
    'DefaultBillingConfiguration',
    'billingConfiguration',
    'ActiveSubscription',
  ],
} as const;

export const $AdminOrganizationsListOrganizationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    asOneAllowed: {
      type: 'boolean',
      nullable: true,
    },
    asOneBackupRecordingTermsAccepted: {
      type: 'boolean',
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    serviceUserId: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentBalance: {
      type: 'number',
    },
    membersCount: {
      type: 'number',
    },
    workspacesCount: {
      type: 'number',
    },
    featureFlags: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
    Subscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminOrganizationsListOrganizationSubscriptionDto',
      },
    },
    BillingAccount: {
      $ref: '#/components/schemas/AdminOrganizationsListOrganizationBillingAccountDto',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'asOneAllowed',
    'asOneBackupRecordingTermsAccepted',
    'managementSource',
    'createdAt',
    'currentBalance',
    'membersCount',
    'workspacesCount',
    'featureFlags',
    'Subscriptions',
    'BillingAccount',
  ],
} as const;

export const $AdminOrganizationsListResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminOrganizationsListOrganizationDto',
      },
    },
    count: {
      type: 'number',
    },
    featureFlags: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
  },
  required: ['data', 'count', 'featureFlags'],
} as const;

export const $AdminGetAllOrganizationsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $AdminGetOrganizationResponseBillingAccountActiveSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    BillingConfiguration: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaBillingConfigurationDto',
        },
      ],
    },
    Product: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaSubscriptionProductDto',
        },
      ],
    },
  },
  required: [
    'id',
    'status',
    'allowedToChooseTranscriptUnlockType',
    'billingAccountId',
    'createdAt',
    'BillingConfiguration',
    'Product',
  ],
} as const;

export const $AdminGetOrganizationResponseBillingAccountDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    tierRate: {
      type: 'number',
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    fixedRate: {
      type: 'boolean',
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    freeCreditBalanceId: {
      type: 'string',
    },
    mainBalanceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    activeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    ActiveSubscription: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/AdminGetOrganizationResponseBillingAccountActiveSubscriptionDto',
        },
      ],
    },
    MainBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    FreeCreditBalance: {
      $ref: '#/components/schemas/PrismaBalanceDto',
    },
    DefaultBillingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
  },
  required: [
    'id',
    'name',
    'stripeCustomerId',
    'deleted',
    'autoRenew',
    'tierRate',
    'autoscriptOneFreeTrial',
    'fixedRate',
    'defaultBillingConfigurationId',
    'freeCreditBalanceId',
    'mainBalanceId',
    'createdAt',
    'ActiveSubscription',
    'MainBalance',
    'FreeCreditBalance',
    'DefaultBillingConfiguration',
  ],
} as const;

export const $AdminGetOrganizationResponseTeamDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    colour: {
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewJobs: {
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    members: {
      type: 'number',
    },
  },
  required: [
    'id',
    'default',
    'name',
    'slug',
    'colour',
    'owner',
    'viewRepositories',
    'editRepositories',
    'viewBilling',
    'manageBilling',
    'viewJobs',
    'editJobs',
    'reassignJobs',
    'deleteJobs',
    'submitJobs',
    'viewJobCost',
    'editJobTranscript',
    'proofreadJobTranscript',
    'finalizeJobTranscript',
    'markJobComplete',
    'viewReports',
    'manageMembers',
    'managePermissions',
    'manageWorkspaces',
    'manageOrganization',
    'viewLicenses',
    'manageLicenses',
    'organizationId',
    'createdAt',
  ],
} as const;

export const $AdminGetOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    asOneAllowed: {
      type: 'boolean',
      nullable: true,
    },
    asOneBackupRecordingTermsAccepted: {
      type: 'boolean',
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    serviceUserId: {
      type: 'string',
      nullable: true,
    },
    billingAccountId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    BillingAccount: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/AdminGetOrganizationResponseBillingAccountDto',
        },
      ],
    },
    Teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminGetOrganizationResponseTeamDto',
      },
    },
    workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/WorkspaceWithStatusesResponseDto',
      },
    },
    repositories: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RepositoryWithStatusesDto',
      },
    },
    membersCount: {
      type: 'number',
    },
    workspacesCount: {
      type: 'number',
    },
    currentBalance: {
      type: 'number',
    },
    tierRate: {
      type: 'number',
    },
    billingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'asOneAllowed',
    'asOneBackupRecordingTermsAccepted',
    'managementSource',
    'createdAt',
    'Teams',
    'workspaces',
    'repositories',
    'membersCount',
    'workspacesCount',
    'currentBalance',
    'tierRate',
  ],
} as const;

export const $AdminGetOrganizationLayoutsLayoutResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    templateName: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    creatorId: {
      type: 'string',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    deleted: {
      type: 'boolean',
    },
    organizationName: {
      type: 'string',
    },
    creatorName: {
      type: 'string',
    },
  },
  required: [
    'id',
    'name',
    'templateName',
    'organizationId',
    'creatorId',
    'createdAt',
    'deleted',
    'organizationName',
    'creatorName',
  ],
} as const;

export const $AdminGetOrganizationLayoutsResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminGetOrganizationLayoutsLayoutResponseDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $AdminCloneLayoutBodyDto = {
  type: 'object',
  properties: {
    targetOrganizationId: {
      type: 'string',
    },
  },
  required: ['targetOrganizationId'],
} as const;

export const $AdminLayoutResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    templateName: {
      type: 'string',
    },
    creatorId: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
    },
    creatorName: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    organizationName: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    docxDownloadLink: {
      type: 'string',
    },
    jsonDownloadLink: {
      type: 'string',
    },
  },
  required: [
    'id',
    'name',
    'templateName',
    'creatorId',
    'deleted',
    'creatorName',
    'organizationId',
    'organizationName',
    'createdAt',
  ],
} as const;

export const $PaginatedBillingAccountResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaBillingAccountDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $AdminBillingAccountSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    stripeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    stripeSubscriptionItemId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['active', 'canceled', 'incomplete', 'incomplete_expired', 'past_due', 'trialing', 'unpaid', 'paused'],
      type: 'string',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    billingAccountId: {
      type: 'string',
    },
    productId: {
      type: 'string',
      nullable: true,
    },
    freeTrialEndDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    currentPeriodEnd: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    billingConfigurationId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Product: {
      $ref: '#/components/schemas/PrismaSubscriptionProductDto',
    },
    BillingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
    licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaLicenseDto',
      },
    },
  },
  required: ['id', 'status', 'allowedToChooseTranscriptUnlockType', 'billingAccountId', 'createdAt', 'licenses'],
} as const;

export const $AdminBillingAccountResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    stripeCustomerId: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    autoRenew: {
      type: 'boolean',
      nullable: true,
    },
    tierRate: {
      type: 'number',
    },
    autoscriptOneFreeTrial: {
      type: 'boolean',
      nullable: true,
    },
    fixedRate: {
      type: 'boolean',
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    freeCreditBalanceId: {
      type: 'string',
    },
    mainBalanceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    activeSubscriptionId: {
      type: 'string',
      nullable: true,
    },
    billingConfiguration: {
      $ref: '#/components/schemas/PrismaBillingConfigurationDto',
    },
    organization: {
      $ref: '#/components/schemas/PrismaOrganizationDto',
    },
    subscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminBillingAccountSubscriptionDto',
      },
    },
  },
  required: [
    'id',
    'name',
    'stripeCustomerId',
    'deleted',
    'autoRenew',
    'tierRate',
    'autoscriptOneFreeTrial',
    'fixedRate',
    'defaultBillingConfigurationId',
    'freeCreditBalanceId',
    'mainBalanceId',
    'createdAt',
    'billingConfiguration',
    'organization',
    'subscriptions',
  ],
} as const;

export const $AdminTransactionListItemDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    codeId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    realTimePending: {
      type: 'boolean',
      nullable: true,
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    dontUseForBalanceCalculation: {
      type: 'boolean',
      nullable: true,
    },
    balanceId: {
      type: 'string',
    },
    organization: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaOrganizationDto',
        },
      ],
    },
    userResponsibleName: {
      type: 'string',
      nullable: true,
    },
    userResponsibleEmail: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'amount', 'codeId', 'title', 'description', 'createdAt', 'balanceId'],
} as const;

export const $AdminTransactionsListResponseDto = {
  type: 'object',
  properties: {
    data: {
      description: 'List of transactions with organization and creator info',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminTransactionListItemDto',
      },
    },
    count: {
      type: 'number',
      description: 'Total count of transactions',
    },
  },
  required: ['data', 'count'],
} as const;

export const $AdminTransactionBodyDto = {
  type: 'object',
  properties: {
    amount: {
      type: 'number',
      description: 'Amount of the transaction',
    },
    code: {
      enum: [
        'GL1000',
        'GL1001',
        'GL2000',
        'GL2001',
        'GL2003',
        'GL2002',
        'GL2005',
        'GL2006',
        'GL2004',
        'GL2007',
        'GL2008',
        'GL2100',
        'GL4000',
        'GL4001',
        'GL4002',
        'GL4003',
        'GL5000',
        'GL5001',
        'GL5002',
        'GL5003',
        'GL6000',
        'GL6666',
        'GL6667',
        'GL6669',
        'GL6671',
        'GL6672',
        'GL6668',
        'GL6670',
        'GL6250',
        'GL6251',
        'GL6252',
        'GL7000',
        'GL7001',
        'GL8000',
        'GL8001',
        'GL9000',
      ],
      type: 'string',
      description: 'Transaction code',
    },
    note: {
      type: 'string',
      description: 'Note for the transaction',
    },
  },
  required: ['amount', 'code', 'note'],
} as const;

export const $AdminAddAdminTransactionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $AddMainBalanceToBillingAccountBodyDto = {
  type: 'object',
  properties: {
    amount: {
      type: 'number',
      description: 'Amount to add to the Free Credit billing account',
    },
  },
  required: ['amount'],
} as const;

export const $AdminAddMainBalanceToBillingAccountResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $SetBillingAccountRateBodyDto = {
  type: 'object',
  properties: {
    fixed: {
      type: 'boolean',
      description: 'Whether the rate is fixed',
    },
    rate: {
      type: 'number',
      description: 'Rate value',
    },
  },
  required: ['fixed', 'rate'],
} as const;

export const $AdminSetBillingAccountRateResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $SetBillingAccountRatesBodyDto = {
  type: 'object',
  properties: {
    realTimeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    realTimeRate: {
      type: 'number',
    },
    postProcessingRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    postProcessingRate: {
      type: 'number',
    },
    partialUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    partialUnlockRate: {
      type: 'number',
    },
    fullUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockChargeType: {
      enum: ['PAY_DIFFERENCE', 'ADDITIONAL_CHARGE'],
      type: 'string',
      default: 'PAY_DIFFERENCE',
    },
    fullUnlockRate: {
      type: 'number',
    },
    enhancedOnDemandRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    enhancedOnDemandRate: {
      type: 'number',
    },
    attorneyConnectFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRate: {
      type: 'number',
    },
    attorneyInviteFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyInviteFeeRate: {
      type: 'number',
    },
  },
  required: [
    'realTimeRateType',
    'realTimeRate',
    'postProcessingRateType',
    'postProcessingRate',
    'partialUnlockRateType',
    'partialUnlockRate',
    'fullUnlockRateType',
    'fullUnlockRate',
    'enhancedOnDemandRateType',
    'enhancedOnDemandRate',
    'attorneyConnectFeeRateType',
    'attorneyConnectFeeRate',
    'attorneyInviteFeeRateType',
    'attorneyInviteFeeRate',
  ],
} as const;

export const $AdminSetBillingAccountRatesResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $AdminPauseSubscriptionCollectionBodyDto = {
  type: 'object',
  properties: {
    subscriptionId: {
      type: 'string',
      description: 'Subscription ID to pause collection on',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
  },
  required: ['subscriptionId'],
} as const;

export const $AdminPauseSubscriptionCollectionPauseDto = {
  type: 'object',
  properties: {
    behavior: {
      type: 'string',
      example: 'void',
    },
  },
  required: ['behavior'],
} as const;

export const $AdminPauseSubscriptionCollectionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      example: true,
    },
    subscriptionId: {
      type: 'string',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    stripeSubscriptionId: {
      type: 'string',
      example: 'sub_1234567890',
    },
    pauseCollection: {
      nullable: true,
      description: 'Stripe pause collection details',
      example: {
        behavior: 'void',
      },
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/AdminPauseSubscriptionCollectionPauseDto',
        },
      ],
    },
  },
  required: ['success', 'subscriptionId', 'stripeSubscriptionId'],
} as const;

export const $AdminCancelSubscriptionBodyDto = {
  type: 'object',
  properties: {
    subscriptionId: {
      type: 'string',
      description: 'Subscription ID to cancel at period end',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
  },
  required: ['subscriptionId'],
} as const;

export const $AdminCancelSubscriptionResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      example: true,
    },
    subscriptionId: {
      type: 'string',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    stripeSubscriptionId: {
      type: 'string',
      example: 'sub_1234567890',
    },
    cancelAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
      example: '2025-12-31T23:59:59.000Z',
    },
    cancelAtPeriodEnd: {
      type: 'boolean',
      example: true,
    },
  },
  required: ['success', 'subscriptionId', 'stripeSubscriptionId', 'cancelAtPeriodEnd'],
} as const;

export const $AdminCancelSubscriptionAndVoidInvoiceBodyDto = {
  type: 'object',
  properties: {
    subscriptionId: {
      type: 'string',
      description: 'Subscription ID to cancel immediately and void last invoice',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
  },
  required: ['subscriptionId'],
} as const;

export const $AdminCancelSubscriptionAndVoidInvoiceResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      example: true,
    },
    subscriptionId: {
      type: 'string',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    stripeSubscriptionId: {
      type: 'string',
      example: 'sub_1234567890',
    },
    canceledAt: {
      type: 'string',
      format: 'date-time',
      example: '2025-11-24T12:00:00.000Z',
    },
    voidedInvoiceId: {
      type: 'string',
      nullable: true,
      example: 'in_1234567890',
    },
    voidedInvoiceStatus: {
      type: 'string',
      nullable: true,
      example: 'void',
    },
  },
  required: ['success', 'subscriptionId', 'stripeSubscriptionId', 'canceledAt'],
} as const;

export const $AdminWorkspaceOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $AdminWorkspaceListItemWithOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    editorsNotifications: {
      type: 'boolean',
      nullable: true,
    },
    proofreadersNotifications: {
      type: 'boolean',
      nullable: true,
    },
    jobSubmissionNotifications: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    Organization: {
      $ref: '#/components/schemas/AdminWorkspaceOrganizationResponseDto',
    },
  },
  required: [
    'id',
    'name',
    'slug',
    'deleted',
    'editorsNotifications',
    'proofreadersNotifications',
    'jobSubmissionNotifications',
    'organizationId',
    'createdAt',
    'Organization',
  ],
} as const;

export const $AdminWorkspacesListResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminWorkspaceListItemWithOrganizationResponseDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $AdminWorkspaceListItemResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Workspace ID',
    },
    name: {
      type: 'string',
      description: 'Workspace name',
    },
    slug: {
      type: 'string',
      description: 'Workspace slug',
    },
    organizationId: {
      type: 'string',
      nullable: true,
      description: 'Organization ID',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $AdminUserDetailsTeamDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug', 'organizationId'],
} as const;

export const $AdminUserDetailsOrgRelationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    image: {
      type: 'string',
      nullable: true,
    },
    deleted: {
      type: 'boolean',
      nullable: true,
    },
    userCount: {
      type: 'number',
    },
    wsCount: {
      type: 'number',
    },
  },
  required: ['id', 'name', 'slug', 'deleted', 'userCount', 'wsCount'],
} as const;

export const $AdminUserDetailsWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug', 'organizationId'],
} as const;

export const $AdminUserDetailsResultDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminUserDetailsTeamDto',
      },
    },
    orgRelations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminUserDetailsOrgRelationDto',
      },
    },
    workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminUserDetailsWorkspaceDto',
      },
    },
  },
  required: ['id', 'name', 'lastname', 'email', 'phone', 'teams', 'orgRelations', 'workspaces'],
} as const;

export const $AdminUserDetailsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the request succeeded',
    },
    result: {
      description: 'User details when success is true',
      allOf: [
        {
          $ref: '#/components/schemas/AdminUserDetailsResultDto',
        },
      ],
    },
    error: {
      type: 'string',
      description: 'Error message when success is false',
    },
  },
  required: ['success'],
} as const;

export const $WorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $OrganizationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    workspaces: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/WorkspaceDto',
      },
    },
  },
  required: ['id', 'name', 'workspaces'],
} as const;

export const $AdminGetUserOrganizationsByEmailResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'User ID',
    },
    organizations: {
      description: 'List of organizations and their workspaces the user belongs to',
      type: 'array',
      items: {
        $ref: '#/components/schemas/OrganizationDto',
      },
    },
  },
  required: ['id', 'organizations'],
} as const;

export const $AdminUsersResponseUserDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
    phone: {
      type: 'string',
    },
    company: {
      type: 'string',
    },
    accountType: {
      type: 'string',
    },
    profile: {
      type: 'object',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    agreement: {
      type: 'boolean',
    },
    haveSeenOnboarding: {
      type: 'boolean',
    },
    org: {
      type: 'string',
    },
    asrUsage: {
      type: 'number',
    },
    createdByAdmin: {
      type: 'boolean',
    },
    downloadedDesktop: {
      type: 'boolean',
    },
    signedInWithDesktop: {
      type: 'boolean',
    },
    signupUrl: {
      type: 'string',
    },
    emailVerified: {
      type: 'boolean',
    },
    confirmed: {
      type: 'boolean',
    },
    disabled: {
      type: 'boolean',
    },
    elasticKey: {
      type: 'string',
    },
    howDidYouHearAboutUs: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastActiveDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastIpAddress: {
      type: 'string',
      nullable: true,
    },
    hasClaimedFreeBalance: {
      type: 'boolean',
    },
    organizations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaOrganizationDto',
      },
    },
  },
  required: [
    'id',
    'name',
    'lastname',
    'phone',
    'company',
    'accountType',
    'profile',
    'email',
    'roles',
    'agreement',
    'haveSeenOnboarding',
    'org',
    'asrUsage',
    'createdByAdmin',
    'downloadedDesktop',
    'signedInWithDesktop',
    'signupUrl',
    'emailVerified',
    'confirmed',
    'disabled',
    'elasticKey',
    'createdAt',
    'hasClaimedFreeBalance',
    'organizations',
  ],
} as const;

export const $AdminUsersResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminUsersResponseUserDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $ToggleAdminRoleBodyDto = {
  type: 'object',
  properties: {
    role: {
      type: 'string',
    },
    value: {
      type: 'boolean',
    },
  },
  required: ['role', 'value'],
} as const;

export const $AdminToggleAdminRoleResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $SetUserDisabledBodyDto = {
  type: 'object',
  properties: {
    disabled: {
      type: 'boolean',
      description: 'User disabled state',
    },
  },
  required: ['disabled'],
} as const;

export const $AdminSetUserDisabledResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $CreateNewASOnePlanBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    public: {
      type: 'boolean',
    },
    trialPeriodDays: {
      type: 'number',
    },
    price: {
      type: 'number',
    },
    freeSeats: {
      type: 'number',
    },
    asrRate: {
      type: 'number',
    },
    postRate: {
      type: 'number',
    },
    reporterUnlockRate: {
      type: 'number',
    },
    fullUnlockRate: {
      type: 'number',
    },
    enhancedOnDemandRate: {
      type: 'number',
    },
    asrRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    postRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    reporterUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockChargeType: {
      enum: ['PAY_DIFFERENCE', 'ADDITIONAL_CHARGE'],
      type: 'string',
      default: 'PAY_DIFFERENCE',
    },
    enhancedOnDemandRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRate: {
      type: 'number',
    },
    attorneyInviteFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyInviteFeeRate: {
      type: 'number',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    audioHoursPerMonth: {
      type: 'number',
    },
    unlimitedHoursPerMonth: {
      type: 'boolean',
    },
    inPersonCaptureChannels: {
      type: 'number',
    },
    realtimeASREnabled: {
      type: 'boolean',
    },
  },
  required: [
    'name',
    'description',
    'public',
    'trialPeriodDays',
    'price',
    'freeSeats',
    'asrRate',
    'postRate',
    'reporterUnlockRate',
    'fullUnlockRate',
    'enhancedOnDemandRate',
    'asrRateType',
    'postRateType',
    'reporterUnlockRateType',
    'fullUnlockRateType',
    'enhancedOnDemandRateType',
    'attorneyConnectFeeRateType',
    'attorneyConnectFeeRate',
    'attorneyInviteFeeRateType',
    'attorneyInviteFeeRate',
    'allowedToChooseTranscriptUnlockType',
    'audioHoursPerMonth',
    'unlimitedHoursPerMonth',
    'inPersonCaptureChannels',
    'realtimeASREnabled',
  ],
} as const;

export const $EditASOnePlanBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    index: {
      type: 'number',
    },
    type: {
      type: 'string',
    },
    public: {
      type: 'boolean',
    },
    trialPeriodDays: {
      type: 'number',
    },
    freeSeats: {
      type: 'number',
    },
    price: {
      type: 'number',
    },
    stripeProductId: {
      type: 'string',
      nullable: true,
    },
    stripeItemPriceId: {
      type: 'string',
      nullable: true,
    },
    defaultBillingConfigurationId: {
      type: 'string',
    },
    asrRate: {
      type: 'number',
    },
    postRate: {
      type: 'number',
    },
    reporterUnlockRate: {
      type: 'number',
    },
    fullUnlockRate: {
      type: 'number',
    },
    enhancedOnDemandRate: {
      type: 'number',
    },
    asrRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    postRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    reporterUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    fullUnlockChargeType: {
      enum: ['PAY_DIFFERENCE', 'ADDITIONAL_CHARGE'],
      type: 'string',
      default: 'PAY_DIFFERENCE',
    },
    enhancedOnDemandRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyConnectFeeRate: {
      type: 'number',
    },
    attorneyInviteFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    rushLabelFeeRate: {
      type: 'number',
    },
    rushLabelFeeRateType: {
      enum: ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'],
      type: 'string',
    },
    attorneyInviteFeeRate: {
      type: 'number',
    },
    allowedToChooseTranscriptUnlockType: {
      type: 'boolean',
    },
    audioHoursPerMonth: {
      type: 'number',
    },
    unlimitedHoursPerMonth: {
      type: 'boolean',
    },
    inPersonCaptureChannels: {
      type: 'number',
    },
    realtimeASREnabled: {
      type: 'boolean',
    },
  },
  required: [
    'name',
    'description',
    'index',
    'type',
    'public',
    'trialPeriodDays',
    'freeSeats',
    'price',
    'asrRate',
    'postRate',
    'reporterUnlockRate',
    'fullUnlockRate',
    'enhancedOnDemandRate',
    'asrRateType',
    'postRateType',
    'reporterUnlockRateType',
    'fullUnlockRateType',
    'enhancedOnDemandRateType',
    'attorneyConnectFeeRateType',
    'attorneyConnectFeeRate',
    'attorneyInviteFeeRateType',
    'rushLabelFeeRate',
    'rushLabelFeeRateType',
    'attorneyInviteFeeRate',
    'allowedToChooseTranscriptUnlockType',
    'audioHoursPerMonth',
    'unlimitedHoursPerMonth',
    'inPersonCaptureChannels',
    'realtimeASREnabled',
  ],
} as const;

export const $PrismaTransactionCodeDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    direction: {
      enum: ['credit', 'debit'],
      type: 'string',
    },
    status: {
      enum: ['charge', 'credit', 'refund', 'purchase', 'adjustment', 'payment', 'subscription'],
      type: 'string',
    },
  },
  required: ['code', 'name', 'description', 'direction', 'status'],
} as const;

export const $JobsReportTransactionDTO = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    codeId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    realTimePending: {
      type: 'boolean',
      nullable: true,
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    dontUseForBalanceCalculation: {
      type: 'boolean',
      nullable: true,
    },
    balanceId: {
      type: 'string',
    },
    code: {
      $ref: '#/components/schemas/PrismaTransactionCodeDto',
    },
  },
  required: ['id', 'amount', 'codeId', 'title', 'description', 'createdAt', 'balanceId', 'code'],
} as const;

export const $PrismaJobPipelineTimestampDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    attemptId: {
      type: 'string',
    },
    submitJob: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingConsumerStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorDownloadingFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorFfmpegProcessingStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputWavStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputMp3Started: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorCleanTemporaryFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingFinished: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    sliceSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    reTranscribeSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    llmTranscriptCreationStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterStartedProcessing: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterGotResultFromTranscriptService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['jobId', 'attemptId'],
} as const;

export const $JobsReportDTO = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    jobName: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    deadline: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    status: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    fileSize: {
      type: 'string',
    },
    fileExtension: {
      type: 'string',
    },
    price: {
      type: 'number',
    },
    meetingId: {
      type: 'string',
    },
    editingProgress: {
      type: 'number',
    },
    paymentModelName: {
      type: 'string',
    },
    organization: {
      $ref: '#/components/schemas/PrismaOrganizationDto',
    },
    workspace: {
      $ref: '#/components/schemas/PrismaWorkspaceDto',
    },
    refunded: {
      type: 'boolean',
    },
    removed: {
      type: 'boolean',
    },
    Transactions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobsReportTransactionDTO',
      },
    },
    asOneLocked: {
      type: 'boolean',
    },
    jobPipelineTimestamps: {
      $ref: '#/components/schemas/PrismaJobPipelineTimestampDto',
    },
    partialUnlocked: {
      type: 'boolean',
    },
  },
  required: [
    'id',
    'email',
    'name',
    'lastname',
    'createdAt',
    'status',
    'fileSize',
    'fileExtension',
    'editingProgress',
    'refunded',
    'removed',
  ],
} as const;

export const $JobReportResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobsReportDTO',
      },
    },
    count: {
      type: 'number',
    },
  },
  required: ['data', 'count'],
} as const;

export const $AdminJobPipelineTimestampsDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    attemptId: {
      type: 'string',
    },
    submitJob: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingConsumerStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorDownloadingFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorFfmpegProcessingStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputWavStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputMp3Started: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorCleanTemporaryFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingFinished: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    sliceSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    reTranscribeSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    llmTranscriptCreationStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterStartedProcessing: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterGotResultFromTranscriptService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
} as const;

export const $AdminJobLlmCallDto = {
  type: 'object',
  properties: {
    pipelineAttemptId: {
      type: 'string',
      nullable: true,
    },
    promptSlug: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    inputModel: {
      type: 'string',
    },
    outputModel: {
      type: 'string',
    },
    promptTokens: {
      type: 'number',
      nullable: true,
    },
    completionTokens: {
      type: 'number',
      nullable: true,
    },
    totalTokens: {
      type: 'number',
      nullable: true,
    },
    requestedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    durationMs: {
      type: 'number',
      nullable: true,
    },
    serviceTier: {
      type: 'string',
      nullable: true,
    },
    responseId: {
      type: 'string',
      nullable: true,
    },
    source: {
      type: 'string',
    },
  },
} as const;

export const $AdminJobDetailsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    creatorId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
    statusChangeDate: {
      type: 'string',
      format: 'date-time',
    },
    deadline: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    notes: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    reportedByAdmin: {
      type: 'boolean',
    },
    abandonedProcessing: {
      type: 'boolean',
    },
    multipleFilesHandling: {
      type: 'string',
      nullable: true,
    },
    reportingType: {
      type: 'string',
    },
    status: {
      type: 'string',
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
    },
    removed: {
      type: 'boolean',
    },
    deletedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    deletedByUserId: {
      type: 'string',
      nullable: true,
    },
    rushed: {
      type: 'boolean',
    },
    submitted: {
      type: 'boolean',
    },
    results: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    keyTerms: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAttachment',
      },
    },
    reporterNotes: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    sourceFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    backupFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    exhibitFiles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    filesCount: {
      type: 'number',
    },
    bucket: {
      type: 'string',
    },
    region: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    repository: {
      $ref: '#/components/schemas/JobDtoRepository',
    },
    editingProgress: {
      type: 'number',
    },
    transcriptConfidence: {
      type: 'number',
    },
    averageJobAudioScore: {
      type: 'number',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    assignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    draftAssigneeId: {
      type: 'string',
      nullable: true,
    },
    assigneeComment: {
      type: 'string',
      nullable: true,
    },
    draftAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    assigneeHistory: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    comments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoComment',
      },
    },
    workspaceId: {
      type: 'string',
    },
    workspaceSlug: {
      type: 'string',
    },
    workspaceName: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    scheduledDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    meetingTime: {
      type: 'string',
      nullable: true,
    },
    meetingTimezone: {
      type: 'string',
      nullable: true,
    },
    meetingAddress: {
      type: 'string',
      nullable: true,
    },
    meetingLink: {
      type: 'string',
      nullable: true,
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    meetingAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    checkoutEvents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoCheckoutEvent',
      },
    },
    versions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoVersion',
      },
    },
    asOneLocked: {
      type: 'boolean',
    },
    processedAudioFilename: {
      type: 'string',
    },
    playbackAudioFilename: {
      type: 'string',
    },
    layoutId: {
      type: 'string',
      nullable: true,
    },
    layoutName: {
      type: 'string',
    },
    partialUnlocked: {
      type: 'boolean',
    },
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    speakerLabels: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    enhancedCharged: {
      type: 'boolean',
    },
    attorneyAccesses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobResponseAttorneyAccessDto',
      },
    },
    attorneyPasscodes: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaAttorneyPasscodeDto',
      },
    },
    watchers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoWatcher',
      },
    },
    noShow: {
      type: 'boolean',
    },
    pipelineErrorMessage: {
      type: 'string',
    },
    clonedFromJobId: {
      type: 'string',
      nullable: true,
    },
    clonedFromEnvironment: {
      type: 'string',
      nullable: true,
    },
    jobPipelineTimestamps: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/AdminJobPipelineTimestampsDto',
        },
      ],
    },
    media: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaMediaDto',
      },
    },
    transcriptId: {
      type: 'string',
      nullable: true,
    },
    organization: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/PrismaOrganizationDto',
        },
      ],
    },
    llmCalls: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdminJobLlmCallDto',
      },
    },
    speakerLabellingQualityScore: {
      type: 'string',
      nullable: true,
      enum: ['good', 'partial', 'bad', 'unknown'],
      description: 'ASOne speaker labelling quality score for enhanced jobs, cached from scenario.json',
    },
    speakerLabellingQualityNotes: {
      type: 'string',
      nullable: true,
      description: 'Rationale for the speaker labelling quality score, cached from scenario.json',
    },
    assemblyTranscriptId: {
      type: 'string',
      nullable: true,
      description:
        'Direct AssemblyAI transcript ID only. Null for ASR Proxy submissions; never used to route proxy retrieval.',
    },
    asrProxyTranscriptId: {
      type: 'string',
      nullable: true,
      description:
        'ASR proxy job ID from the latest submission route, or from saved transcript provenance when no webhook route exists',
    },
    providerTranscriptId: {
      type: 'string',
      nullable: true,
      description:
        'Transcript ID assigned by the ASR provider itself. Equals assemblyTranscriptId for direct submissions; for ASR Proxy submissions it comes from the saved provenance or from the proxy job attempts.',
    },
    asrProxyProvider: {
      type: 'string',
      nullable: true,
      description: 'ASR provider that produced the saved proxy transcript, taken from its provenance',
    },
    asrProxyModel: {
      type: 'string',
      nullable: true,
      description: 'ASR proxy model that produced the saved proxy transcript, taken from its provenance',
    },
  },
  required: [
    'id',
    'notes',
    'name',
    'reportedByAdmin',
    'abandonedProcessing',
    'status',
    'results',
    'attachments',
    'filesCount',
    'workspaceId',
    'noShow',
  ],
} as const;

export const $AdminGetJobAssigneeHistoryResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    result: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    error: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $TriggerEnhanceOnDemandResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
  },
  required: ['success'],
} as const;

export const $TriggerLLMTranscriptIssueReportResponseDto = {
  type: 'object',
  properties: {
    workflowId: {
      type: 'string',
    },
  },
  required: ['workflowId'],
} as const;

export const $LLMTranscriptIssueReportStatsDto = {
  type: 'object',
  properties: {
    total_issues: {
      type: 'number',
    },
    by_category: {
      type: 'object',
      additionalProperties: {
        type: 'number',
      },
    },
    by_confidence: {
      type: 'object',
      additionalProperties: {
        type: 'number',
      },
    },
  },
  required: ['total_issues', 'by_category', 'by_confidence'],
} as const;

export const $LLMTranscriptIssueTimestampRangeDto = {
  type: 'object',
  properties: {
    start_ms: {
      type: 'number',
    },
    end_ms: {
      type: 'number',
    },
  },
  required: ['start_ms', 'end_ms'],
} as const;

export const $LLMTranscriptDetectedIssueDto = {
  type: 'object',
  properties: {
    issue_id: {
      type: 'string',
    },
    chunk_index: {
      type: 'number',
    },
    timestamp_range: {
      $ref: '#/components/schemas/LLMTranscriptIssueTimestampRangeDto',
    },
    speaker: {
      type: 'string',
      nullable: true,
    },
    category: {
      type: 'string',
      example: 'homophone_confusion',
    },
    before: {
      type: 'string',
    },
    after: {
      type: 'string',
    },
    issue: {
      type: 'string',
    },
    confidence: {
      type: 'string',
      enum: ['high', 'medium', 'low'],
    },
  },
  required: ['issue_id', 'chunk_index', 'timestamp_range', 'category', 'before', 'after', 'issue', 'confidence'],
} as const;

export const $LLMTranscriptIssueReportDto = {
  type: 'object',
  properties: {
    version: {
      type: 'number',
    },
    job_id: {
      type: 'string',
    },
    environment: {
      type: 'string',
    },
    source_key: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    generated_at: {
      type: 'string',
    },
    summary: {
      type: 'string',
    },
    stats: {
      $ref: '#/components/schemas/LLMTranscriptIssueReportStatsDto',
    },
    issues: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/LLMTranscriptDetectedIssueDto',
      },
    },
  },
  required: ['version', 'job_id', 'environment', 'source_key', 'model', 'generated_at', 'summary', 'stats', 'issues'],
} as const;

export const $LLMTranscriptIssueFixDto = {
  type: 'object',
  properties: {
    issue_id: {
      type: 'string',
    },
    apply: {
      type: 'boolean',
    },
    before: {
      type: 'string',
    },
    after: {
      type: 'string',
    },
    reason: {
      type: 'string',
    },
  },
  required: ['issue_id', 'apply', 'before', 'after', 'reason'],
} as const;

export const $LLMTranscriptIssueFixReportDto = {
  type: 'object',
  properties: {
    job_id: {
      type: 'string',
    },
    environment: {
      type: 'string',
    },
    source_key: {
      type: 'string',
    },
    issue_report_key: {
      type: 'string',
    },
    fixed_transcript_key: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    generated_at: {
      type: 'string',
    },
    applied: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/LLMTranscriptIssueFixDto',
      },
    },
    rejected: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/LLMTranscriptIssueFixDto',
      },
    },
  },
  required: [
    'job_id',
    'environment',
    'source_key',
    'issue_report_key',
    'fixed_transcript_key',
    'model',
    'generated_at',
    'applied',
    'rejected',
  ],
} as const;

export const $GetLLMTranscriptIssueReportResponseDto = {
  type: 'object',
  properties: {
    report: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/LLMTranscriptIssueReportDto',
        },
      ],
    },
    fixReport: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/LLMTranscriptIssueFixReportDto',
        },
      ],
    },
    hasFixedTranscript: {
      type: 'boolean',
      description: 'True when the fixed transcript JSON exists in S3 for this job',
    },
  },
  required: ['hasFixedTranscript'],
} as const;

export const $GetSettingsResponseSetting = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    value: {
      type: 'string',
    },
  },
  required: ['name', 'value'],
} as const;

export const $GetSettingsResponseEnv = {
  type: 'object',
  properties: {
    ENVIRONMENT: {
      type: 'string',
    },
    AWSBUCKET: {
      type: 'string',
    },
  },
  required: ['ENVIRONMENT', 'AWSBUCKET'],
} as const;

export const $GetSettingsResponse = {
  type: 'object',
  properties: {
    settings: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetSettingsResponseSetting',
      },
    },
    env: {
      $ref: '#/components/schemas/GetSettingsResponseEnv',
    },
  },
  required: ['settings', 'env'],
} as const;

export const $UpdateSettingBodyDto = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
    },
  },
  required: ['value'],
} as const;

export const $AdminUpdateSettingResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    code: {
      type: 'number',
    },
    message: {
      type: 'string',
    },
  },
  required: ['success'],
} as const;

export const $WordDto = {
  type: 'object',
  properties: {
    text: {
      type: 'string',
      description: 'The text content of the word',
    },
    start: {
      type: 'number',
      description: 'The start time of the word in milliseconds',
    },
    confidence: {
      type: 'number',
      description: 'The confidence score of the word',
    },
  },
  required: ['text', 'start'],
} as const;

export const $UtteranceDto = {
  type: 'object',
  properties: {
    index: {
      type: 'number',
      description: 'Optional index for reordering',
    },
    start: {
      type: 'number',
      description: 'The start time of the utterance in milliseconds',
    },
    end: {
      type: 'number',
      description: 'The end time of the utterance in milliseconds',
    },
    speaker: {
      type: 'string',
      description: 'The speaker identifier',
    },
    text: {
      type: 'string',
      description: 'The text content of the utterance',
    },
    words: {
      description: 'The individual words in the utterance',
      type: 'array',
      items: {
        $ref: '#/components/schemas/WordDto',
      },
    },
    confidence: {
      type: 'number',
      description: 'The confidence score of the utterance',
    },
  },
  required: ['start', 'speaker', 'text', 'words'],
} as const;

export const $GetJobUtterancesResponseDto = {
  type: 'object',
  properties: {
    utterances: {
      description: 'The list of utterances',
      type: 'array',
      items: {
        $ref: '#/components/schemas/UtteranceDto',
      },
    },
    availableTranscripts: {
      description: 'List of available transcript types',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    hasSpeakerNames: {
      type: 'boolean',
      description: 'Whether the transcript has speaker names',
    },
    hasUserRenamedSpeakers: {
      type: 'boolean',
      description: 'Whether the user has renamed speakers',
    },
    text: {
      type: 'string',
      description: 'Full transcript text',
    },
    id: {
      type: 'string',
      description: 'The transcript identifier',
    },
    confidence: {
      type: 'number',
      description: 'The confidence score of the transcript',
    },
    asrModel: {
      type: 'string',
      description: 'ASR model used to produce the transcript',
    },
  },
  required: ['utterances', 'availableTranscripts'],
} as const;

export const $SpeakerDto = {
  type: 'object',
  properties: {
    post_asr_label: {
      type: 'string',
      example: 'Speaker A',
    },
    role: {
      type: 'string',
      example: 'PLAINTIFF ATTORNEY',
    },
    honorific_prefix: {
      type: 'string',
      example: 'Ms.',
    },
    first_name: {
      type: 'string',
      example: 'Terry',
    },
    last_name: {
      type: 'string',
      example: 'Seligman',
    },
    full_name: {
      type: 'string',
      example: 'Terry Seligman',
    },
    real_time_asr_label: {
      type: 'string',
      example: 'MS. SELIGMAN',
    },
  },
  required: [
    'post_asr_label',
    'role',
    'honorific_prefix',
    'first_name',
    'last_name',
    'full_name',
    'real_time_asr_label',
  ],
} as const;

export const $MetadataDto = {
  type: 'object',
  properties: {
    speakers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SpeakerDto',
      },
    },
    proceeding_type: {
      type: 'string',
      example: 'Deposition',
    },
    summary: {
      type: 'string',
      example:
        'This proceeding is a deposition of Ms. Jacob, a senior environmental project manager at Cancun Farms, conducted by Ms. Seligman, who represents plaintiff Moonlight Plaza Associates. ...',
    },
  },
  required: ['speakers', 'proceeding_type', 'summary'],
} as const;

export const $GetEnhancementsResponseDto = {
  type: 'object',
  properties: {
    metadata: {
      $ref: '#/components/schemas/MetadataDto',
    },
  },
  required: ['metadata'],
} as const;

export const $TriggerJobResponseDto = {
  type: 'object',
  properties: {
    ok: {
      type: 'boolean',
      description: 'Whether the job event was triggered successfully',
    },
  },
  required: ['ok'],
} as const;

export const $PrismaJobPipelineTimestampsHistoryDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    attemptId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    jobId: {
      type: 'string',
    },
    submitJob: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingConsumerStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorDownloadingFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorFfmpegProcessingStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputWavStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorUploadOutputMp3Started: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorCleanTemporaryFilesStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorPreprocessingFinished: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    preprocessorSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    sliceSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    reTranscribeSegmentsStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    llmTranscriptCreationStarted: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterStartedProcessing: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterGotResultFromTranscriptService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    submitterSentToNextService: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'createdAt', 'jobId'],
} as const;

export const $JobPipelineTimestampsHistoryResponseDto = {
  type: 'object',
  properties: {
    data: {
      description: 'List of pipeline timestamp history records',
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaJobPipelineTimestampsHistoryDto',
      },
    },
  },
  required: ['data'],
} as const;

export const $AlignmentItemDto = {
  type: 'object',
  properties: {
    rawText: {
      type: 'string',
    },
    rawSpeaker: {
      type: 'string',
    },
    editedText: {
      type: 'string',
    },
    editedSpeaker: {
      type: 'string',
    },
    similarity: {
      type: 'number',
    },
    rawTurnIndex: {
      type: 'number',
    },
    editedTurnIndex: {
      type: 'number',
    },
  },
  required: ['rawText', 'rawSpeaker', 'editedText', 'editedSpeaker', 'similarity', 'rawTurnIndex', 'editedTurnIndex'],
} as const;

export const $ASOneEditsResponseDto = {
  type: 'object',
  properties: {
    edits: {
      description: 'List of alignment edits',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AlignmentItemDto',
      },
    },
  },
  required: ['edits'],
} as const;

export const $PrismaAttorneyAccessDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    connected: {
      type: 'boolean',
    },
    recordingSessionId: {
      type: 'string',
    },
    disabledByAdmin: {
      type: 'boolean',
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'email', 'connected', 'recordingSessionId', 'disabledByAdmin', 'createdAt'],
} as const;

export const $PaginatedAttorneyAccessResponseDtoItem = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    connected: {
      type: 'boolean',
    },
    recordingSessionId: {
      type: 'string',
    },
    disabledByAdmin: {
      type: 'boolean',
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    registered: {
      type: 'boolean',
    },
    emailVerified: {
      type: 'boolean',
    },
    RecordingSession: {
      $ref: '#/components/schemas/PrismaRecordingSessionDto',
    },
  },
  required: [
    'id',
    'email',
    'connected',
    'recordingSessionId',
    'disabledByAdmin',
    'createdAt',
    'registered',
    'emailVerified',
    'RecordingSession',
  ],
} as const;

export const $PaginatedAttorneyAccessResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PaginatedAttorneyAccessResponseDtoItem',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $GetAttorneyUsersResponseUserDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'ID',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    email: {
      type: 'string',
      description: 'email',
      example: '123@asdf.cc',
    },
    emailVerified: {
      type: 'string',
      description: 'Is email verified (contains null or date)',
      example: 'null',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
      description: 'createdAt',
    },
  },
  required: ['id', 'email', 'createdAt'],
} as const;

export const $GetAttorneyUsersResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
      description: 'Total number of results',
      example: 5,
    },
    data: {
      description: 'Users',
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetAttorneyUsersResponseUserDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $PaginatedAttorneyPasscodeResponseDtoItem = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
      nullable: true,
    },
    passcode: {
      type: 'string',
      nullable: true,
    },
    recordingSessionId: {
      type: 'string',
    },
    inviterId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    RecordingSession: {
      $ref: '#/components/schemas/PrismaRecordingSessionDto',
    },
  },
  required: ['id', 'recordingSessionId', 'createdAt', 'RecordingSession'],
} as const;

export const $PaginatedAttorneyPasscodeResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PaginatedAttorneyPasscodeResponseDtoItem',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $TranscriptChatResponseDto = {
  type: 'object',
  properties: {
    answer: {
      type: 'string',
      description: 'AI response answer',
    },
    sources: {
      description: 'Source chunk indices',
      type: 'array',
      items: {
        type: 'number',
      },
    },
  },
  required: ['answer', 'sources'],
} as const;

export const $PrismaJobTranscriptMessagesHistoryDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    transcriptId: {
      type: 'string',
      nullable: true,
    },
    repositoryId: {
      type: 'string',
      nullable: true,
    },
    content: {
      type: 'string',
    },
    role: {
      type: 'string',
    },
    initiatedByUser: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    userId: {
      type: 'string',
      nullable: true,
    },
    jobTranscriptId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'content', 'role', 'createdAt'],
} as const;

export const $ResubmitJobResultDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'ID of the job',
      example: '123e4567-e89b-12d3-a456-426614174000',
    },
    status: {
      type: 'string',
      description: 'Status of the resubmission attempt',
      enum: ['resubmitted', 'error'],
      example: 'resubmitted',
    },
    error: {
      type: 'string',
      description: 'Error message (if failed)',
      example: 'Failed to resubmit job',
    },
  },
  required: ['jobId', 'status'],
} as const;

export const $ResubmitJobsResponseDto = {
  type: 'object',
  properties: {
    totalFound: {
      type: 'number',
      description: 'Total number of jobs considered for resubmission',
      example: 5,
    },
    results: {
      description: 'Results of the resubmission attempts',
      type: 'array',
      items: {
        $ref: '#/components/schemas/ResubmitJobResultDto',
      },
    },
  },
  required: ['totalFound', 'results'],
} as const;

export const $UpdateClassifiedErrorDescriptionBodyDto = {
  type: 'object',
  properties: {
    description: {
      type: 'string',
      description: 'New description for the classified error',
    },
  },
  required: ['description'],
} as const;

export const $BulkJobIdsBodyDto = {
  type: 'object',
  properties: {
    ids: {
      description: 'Job IDs',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['ids'],
} as const;

export const $CreateBulkJobsResponseDto = {
  type: 'object',
  properties: {
    jobIds: {
      description: 'IDs of created and submitted jobs',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['jobIds'],
} as const;

export const $BulkJobStatusItemResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      description: 'Job status',
    },
  },
  required: ['status'],
} as const;

export const $PrismaTransactionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    amount: {
      type: 'number',
    },
    codeId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    realTimePending: {
      type: 'boolean',
      nullable: true,
    },
    stripeChargeId: {
      type: 'string',
      nullable: true,
    },
    stripeReceiptUrl: {
      type: 'string',
      nullable: true,
    },
    jobId: {
      type: 'string',
      nullable: true,
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    dontUseForBalanceCalculation: {
      type: 'boolean',
      nullable: true,
    },
    balanceId: {
      type: 'string',
    },
  },
  required: ['id', 'amount', 'codeId', 'title', 'description', 'createdAt', 'balanceId'],
} as const;

export const $UpdateJobAbandonedProcessingBodyDto = {
  type: 'object',
  properties: {
    abandonedProcessing: {
      type: 'boolean',
    },
  },
  required: ['abandonedProcessing'],
} as const;

export const $RefundJobBodyDto = {
  type: 'object',
  properties: {
    reason: {
      type: 'string',
    },
    shouldLockJob: {
      type: 'boolean',
    },
    transactionIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['reason', 'shouldLockJob'],
} as const;

export const $AdminRefundJobResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $ConfirmUserForTestsBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'User email to confirm',
    },
  },
  required: ['email'],
} as const;

export const $AdminConfirmUserForTestsResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $GrantAdminRolesBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'User email',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
        enum: ['ROLE_BILLING_ADMIN', 'ROLE_ORG_ADMIN', 'ROLE_VS_ADMIN', 'ROLE_VS_DEV', 'ROLE_SUPER_ADMIN'],
      },
      description: 'Roles to add',
    },
  },
  required: ['email', 'roles'],
} as const;

export const $GrantAdminRolesResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
      description: 'Whether the operation succeeded',
    },
    roles: {
      description: 'Updated roles list',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['success', 'roles'],
} as const;

export const $AgenticMetadataSpeakerDto = {
  type: 'object',
  properties: {
    post_asr_label: {
      type: 'string',
      nullable: true,
    },
    role: {
      type: 'string',
      nullable: true,
    },
    honorific_prefix: {
      type: 'string',
      nullable: true,
    },
    first_name: {
      type: 'string',
      nullable: true,
    },
    last_name: {
      type: 'string',
      nullable: true,
    },
    full_name: {
      type: 'string',
      nullable: true,
    },
    real_time_asr_label: {
      type: 'string',
      nullable: true,
    },
  },
} as const;

export const $AgenticMetadataResponseDto = {
  type: 'object',
  properties: {
    speakers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AgenticMetadataSpeakerDto',
      },
    },
    proceeding_type: {
      type: 'string',
    },
    summary: {
      type: 'string',
    },
  },
  required: ['speakers', 'proceeding_type', 'summary'],
} as const;

export const $ReporterSummaryResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    summaryPdfKey: {
      type: 'string',
    },
    summaryAudioKey: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    utteranceCount: {
      type: 'number',
    },
    lineCount: {
      type: 'number',
    },
    chunksProcessed: {
      type: 'number',
    },
    fallbackChunks: {
      type: 'number',
    },
  },
  required: [
    'jobId',
    'summaryPdfKey',
    'summaryAudioKey',
    'status',
    'utteranceCount',
    'lineCount',
    'chunksProcessed',
    'fallbackChunks',
  ],
} as const;

export const $RemoveForeignLanguageResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'Job ID',
    },
    utterances: {
      type: 'array',
      description: 'Processed transcript utterances',
      items: {
        type: 'object',
      },
    },
  },
  required: ['jobId', 'utterances'],
} as const;

export const $CorrectDiarizationErrorsResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'Job ID',
    },
    queueJobId: {
      type: 'string',
      description: 'Queue job ID',
    },
    message: {
      type: 'string',
      description: 'Status message',
    },
  },
  required: ['jobId', 'queueJobId', 'message'],
} as const;

export const $CheckIsCloningAvailableResponseDto = {
  type: 'object',
  properties: {
    isEnabled: {
      type: 'boolean',
    },
    currentEnvironment: {
      type: 'string',
    },
  },
  required: ['isEnabled', 'currentEnvironment'],
} as const;

export const $CreateFeatureFlagBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    value: {
      type: 'boolean',
    },
  },
  required: ['name', 'value'],
} as const;

export const $PrismaFeatureFlagDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    value: {
      type: 'boolean',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'value', 'createdAt'],
} as const;

export const $UpdateFeatureFlagBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    value: {
      type: 'boolean',
    },
  },
} as const;

export const $CheckStuckAssemblyWebhooksResponseDto = {
  type: 'object',
  properties: {
    checked: {
      type: 'number',
      description: 'Number of stuck (>3h queued) Assembly webhooks inspected',
      example: 3,
    },
    requeued: {
      type: 'number',
      description: 'Number of webhooks re-enqueued to the Assembly transcript queue',
      example: 2,
    },
    failed: {
      type: 'number',
      description: 'Number of webhooks that failed inspection (logged to Slack warnings)',
      example: 1,
    },
  },
  required: ['checked', 'requeued', 'failed'],
} as const;

export const $ModelNormalizerSettingResponseDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    enabled: {
      type: 'boolean',
    },
  },
  required: ['name', 'description', 'enabled'],
} as const;

export const $ModelSettingsResponseDto = {
  type: 'object',
  properties: {
    modelName: {
      type: 'string',
    },
    provider: {
      type: 'string',
    },
    providerModel: {
      type: 'string',
    },
    normalizers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ModelNormalizerSettingResponseDto',
      },
    },
    qualityCheckers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ModelNormalizerSettingResponseDto',
      },
    },
  },
  required: ['modelName', 'provider', 'providerModel', 'normalizers', 'qualityCheckers'],
} as const;

export const $SetModelNormalizersBodyDto = {
  type: 'object',
  properties: {
    enabledNormalizerNames: {
      description:
        'Enabled registered normalizer names. An empty list disables all normalizers. Execution order is defined by the model.',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['enabledNormalizerNames'],
} as const;

export const $SetModelQualityCheckersBodyDto = {
  type: 'object',
  properties: {
    enabledQualityCheckerNames: {
      description:
        'Enabled registered quality checker names. An empty list disables all quality-checkers. Execution order is defined by the model.',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['enabledQualityCheckerNames'],
} as const;

export const $AsrProxyHealthResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'ok',
    },
    adapters: {
      description: 'Registered provider adapters',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['status', 'adapters'],
} as const;

export const $AsrProxyModelHealthDto = {
  type: 'object',
  properties: {
    ok: {
      type: 'boolean',
    },
    detail: {
      type: 'string',
    },
    checkedAt: {
      type: 'string',
      description: 'ISO timestamp of the last probe',
    },
  },
  required: ['ok', 'checkedAt'],
} as const;

export const $AsrProxyModelRowDto = {
  type: 'object',
  properties: {
    model_name: {
      type: 'string',
    },
    provider: {
      type: 'string',
    },
    provider_model: {
      type: 'string',
    },
    has_api_key: {
      type: 'boolean',
    },
    supported_options: {
      nullable: true,
      description:
        'AssemblyAI option names handled by this model; null means the native AssemblyAI contract is passed through',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    info: {
      type: 'object',
      additionalProperties: true,
      description: 'Provider capability flags (diarization, multichannel, …)',
    },
    health: {
      $ref: '#/components/schemas/AsrProxyModelHealthDto',
    },
  },
  required: ['model_name', 'provider', 'provider_model', 'has_api_key', 'supported_options', 'info'],
} as const;

export const $AsrProxyModelsResponseDto = {
  type: 'object',
  properties: {
    default_model: {
      type: 'string',
      description: 'Default model used when a request omits or names an unknown model',
    },
    known_options: {
      description: 'AssemblyAI option names compared in the admin capability table',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    models: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyModelRowDto',
      },
    },
  },
  required: ['known_options', 'models'],
} as const;

export const $AsrProxyProviderOptionMappingDto = {
  type: 'object',
  properties: {
    option: {
      type: 'string',
    },
    status: {
      enum: ['native', 'mapped', 'controlled', 'unavailable'],
      type: 'string',
    },
    target: {
      type: 'string',
      nullable: true,
    },
    detail: {
      type: 'string',
    },
  },
  required: ['option', 'status', 'target', 'detail'],
} as const;

export const $AsrProxyProviderOptionsRowDto = {
  type: 'object',
  properties: {
    provider: {
      type: 'string',
    },
    mappings: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderOptionMappingDto',
      },
    },
  },
  required: ['provider', 'mappings'],
} as const;

export const $AsrProxyProviderOptionsResponseDto = {
  type: 'object',
  properties: {
    known_options: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    options: {
      type: 'object',
      additionalProperties: true,
    },
    providers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderOptionsRowDto',
      },
    },
  },
  required: ['known_options', 'options', 'providers'],
} as const;

export const $AsrProxySetProviderOptionsBodyDto = {
  type: 'object',
  properties: {
    options: {
      type: 'object',
      additionalProperties: true,
      description: 'Global default AssemblyAI-first options',
    },
  },
  required: ['options'],
} as const;

export const $AsrProxySetProviderOptionsResponseDto = {
  type: 'object',
  properties: {
    options: {
      type: 'object',
      additionalProperties: true,
    },
  },
  required: ['options'],
} as const;

export const $AsrProxyProviderLimitDefinitionDto = {
  type: 'object',
  properties: {
    key: {
      type: 'string',
    },
    label: {
      type: 'string',
    },
    unit: {
      enum: ['bytes', 'seconds', 'count', 'formats'],
      type: 'string',
    },
  },
  required: ['key', 'label', 'unit'],
} as const;

export const $AsrProxyProviderLimitDto = {
  type: 'object',
  properties: {
    key: {
      type: 'string',
    },
    value: {
      nullable: true,
      oneOf: [
        {
          type: 'number',
        },
        {
          type: 'array',
          items: {
            type: 'string',
          },
        },
      ],
    },
    status: {
      enum: ['documented', 'conditional', 'deployment_defined', 'not_applicable', 'not_documented'],
      type: 'string',
    },
    detail: {
      type: 'string',
    },
  },
  required: ['key', 'value', 'status', 'detail'],
} as const;

export const $AsrProxyProviderLimitSourceDto = {
  type: 'object',
  properties: {
    label: {
      type: 'string',
    },
    url: {
      type: 'string',
    },
  },
  required: ['label', 'url'],
} as const;

export const $AsrProxyProviderLimitsRowDto = {
  type: 'object',
  properties: {
    provider: {
      type: 'string',
    },
    limits: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderLimitDto',
      },
    },
    sources: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderLimitSourceDto',
      },
    },
  },
  required: ['provider', 'limits', 'sources'],
} as const;

export const $AsrProxyProviderLimitsResponseDto = {
  type: 'object',
  properties: {
    known_limits: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderLimitDefinitionDto',
      },
    },
    providers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyProviderLimitsRowDto',
      },
    },
  },
  required: ['known_limits', 'providers'],
} as const;

export const $AsrProxyHealthCheckResponseDto = {
  type: 'object',
  properties: {
    models: {
      type: 'object',
      additionalProperties: true,
      description: 'Per-model health keyed by public model name',
    },
  },
  required: ['models'],
} as const;

export const $AsrProxyJobAttemptDto = {
  type: 'object',
  properties: {
    model: {
      type: 'string',
    },
    provider: {
      type: 'string',
    },
    ok: {
      type: 'boolean',
    },
    tries: {
      type: 'number',
    },
    error: {
      type: 'string',
    },
  },
  required: ['model', 'provider', 'ok', 'tries'],
} as const;

export const $AsrProxyJobRowDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    provider: {
      type: 'string',
    },
    provider_transcript_id: {
      type: 'string',
    },
    has_transcript: {
      type: 'boolean',
    },
    has_execution: {
      type: 'boolean',
      description: 'Whether an execution record with plan and stage history exists',
    },
    failed_stage: {
      type: 'string',
      description: 'Stage that was running when the job failed',
    },
    metadata: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
    },
    attempts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyJobAttemptDto',
      },
    },
    error: {
      type: 'string',
    },
    created_at: {
      type: 'string',
    },
    updated_at: {
      type: 'string',
    },
  },
  required: ['id', 'status', 'model', 'provider', 'has_transcript', 'has_execution', 'created_at', 'updated_at'],
} as const;

export const $AsrProxyJobsResponseDto = {
  type: 'object',
  properties: {
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyJobRowDto',
      },
    },
  },
  required: ['jobs'],
} as const;

export const $AsrProxyReloadResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'reloaded',
    },
    default_model: {
      type: 'string',
    },
  },
  required: ['status'],
} as const;

export const $AsrProxySettingsResponseDto = {
  type: 'object',
  properties: {
    default_model: {
      type: 'string',
    },
    retry_count: {
      type: 'number',
      example: 2,
    },
    retry_delay_ms: {
      type: 'number',
      example: 1000,
    },
    fallback_models: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['retry_count', 'retry_delay_ms', 'fallback_models'],
} as const;

export const $AsrProxySetDefaultModelBodyDto = {
  type: 'object',
  properties: {
    model: {
      type: 'string',
      description: 'Public model name used when a request omits or names an unknown model',
    },
  },
  required: ['model'],
} as const;

export const $AsrProxyDefaultModelResponseDto = {
  type: 'object',
  properties: {
    default_model: {
      type: 'string',
    },
  },
} as const;

export const $AsrProxySetRetriesBodyDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
      description: 'How many times a failing provider call is retried',
      example: 2,
      maximum: 10,
    },
    delayMs: {
      type: 'number',
      description: 'Delay between retries in milliseconds',
      example: 1000,
      maximum: 60000,
    },
  },
  required: ['count', 'delayMs'],
} as const;

export const $AsrProxyRetriesResponseDto = {
  type: 'object',
  properties: {
    retry_count: {
      type: 'number',
      example: 2,
    },
    retry_delay_ms: {
      type: 'number',
      example: 1000,
    },
  },
  required: ['retry_count', 'retry_delay_ms'],
} as const;

export const $AsrProxySetFallbacksBodyDto = {
  type: 'object',
  properties: {
    models: {
      description: 'Fallback models tried (each with its own retries) when the primary model keeps failing',
      maxItems: 10,
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['models'],
} as const;

export const $AsrProxyFallbacksResponseDto = {
  type: 'object',
  properties: {
    fallback_models: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['fallback_models'],
} as const;

export const $AsrProxyCreateTranscriptionBodyDto = {
  type: 'object',
  properties: {
    audio_url: {
      type: 'string',
      description: 'Publicly reachable URL of the audio to transcribe',
    },
    model: {
      type: 'string',
      description: 'The fixed AssemblyAI Universal-2 proxy model',
    },
    options: {
      type: 'object',
      additionalProperties: true,
      description: 'AssemblyAI-native transcription options',
    },
    webhook_url: {
      type: 'string',
      description: 'Webhook URL for the async path; omit for a synchronous request',
    },
    metadata: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
      description: 'Arbitrary string metadata persisted with the job',
    },
    normalizers: {
      description: 'Registered normalizer names to run for this request; omit to use the persisted model settings',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    quality_checkers: {
      description: 'Registered quality checker names to run for this request; omit to use the persisted model settings',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    async: {
      type: 'boolean',
      description: 'Return the queued job immediately and poll for the result',
    },
  },
  required: ['audio_url'],
} as const;

export const $AsrProxyUtteranceDto = {
  type: 'object',
  properties: {
    speaker: {
      type: 'string',
    },
    text: {
      type: 'string',
    },
    start: {
      type: 'number',
      description: 'Start timestamp in milliseconds',
    },
    end: {
      type: 'number',
      description: 'End timestamp in milliseconds',
    },
    confidence: {
      type: 'number',
    },
    words: {
      description: 'Word-level tokens',
      type: 'array',
      items: {
        type: 'object',
      },
    },
  },
  required: ['speaker', 'text', 'start', 'words'],
} as const;

export const $AsrProxyQualityCheckDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    score: {
      type: 'number',
      description: 'Score from 0 to 100',
    },
    issues: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['name', 'score', 'issues'],
} as const;

export const $AsrProxyTranscriptProvenanceDto = {
  type: 'object',
  properties: {
    provider: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    providerModel: {
      type: 'string',
    },
    providerTranscriptId: {
      type: 'string',
      description: 'Native provider transcript ID; not the ASR proxy request ID',
    },
    retryPolicy: {
      type: 'object',
      description: 'Retry policy applied for this transcript',
    },
    attempts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyJobAttemptDto',
      },
    },
    fallbackReason: {
      type: 'string',
    },
    normalizers: {
      description: 'Normalizer names applied in execution order',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['provider', 'model'],
} as const;

export const $AsrProxyTranscriptDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    text: {
      type: 'string',
    },
    language_code: {
      type: 'string',
    },
    audio_duration: {
      type: 'number',
      description: 'Audio duration in seconds',
    },
    confidence: {
      type: 'number',
    },
    multichannel: {
      type: 'boolean',
    },
    speech_model: {
      type: 'string',
    },
    utterances: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyUtteranceDto',
      },
    },
    error: {
      type: 'string',
    },
    quality_checks: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyQualityCheckDto',
      },
    },
    provenance: {
      $ref: '#/components/schemas/AsrProxyTranscriptProvenanceDto',
    },
  },
  required: ['id', 'status', 'utterances', 'provenance'],
} as const;

export const $AsrProxyExecutionPlanDto = {
  type: 'object',
  properties: {
    provider: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    providerModel: {
      type: 'string',
    },
    modelSelectionSource: {
      enum: ['proxy-default', 'organization-setting', 'resubmit-override', 'explicit-request'],
      type: 'string',
      description: 'Why this model was selected',
    },
    synchronous: {
      type: 'boolean',
      description: 'Whether the result is returned in the create response',
    },
    options: {
      type: 'object',
      additionalProperties: true,
      description: 'Usable provider options after defaults and overrides',
    },
    ignoredOptions: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    normalizers: {
      description: 'Normalizer names configured to run, in execution order',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    qualityCheckers: {
      description: 'Quality checker names configured to run',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    retryPolicy: {
      type: 'object',
      description: 'Transient-error retry policy',
    },
    fallbackModels: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: [
    'provider',
    'model',
    'providerModel',
    'synchronous',
    'options',
    'ignoredOptions',
    'normalizers',
    'qualityCheckers',
    'retryPolicy',
    'fallbackModels',
  ],
} as const;

export const $AsrProxyExecutionStageDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      description: 'Stage name from the ASR proxy stage history',
    },
    at: {
      type: 'string',
      description: 'ISO timestamp when the stage was recorded',
    },
    detail: {
      type: 'string',
    },
  },
  required: ['name', 'at'],
} as const;

export const $AsrProxyExecutionAttemptDto = {
  type: 'object',
  properties: {
    number: {
      type: 'number',
    },
    provider: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    providerModel: {
      type: 'string',
    },
    providerTranscriptId: {
      type: 'string',
    },
    status: {
      enum: ['running', 'completed', 'error'],
      type: 'string',
    },
    error: {
      type: 'string',
    },
    transientErrors: {
      type: 'number',
      description: 'Transient provider errors recovered by the retry policy',
    },
    startedAt: {
      type: 'string',
    },
    finishedAt: {
      type: 'string',
    },
  },
  required: ['number', 'provider', 'model', 'providerModel', 'status', 'transientErrors', 'startedAt'],
} as const;

export const $AsrProxyTranscriptPreviewDto = {
  type: 'object',
  properties: {
    utteranceCount: {
      type: 'number',
    },
    characterCount: {
      type: 'number',
    },
    utterances: {
      description: 'Leading utterances as speaker and text',
      type: 'array',
      items: {
        type: 'object',
      },
    },
  },
  required: ['utteranceCount', 'characterCount', 'utterances'],
} as const;

export const $AsrProxyUtteranceChangeDto = {
  type: 'object',
  properties: {
    index: {
      type: 'number',
    },
    speaker: {
      type: 'string',
    },
    before: {
      type: 'string',
    },
    after: {
      type: 'string',
    },
  },
  required: ['index', 'speaker', 'before', 'after'],
} as const;

export const $AsrProxyNormalizerChangeDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    utteranceCountBefore: {
      type: 'number',
    },
    utteranceCountAfter: {
      type: 'number',
    },
    changedUtteranceCount: {
      type: 'number',
    },
    changedUtterances: {
      description: 'Changed utterances, capped by the proxy',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyUtteranceChangeDto',
      },
    },
    truncated: {
      type: 'boolean',
      description: 'True when more utterances changed than are listed',
    },
  },
  required: [
    'name',
    'utteranceCountBefore',
    'utteranceCountAfter',
    'changedUtteranceCount',
    'changedUtterances',
    'truncated',
  ],
} as const;

export const $AsrProxyExecutionDto = {
  type: 'object',
  properties: {
    plan: {
      $ref: '#/components/schemas/AsrProxyExecutionPlanDto',
    },
    stages: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyExecutionStageDto',
      },
    },
    attempts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyExecutionAttemptDto',
      },
    },
    fallbacksApplied: {
      type: 'number',
    },
    normalizersApplied: {
      description: 'Normalizer names that actually ran',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    mappedTranscriptPreview: {
      description: 'AssemblyAI-first transcript before normalization',
      allOf: [
        {
          $ref: '#/components/schemas/AsrProxyTranscriptPreviewDto',
        },
      ],
    },
    normalizerChanges: {
      description: 'What each normalizer changed, in order',
      type: 'array',
      items: {
        $ref: '#/components/schemas/AsrProxyNormalizerChangeDto',
      },
    },
  },
  required: ['plan', 'stages', 'attempts', 'fallbacksApplied'],
} as const;

export const $AsrProxyCreateTranscriptionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Proxy job id the caller persists',
    },
    status: {
      type: 'string',
    },
    provider: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    transcript: {
      description: 'Present on the synchronous path',
      allOf: [
        {
          $ref: '#/components/schemas/AsrProxyTranscriptDto',
        },
      ],
    },
    execution: {
      description: 'Execution plan and recorded stage history',
      allOf: [
        {
          $ref: '#/components/schemas/AsrProxyExecutionDto',
        },
      ],
    },
  },
  required: ['id', 'status', 'provider', 'model'],
} as const;

export const $AsrProxyRetrieveTranscriptionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    transcript: {
      $ref: '#/components/schemas/AsrProxyTranscriptDto',
    },
    error: {
      type: 'string',
    },
    execution: {
      description: 'Execution plan and recorded stage history',
      allOf: [
        {
          $ref: '#/components/schemas/AsrProxyExecutionDto',
        },
      ],
    },
  },
  required: ['id', 'status'],
} as const;

export const $AsrProxyOrganizationConfigResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'organizationId', 'model', 'createdAt', 'updatedAt'],
} as const;

export const $AsrProxySetOrganizationModelBodyDto = {
  type: 'object',
  properties: {
    model: {
      type: 'string',
      description: 'Registered ASR proxy model name',
    },
  },
  required: ['model'],
} as const;

export const $GetManyForUserResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    templateName: {
      type: 'string',
    },
    creatorName: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    organizationName: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'templateName', 'creatorName', 'organizationId', 'organizationName', 'createdAt'],
} as const;

export const $GetDownloadUrlsForLayoutResponseDto = {
  type: 'object',
  properties: {
    jsonDownloadLink: {
      type: 'string',
    },
    docxDownloadLink: {
      type: 'string',
    },
  },
  required: ['jsonDownloadLink', 'docxDownloadLink'],
} as const;

export const $CreateLayoutBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    templateName: {
      type: 'string',
    },
  },
  required: ['name', 'templateName'],
} as const;

export const $CreateLayoutResponseDto = {
  type: 'object',
  properties: {
    jsonUploadUrl: {
      type: 'string',
    },
    docxUploadUrl: {
      type: 'string',
    },
  },
  required: ['jsonUploadUrl', 'docxUploadUrl'],
} as const;

export const $ReplaceLayoutBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    templateName: {
      type: 'string',
    },
  },
  required: ['name', 'templateName'],
} as const;

export const $ReplaceLayoutResponseDto = {
  type: 'object',
  properties: {
    docxUploadUrl: {
      type: 'string',
    },
    jsonUploadUrl: {
      type: 'string',
    },
  },
  required: ['docxUploadUrl', 'jsonUploadUrl'],
} as const;

export const $DeleteLayoutResponseDto = {
  type: 'object',
  properties: {
    deleted: {
      type: 'boolean',
    },
  },
  required: ['deleted'],
} as const;

export const $SeedAsoneLoadJobBodyDto = {
  type: 'object',
  properties: {
    fixtureId: {
      enum: [
        'asone-mono-15min',
        'asone-multi-90min',
        'asone-multi-180min',
        'asone-multi-360min',
        'asone-mono-noRealtime-90min',
      ],
      type: 'string',
      description: 'Fixture ID identifying the audio + session-text + duration the seeded job should use.',
    },
    userEmail: {
      type: 'string',
      description:
        'Email of the e2e load-test user to attribute jobs to. Falls back to env LOAD_TEST_USER_EMAIL, then "e2e@voicescript.ai".',
    },
    organizationName: {
      type: 'string',
      description:
        'Name of the e2e load-test organization to attribute jobs to. Falls back to env LOAD_TEST_ORG_NAME, then "e2e-testing".',
    },
  },
  required: ['fixtureId'],
} as const;

export const $SeedAsoneLoadJobResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'ID of the newly created Job.',
    },
    recordingSessionId: {
      type: 'string',
      description: 'ID of the newly created RecordingSession backing the Job.',
    },
    fixtureId: {
      type: 'string',
      description: 'Fixture ID this job was seeded from.',
    },
  },
  required: ['jobId', 'recordingSessionId', 'fixtureId'],
} as const;

export const $GetLoadJobStatusesBodyDto = {
  type: 'object',
  properties: {
    jobIds: {
      description: 'Job IDs to look up.',
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['jobIds'],
} as const;

export const $LoadJobStatusItemResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
      description: 'Job ID.',
    },
    status: {
      type: 'string',
      description: 'Job.status (EJobStatuses).',
    },
    pipelineStatus: {
      type: 'string',
      nullable: true,
      description: 'Job.pipelineStatus (XState snapshot value).',
    },
    currentAttemptId: {
      type: 'string',
      nullable: true,
      description: 'PipelineAttempt.id of the currently in-flight attempt, if any.',
    },
    failureCount: {
      type: 'number',
      nullable: true,
      description: 'Failure count on the Job row.',
    },
    statusChangeDate: {
      format: 'date-time',
      type: 'string',
      description: 'Job.statusChangeDate timestamp.',
    },
  },
  required: ['jobId', 'status', 'statusChangeDate'],
} as const;

export const $LoadJobStatusListResponseDto = {
  type: 'object',
  properties: {
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/LoadJobStatusItemResponseDto',
      },
    },
  },
  required: ['items'],
} as const;

export const $DashboardMembersDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    active7days: {
      type: 'number',
    },
  },
  required: ['count', 'active7days'],
} as const;

export const $DashboardEfficiencyDto = {
  type: 'object',
  properties: {
    totalHoursPerJob: {
      type: 'number',
    },
    last7days: {
      type: 'number',
    },
    prevMonthDifference: {
      type: 'number',
    },
  },
  required: ['totalHoursPerJob', 'last7days', 'prevMonthDifference'],
} as const;

export const $DashboardWorkspaceActivityDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    tierRate: {
      type: 'number',
    },
    billingCard: {
      type: 'string',
    },
  },
  required: ['count', 'tierRate', 'billingCard'],
} as const;

export const $DashboardJobAssigneeDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'lastname'],
} as const;

export const $DashboardJobWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $DashboardJobDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    deadline: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/DashboardJobAssigneeDto',
        },
      ],
    },
    workspace: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/DashboardJobWorkspaceDto',
        },
      ],
    },
  },
  required: ['id', 'name'],
} as const;

export const $DashboardDeadlineCalendarDayDto = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
    },
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardJobDto',
      },
    },
  },
  required: ['date', 'jobs'],
} as const;

export const $DashboardActivityPointDto = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
    },
    value: {
      type: 'number',
    },
  },
  required: ['date', 'value'],
} as const;

export const $DashboardDailyActivityDto = {
  type: 'object',
  properties: {
    week: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardActivityPointDto',
      },
    },
    month: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardActivityPointDto',
      },
    },
  },
  required: ['week', 'month'],
} as const;

export const $DashboardLeaderboardEntryDto = {
  type: 'object',
  properties: {
    label: {
      type: 'string',
    },
    value: {
      type: 'number',
    },
  },
  required: ['label', 'value'],
} as const;

export const $DashboardLeaderboardDto = {
  type: 'object',
  properties: {
    week: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardLeaderboardEntryDto',
      },
    },
    month: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardLeaderboardEntryDto',
      },
    },
  },
  required: ['week', 'month'],
} as const;

export const $DashboardPerformanceReviewDto = {
  type: 'object',
  properties: {
    totalJobs: {
      type: 'number',
    },
    week: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          date: {
            type: 'string',
          },
          value: {
            type: 'number',
          },
        },
      },
    },
    month: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          date: {
            type: 'string',
          },
          value: {
            type: 'number',
          },
        },
      },
    },
  },
  required: ['totalJobs', 'week', 'month'],
} as const;

export const $OrganizationDashboardInfoResponseDto = {
  type: 'object',
  properties: {
    members: {
      $ref: '#/components/schemas/DashboardMembersDto',
    },
    efficiency: {
      $ref: '#/components/schemas/DashboardEfficiencyDto',
    },
    workspaceActivity: {
      description: 'Workspace activity summary',
      allOf: [
        {
          $ref: '#/components/schemas/DashboardWorkspaceActivityDto',
        },
      ],
    },
    deadlineCalendar: {
      description: 'Deadline calendar entries',
      type: 'array',
      items: {
        $ref: '#/components/schemas/DashboardDeadlineCalendarDayDto',
      },
    },
    dailyActivity: {
      description: 'Daily activity stats',
      allOf: [
        {
          $ref: '#/components/schemas/DashboardDailyActivityDto',
        },
      ],
    },
    leaderboard: {
      description: 'Leaderboard data',
      allOf: [
        {
          $ref: '#/components/schemas/DashboardLeaderboardDto',
        },
      ],
    },
    performanceReview: {
      $ref: '#/components/schemas/DashboardPerformanceReviewDto',
    },
  },
  required: [
    'members',
    'efficiency',
    'workspaceActivity',
    'deadlineCalendar',
    'dailyActivity',
    'leaderboard',
    'performanceReview',
  ],
} as const;

export const $ScriberDashboardJobAssigneeDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'lastname'],
} as const;

export const $ScriberDashboardJobWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $ScriberDashboardJobDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    deadline: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    assignee: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/ScriberDashboardJobAssigneeDto',
        },
      ],
    },
    workspace: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/ScriberDashboardJobWorkspaceDto',
        },
      ],
    },
  },
  required: ['id', 'name'],
} as const;

export const $ScriberDashboardDeadlineCalendarDayDto = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
    },
    jobs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ScriberDashboardJobDto',
      },
    },
  },
  required: ['date', 'jobs'],
} as const;

export const $ScriberDashboardInfoResponseDto = {
  type: 'object',
  properties: {
    completedJobs: {
      type: 'number',
      description: 'Count of completed jobs',
    },
    concurrentJobsLimit: {
      type: 'number',
      description: 'Concurrent jobs limit for the user',
    },
    jobsToClaim: {
      description: 'Jobs available to claim',
      type: 'array',
      items: {
        $ref: '#/components/schemas/ScriberDashboardJobDto',
      },
    },
    myJobs: {
      description: 'Current user jobs',
      type: 'array',
      items: {
        $ref: '#/components/schemas/ScriberDashboardJobDto',
      },
    },
    deadlineCalendar: {
      description: 'Deadline calendar entries',
      type: 'array',
      items: {
        $ref: '#/components/schemas/ScriberDashboardDeadlineCalendarDayDto',
      },
    },
  },
  required: ['completedJobs', 'concurrentJobsLimit', 'jobsToClaim', 'myJobs', 'deadlineCalendar'],
} as const;

export const $SendSalesEmailBodyDto = {
  type: 'object',
  properties: {
    agency: {
      type: 'string',
    },
    fullname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    state: {
      type: 'string',
    },
    reporters: {
      type: 'string',
    },
    transcriptionists: {
      type: 'string',
    },
    additional: {
      type: 'string',
    },
  },
  required: ['agency', 'fullname', 'email', 'phone', 'state', 'reporters', 'transcriptionists', 'additional'],
} as const;

export const $SendSalesEmailResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $SendSalesEmailFromLandingToolsDto = {
  type: 'object',
  properties: {
    asd: {
      type: 'boolean',
    },
    asone: {
      type: 'boolean',
    },
    attorneyView: {
      type: 'boolean',
    },
    cat: {
      type: 'boolean',
    },
    eclipse: {
      type: 'boolean',
    },
    maxscribe: {
      type: 'boolean',
    },
    word: {
      type: 'boolean',
    },
    other: {
      type: 'boolean',
    },
    otherName: {
      type: 'string',
    },
  },
  required: ['asd', 'asone', 'attorneyView', 'cat', 'eclipse', 'maxscribe', 'word', 'other', 'otherName'],
} as const;

export const $SendSalesEmailFromLandingInterestedDto = {
  type: 'object',
  properties: {
    asWeb: {
      type: 'boolean',
    },
    asone: {
      type: 'boolean',
    },
    attorney: {
      type: 'boolean',
    },
    notSure: {
      type: 'boolean',
    },
  },
  required: ['asWeb', 'asone', 'attorney', 'notSure'],
} as const;

export const $SendSalesEmailFromLandingBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    surname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    typeOfWork: {
      type: 'string',
    },
    companyName: {
      type: 'string',
    },
    role: {
      type: 'string',
    },
    tools: {
      $ref: '#/components/schemas/SendSalesEmailFromLandingToolsDto',
    },
    interested: {
      $ref: '#/components/schemas/SendSalesEmailFromLandingInterestedDto',
    },
    autoScriptAccount: {
      type: 'boolean',
    },
    outsourceTo: {
      type: 'string',
    },
    outsource: {
      type: 'string',
    },
    notes: {
      type: 'string',
    },
    notSureNotes: {
      type: 'string',
    },
  },
  required: [
    'name',
    'surname',
    'email',
    'phone',
    'typeOfWork',
    'companyName',
    'role',
    'tools',
    'interested',
    'autoScriptAccount',
    'outsourceTo',
    'outsource',
    'notes',
    'notSureNotes',
  ],
} as const;

export const $CheckRsProLicenseBodyDto = {
  type: 'object',
  properties: {
    enabled: {
      type: 'boolean',
    },
  },
  required: ['enabled'],
} as const;

export const $BeginCrashReportBodyDto = {
  type: 'object',
  properties: {
    appVersion: {
      type: 'string',
      example: '1.2.3.4',
    },
    machine: {
      type: 'string',
      example: 'REPORTER-PC',
    },
    os: {
      type: 'string',
      example: 'Microsoft Windows NT 10.0.26200.0',
    },
    origin: {
      type: 'string',
      example: 'hang',
      enum: ['hang', 'crash'],
      description: 'hang or crash',
    },
    stalledMs: {
      type: 'number',
      example: 31000,
    },
    dumpBytes: {
      type: 'number',
      example: 4194304,
    },
    exception: {
      type: 'string',
    },
    details: {
      type: 'string',
      example: 'It froze right after I pasted a long transcript.',
    },
  },
} as const;

export const $CrashReportTicket = {
  type: 'object',
  properties: {
    reportId: {
      type: 'string',
    },
    dumpUploadUrl: {
      type: 'string',
    },
    reportUploadUrl: {
      type: 'string',
    },
  },
  required: ['reportId', 'dumpUploadUrl', 'reportUploadUrl'],
} as const;

export const $CrashReportCompletion = {
  type: 'object',
  properties: {
    reportId: {
      type: 'string',
    },
    jiraIssueKey: {
      type: 'string',
      description: 'Absent when Jira was unreachable.',
    },
    jiraIssueUrl: {
      type: 'string',
    },
  },
  required: ['reportId'],
} as const;

export const $DesktopJobInfoDTO = {
  type: 'object',
  properties: {
    jobName: {
      type: 'string',
    },
    versions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
          },
          createdAt: {
            format: 'date-time',
            type: 'string',
          },
        },
        required: ['id', 'createdAt'],
      },
    },
    shouldUnlockTrackChanges: {
      type: 'boolean',
    },
  },
  required: ['jobName', 'versions', 'shouldUnlockTrackChanges'],
} as const;

export const $DesktopDownloadJobInfoDTO = {
  type: 'object',
  properties: {
    audio: {
      type: 'string',
    },
    transcript: {
      type: 'string',
    },
    jobJson: {
      type: 'string',
      nullable: true,
    },
    jobDoc: {
      type: 'string',
      nullable: true,
    },
    shouldUnlockTrackChanges: {
      type: 'boolean',
    },
  },
  required: ['audio', 'transcript', 'jobJson', 'jobDoc', 'shouldUnlockTrackChanges'],
} as const;

export const $DesktopUploadJobInfoDTO = {
  type: 'object',
  properties: {
    jobJson: {
      type: 'string',
    },
    jobDoc: {
      type: 'string',
    },
  },
  required: ['jobJson', 'jobDoc'],
} as const;

export const $GetInvitationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    organizationName: {
      type: 'string',
    },
    status: {
      enum: ['CREATED', 'ACCEPTED', 'DECLINED'],
      type: 'string',
    },
  },
  required: ['id', 'userId', 'organizationName', 'status'],
} as const;

export const $AcceptInvitationResponseDto = {
  type: 'object',
  properties: {
    success: {
      type: 'boolean',
    },
    error: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    code: {
      type: 'number',
    },
  },
  required: ['success'],
} as const;

export const $GetJobSubscriptionsListNestedJobResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    meetingId: {
      type: 'string',
    },
    asOneLocked: {
      type: 'boolean',
    },
  },
  required: ['id', 'name', 'workspaceId', 'asOneLocked'],
} as const;

export const $GetJobSubscriptionsListResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    job: {
      $ref: '#/components/schemas/GetJobSubscriptionsListNestedJobResponseDto',
    },
  },
  required: ['id', 'jobId', 'createdAt', 'job'],
} as const;

export const $UpsertJobSubscriptionBodyDto = {
  type: 'object',
  properties: {
    status: {
      type: 'boolean',
    },
    assignee: {
      type: 'boolean',
    },
    comments: {
      type: 'boolean',
    },
  },
  required: ['status', 'assignee', 'comments'],
} as const;

export const $PrismaJobNotificationsSubscriptionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    userId: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    status: {
      type: 'boolean',
    },
    assignee: {
      type: 'boolean',
    },
    comments: {
      type: 'boolean',
    },
  },
  required: ['id', 'createdAt', 'userId', 'jobId', 'status', 'assignee', 'comments'],
} as const;

export const $GetWorkspaceSubscriptionsListNestedOrganizationDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $GetWorkspaceSubscriptionsListNestedWorkspaceDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    organization: {
      $ref: '#/components/schemas/GetWorkspaceSubscriptionsListNestedOrganizationDto',
    },
  },
  required: ['id', 'name', 'slug', 'organizationId', 'organization'],
} as const;

export const $GetWorkspaceSubscriptionsListResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    workspace: {
      $ref: '#/components/schemas/GetWorkspaceSubscriptionsListNestedWorkspaceDto',
    },
  },
  required: ['id', 'workspaceId', 'createdAt', 'workspace'],
} as const;

export const $CreateTeamBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    memberIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    colour: {
      type: 'string',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    viewJobs: {
      enum: ['none', 'all', 'assigned', 'assignedAndUnassigned'],
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
  },
  required: ['name', 'slug', 'organizationId'],
} as const;

export const $FindOneTeamOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'slug'],
} as const;

export const $FindOneTeamUserResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'lastname', 'email', 'phone', 'createdAt'],
} as const;

export const $FindOneTeamMemberResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    User: {
      $ref: '#/components/schemas/FindOneTeamUserResponseDto',
    },
  },
  required: ['id', 'User'],
} as const;

export const $FindOneTeamResponseDto = {
  type: 'object',
  properties: {
    Organization: {
      $ref: '#/components/schemas/FindOneTeamOrganizationResponseDto',
    },
    Members: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/FindOneTeamMemberResponseDto',
      },
    },
    id: {
      type: 'string',
    },
    default: {
      type: 'boolean',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    colour: {
      type: 'string',
    },
    owner: {
      type: 'boolean',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewJobs: {
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    organizationId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'Organization',
    'Members',
    'id',
    'default',
    'name',
    'slug',
    'colour',
    'owner',
    'viewRepositories',
    'editRepositories',
    'viewBilling',
    'manageBilling',
    'viewJobs',
    'editJobs',
    'reassignJobs',
    'deleteJobs',
    'submitJobs',
    'viewJobCost',
    'editJobTranscript',
    'proofreadJobTranscript',
    'finalizeJobTranscript',
    'markJobComplete',
    'viewReports',
    'manageMembers',
    'managePermissions',
    'manageWorkspaces',
    'manageOrganization',
    'viewLicenses',
    'manageLicenses',
    'organizationId',
    'createdAt',
  ],
} as const;

export const $FindAvailableMembersItemUserDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'lastname', 'email', 'phone', 'createdAt'],
} as const;

export const $FindAvailableMembersItemResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    concurrentJobsLimit: {
      type: 'number',
      nullable: true,
    },
    canManageLayouts: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    User: {
      $ref: '#/components/schemas/FindAvailableMembersItemUserDto',
    },
  },
  required: ['id', 'disabled', 'canManageLayouts', 'organizationId', 'userId', 'createdAt', 'User'],
} as const;

export const $IsSlugAvailableResponse = {
  type: 'object',
  properties: {
    available: {
      type: 'boolean',
    },
  },
  required: ['available'],
} as const;

export const $UpdateTeamBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    memberIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    colour: {
      type: 'string',
    },
    viewRepositories: {
      type: 'boolean',
    },
    editRepositories: {
      type: 'boolean',
    },
    viewBilling: {
      type: 'boolean',
    },
    manageBilling: {
      type: 'boolean',
    },
    viewLicenses: {
      type: 'boolean',
    },
    manageLicenses: {
      type: 'boolean',
    },
    viewJobs: {
      enum: ['none', 'all', 'assigned', 'assignedAndUnassigned'],
      type: 'string',
    },
    editJobs: {
      type: 'boolean',
    },
    reassignJobs: {
      type: 'boolean',
    },
    deleteJobs: {
      type: 'boolean',
    },
    submitJobs: {
      type: 'boolean',
    },
    viewJobCost: {
      type: 'boolean',
    },
    editJobTranscript: {
      type: 'boolean',
    },
    proofreadJobTranscript: {
      type: 'boolean',
    },
    finalizeJobTranscript: {
      type: 'boolean',
    },
    markJobComplete: {
      type: 'boolean',
    },
    viewReports: {
      type: 'boolean',
    },
    manageMembers: {
      type: 'boolean',
    },
    managePermissions: {
      type: 'boolean',
    },
    manageWorkspaces: {
      type: 'boolean',
    },
    manageOrganization: {
      type: 'boolean',
    },
  },
} as const;

export const $AddMembersBodyDto = {
  type: 'object',
  properties: {
    memberIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['memberIds'],
} as const;

export const $PrismaOrganizationMembershipDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    concurrentJobsLimit: {
      type: 'number',
      nullable: true,
    },
    canManageLayouts: {
      type: 'boolean',
      nullable: true,
    },
    organizationId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'disabled', 'canManageLayouts', 'organizationId', 'userId', 'createdAt'],
} as const;

export const $MeetingAssigneeDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    lastname: {
      type: 'string',
    },
    avatar: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'email', 'name', 'lastname'],
} as const;

export const $CheckoutEventDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    finalizedAt: {
      format: 'date-time',
      type: 'string',
      nullable: true,
    },
    user: {
      type: 'object',
      properties: {
        id: {
          type: 'string',
        },
        email: {
          type: 'string',
        },
        name: {
          type: 'string',
        },
        lastname: {
          type: 'string',
        },
        avatar: {
          type: 'string',
          nullable: true,
        },
      },
      required: ['id', 'email', 'name', 'lastname'],
    },
    jobStatus: {
      type: 'string',
    },
    initialVersionId: {
      type: 'string',
    },
    finalVersionId: {
      type: 'string',
    },
    predecessor: {
      type: 'object',
      properties: {
        id: {
          type: 'string',
        },
        createdAt: {
          format: 'date-time',
          type: 'string',
        },
        finalizedAt: {
          format: 'date-time',
          type: 'string',
          nullable: true,
        },
        user: {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            email: {
              type: 'string',
            },
            name: {
              type: 'string',
            },
            lastname: {
              type: 'string',
            },
            avatar: {
              type: 'string',
              nullable: true,
            },
          },
          selfRequired: true,
        },
        jobStatus: {
          type: 'string',
        },
        initialVersionId: {
          type: 'string',
        },
        finalVersionId: {
          type: 'string',
        },
      },
      required: ['id', 'createdAt', 'finalizedAt', 'user', 'jobStatus', 'initialVersionId', 'finalVersionId'],
    },
  },
  required: ['id', 'createdAt', 'finalizedAt', 'user', 'jobStatus', 'initialVersionId', 'finalVersionId'],
} as const;

export const $PrivateCreateJobBodyDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    updatedAt: {
      format: 'date-time',
      nullable: true,
      oneOf: [
        {
          type: 'Date',
        },
        {
          type: 'string',
        },
      ],
    },
    statusChangeDate: {
      format: 'date-time',
      nullable: true,
      oneOf: [
        {
          type: 'Date',
        },
        {
          type: 'string',
        },
      ],
    },
    deadline: {
      format: 'date-time',
      nullable: true,
      oneOf: [
        {
          type: 'Date',
        },
        {
          type: 'string',
        },
      ],
    },
    notes: {
      type: 'string',
    },
    duration: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    multipleFilesHandling: {
      type: 'string',
      nullable: true,
    },
    reportingType: {
      type: 'string',
    },
    status: {
      enum: [
        'JOB_STATUS_DRAFT',
        'JOB_STATUS_SCHEDULED',
        'JOB_STATUS_PROCESSING',
        'JOB_STATUS_LOCKED',
        'JOB_STATUS_READY_FOR_TRANSCRIBING',
        'JOB_STATUS_TRANSCRIBING',
        'JOB_STATUS_READY_FOR_PROOFREADING',
        'JOB_STATUS_PROOFING',
        'JOB_STATUS_READY_FOR_FINAL',
        'JOB_STATUS_FINALIZING',
        'JOB_STATUS_COMPLETE',
        'JOB_STATUS_SUCCESS',
        'JOB_STATUS_ERROR',
      ],
      type: 'string',
    },
    removed: {
      type: 'boolean',
    },
    submitted: {
      type: 'boolean',
    },
    results: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    attachments: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    filesCount: {
      type: 'number',
    },
    bucket: {
      type: 'string',
    },
    region: {
      type: 'string',
    },
    repositoryId: {
      type: 'string',
    },
    repository: {
      $ref: '#/components/schemas/JobDtoRepository',
    },
    editingProgress: {
      type: 'number',
    },
    assigneeId: {
      type: 'string',
      nullable: true,
    },
    assignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    draftAssigneeId: {
      type: 'string',
      nullable: true,
    },
    assigneeComment: {
      type: 'string',
      nullable: true,
    },
    draftAssignee: {
      $ref: '#/components/schemas/JobDtoUser',
    },
    assigneeHistory: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoAssigneeHistory',
      },
    },
    comments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/JobDtoComment',
      },
    },
    workspaceId: {
      type: 'string',
    },
    workspaceSlug: {
      type: 'string',
    },
    workspaceName: {
      type: 'string',
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    meetingId: {
      type: 'string',
    },
    meetingType: {
      type: 'string',
    },
    meetingDate: {
      type: 'string',
      nullable: true,
    },
    scheduledDate: {
      type: 'string',
      nullable: true,
    },
    meetingTime: {
      type: 'string',
      nullable: true,
    },
    meetingTimezone: {
      type: 'string',
      nullable: true,
    },
    meetingAddress: {
      type: 'string',
      nullable: true,
    },
    meetingLink: {
      type: 'string',
      nullable: true,
    },
    meetingStatus: {
      type: 'string',
    },
    meetingAssigneeId: {
      type: 'string',
    },
    meetingAssignee: {
      $ref: '#/components/schemas/MeetingAssigneeDto',
    },
    multichannel: {
      type: 'boolean',
    },
    userRequestedForeignLanguageRemoval: {
      type: 'boolean',
      description: 'Whether the user requested foreign-language removal',
    },
    checkoutEvents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CheckoutEventDto',
      },
    },
    asOneLocked: {
      type: 'boolean',
    },
    layoutId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['notes', 'attachments'],
} as const;

export const $AttachFileToJobBodyDto = {
  type: 'object',
  properties: {
    fileName: {
      type: 'string',
    },
    fileSize: {
      type: 'string',
    },
    weight: {
      type: 'number',
    },
  },
  required: ['fileName', 'fileSize', 'weight'],
} as const;

export const $LicenseDefaultsBodyDto = {
  type: 'object',
  properties: {
    transcriptUnlockType: {
      enum: ['ASONE_ENHANCED', 'SESSION_TEXT', 'CHOOSE'],
      type: 'string',
    },
    asOneBackupRecordingAllowed: {
      type: 'boolean',
    },
  },
  required: ['transcriptUnlockType', 'asOneBackupRecordingAllowed'],
} as const;

export const $BootstrapOrganizationBodyDto = {
  type: 'object',
  properties: {
    idempotencyKey: {
      type: 'string',
      description: 'Replay-safe key; a retry with the same key returns the existing organization',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
      description: 'Lowercase kebab-case organization slug',
    },
    externalRef: {
      type: 'string',
      description: 'Identifier of the organization in the external manager',
    },
    seatCount: {
      type: 'number',
      minimum: 1,
      maximum: 10000,
    },
    licenseDefaults: {
      $ref: '#/components/schemas/LicenseDefaultsBodyDto',
    },
  },
  required: ['idempotencyKey', 'name', 'slug', 'externalRef', 'seatCount', 'licenseDefaults'],
} as const;

export const $IssuedCredentialResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    secret: {
      type: 'string',
      description: 'Shown once; stored hashed and never retrievable again',
    },
  },
  required: ['id', 'secret'],
} as const;

export const $BootstrapOrganizationResponseDto = {
  type: 'object',
  properties: {
    organizationId: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    subscriptionId: {
      type: 'string',
    },
    credential: {
      nullable: true,
      type: 'object',
      allOf: [
        {
          $ref: '#/components/schemas/IssuedCredentialResponseDto',
        },
      ],
    },
    credentialAlreadyIssued: {
      type: 'boolean',
      description: 'True on a replay: the credential was issued by the original request',
    },
  },
  required: ['organizationId', 'workspaceId', 'subscriptionId', 'credential', 'credentialAlreadyIssued'],
} as const;

export const $ServiceOrganizationTeamResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
  },
  required: ['id', 'slug', 'name'],
} as const;

export const $ServiceOrganizationResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    slug: {
      type: 'string',
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    externalManagerName: {
      type: 'string',
      nullable: true,
    },
    managementSource: {
      enum: ['SELF', 'EXTERNAL'],
      type: 'string',
    },
    seatCount: {
      type: 'number',
    },
    assignedSeatCount: {
      type: 'number',
    },
    subscriptionId: {
      type: 'string',
      nullable: true,
    },
    defaultWorkspaceId: {
      type: 'string',
      nullable: true,
    },
    teams: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ServiceOrganizationTeamResponseDto',
      },
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'slug', 'managementSource', 'seatCount', 'assignedSeatCount', 'teams', 'createdAt'],
} as const;

export const $PatchServiceOrganizationBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    seatCount: {
      type: 'number',
      minimum: 1,
      maximum: 10000,
    },
  },
} as const;

export const $RotateOrganizationCredentialBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    revokeOthers: {
      type: 'boolean',
      description: 'Revoke every other active credential of the organization',
    },
  },
} as const;

export const $UpsertProvisionedMemberBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
    externalRef: {
      type: 'string',
      description: 'Identifier of the member in the external manager',
    },
    teamSlugs: {
      description: 'Team slugs of the organization the member joins',
      type: 'array',
      items: {
        type: 'string',
      },
    },
    assignLicense: {
      type: 'boolean',
    },
  },
  required: ['email', 'teamSlugs', 'assignLicense'],
} as const;

export const $ProvisionedMemberResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    externalRef: {
      type: 'string',
      nullable: true,
    },
    state: {
      enum: ['PENDING', 'LINKED', 'WAITING_FOR_SEAT', 'DEACTIVATED'],
      type: 'string',
    },
    teamSlugs: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    assignLicense: {
      type: 'boolean',
    },
    membershipId: {
      type: 'string',
      nullable: true,
    },
    userId: {
      type: 'string',
      nullable: true,
    },
    licenseId: {
      type: 'string',
      nullable: true,
    },
    lastError: {
      type: 'string',
      nullable: true,
    },
    linkedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    deactivatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'email', 'state', 'teamSlugs', 'assignLicense'],
} as const;

export const $ChangeProvisionedMemberEmailBodyDto = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
    },
  },
  required: ['email'],
} as const;

export const $CreateServiceCredentialBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      description: 'Identifies the external manager this credential belongs to',
    },
    scopes: {
      type: 'array',
      items: {
        type: 'string',
        enum: ['org:bootstrap', 'org:provision', 'webhooks:manage'],
      },
    },
    expiresAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['name', 'scopes'],
} as const;

export const $ServiceCredentialCreatedResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    scopes: {
      type: 'array',
      items: {
        type: 'string',
        enum: ['org:bootstrap', 'org:provision', 'webhooks:manage'],
      },
    },
    disabled: {
      type: 'boolean',
    },
    expiresAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastUsedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    createdByUserId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    secret: {
      type: 'string',
      description: 'Shown once; it is stored hashed and cannot be retrieved again',
    },
  },
  required: ['id', 'name', 'scopes', 'disabled', 'createdAt', 'secret'],
} as const;

export const $PrismaServiceCredentialDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    scopes: {
      type: 'array',
      items: {
        type: 'string',
        enum: ['org:bootstrap', 'org:provision', 'webhooks:manage'],
      },
    },
    disabled: {
      type: 'boolean',
    },
    expiresAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    lastUsedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    createdByUserId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'name', 'scopes', 'disabled', 'createdAt'],
} as const;

export const $CreateApiKeyBodyDto = {
  type: 'object',
  properties: {
    expirationDate: {
      format: 'date-time',
      type: 'string',
    },
  },
} as const;

export const $PrismaOrganizationApiKeyDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    name: {
      type: 'string',
      nullable: true,
    },
    revokedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    createdByServiceCredentialId: {
      type: 'string',
      nullable: true,
    },
    expirationDate: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    creatorId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'organizationId', 'createdAt'],
} as const;

export const $CreateSmsCountryBodyDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    prefix: {
      type: 'string',
    },
    status: {
      enum: ['ALLOW_ALL', 'ALLOW_WHITELIST'],
      type: 'string',
    },
  },
  required: ['code', 'prefix', 'status'],
} as const;

export const $PrismaSMSCountryCodeDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    prefix: {
      type: 'string',
    },
    status: {
      enum: ['ALLOW_ALL', 'ALLOW_WHITELIST'],
      type: 'string',
    },
  },
  required: ['code', 'prefix', 'status'],
} as const;

export const $UpdateSmsCountryBodyDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    prefix: {
      type: 'string',
    },
    status: {
      enum: ['ALLOW_ALL', 'ALLOW_WHITELIST'],
      type: 'string',
    },
  },
} as const;

export const $CreateSmsWhitelistBodyDto = {
  type: 'object',
  properties: {
    number: {
      type: 'string',
    },
  },
  required: ['number'],
} as const;

export const $PrismaSMSWhitelistDto = {
  type: 'object',
  properties: {
    number: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['number', 'createdAt'],
} as const;

export const $CreateTransactionCodeBodyDto = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    direction: {
      enum: ['credit', 'debit'],
      type: 'string',
    },
    status: {
      enum: ['charge', 'credit', 'refund', 'purchase', 'adjustment', 'payment', 'subscription'],
      type: 'string',
    },
  },
  required: ['code', 'name', 'description', 'direction', 'status'],
} as const;

export const $GetTransactionCodesListResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaTransactionCodeDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $AdminJobsLiveDashboardSubscriptionBodyDto = {
  type: 'object',
  properties: {
    sessionId: {
      type: 'string',
    },
  },
  required: ['sessionId'],
} as const;

export const $AdminJobDetailsSubscriptionBodyDto = {
  type: 'object',
  properties: {
    sessionId: {
      type: 'string',
      description: 'Websocket session id',
    },
    jobId: {
      type: 'string',
      description: 'Admin job details page job id',
    },
  },
  required: ['sessionId', 'jobId'],
} as const;

export const $WebsocketConfigResponseDto = {
  type: 'object',
  properties: {
    websocketHost: {
      type: 'string',
      example: '9mwy3kb02g.execute-api.us-east-1.amazonaws.com',
      description: 'Host of the WebSocket API gateway',
    },
    websocketStage: {
      type: 'string',
      example: 'dev',
      description: 'Stage of the WebSocket API gateway',
    },
  },
  required: ['websocketHost', 'websocketStage'],
} as const;

export const $TemporalConfigResponseDto = {
  type: 'object',
  properties: {
    namespace: {
      type: 'string',
      example: 'staging',
      description: 'Temporal namespace this environment runs workflows in',
    },
    webUiUrl: {
      type: 'string',
      example: 'https://temporal-staging.autoscript.ai',
      description: 'Base URL of the Temporal Web UI for building workflow debug links',
    },
  },
  required: ['namespace', 'webUiUrl'],
} as const;

export const $StripeConfigResponseDto = {
  type: 'object',
  properties: {
    publishableKey: {
      type: 'string',
      example: 'pk_test_51TPHjNGcbyvbDzot...',
      description: 'Stripe publishable key for the sandbox/account this backend is paired with',
    },
  },
  required: ['publishableKey'],
} as const;

export const $HealthCheckItemDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      description: 'Status of the check',
    },
    message: {
      type: 'string',
      description: 'Error message when unhealthy',
    },
  },
  required: ['status'],
} as const;

export const $HealthCheckChecksDto = {
  type: 'object',
  properties: {
    database: {
      $ref: '#/components/schemas/HealthCheckItemDto',
    },
    redis: {
      $ref: '#/components/schemas/HealthCheckItemDto',
    },
  },
  required: ['database', 'redis'],
} as const;

export const $HealthCheckResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'healthy',
    },
    timestamp: {
      type: 'string',
      example: '2025-12-16T10:00:00.000Z',
    },
    checks: {
      $ref: '#/components/schemas/HealthCheckChecksDto',
    },
  },
  required: ['status', 'timestamp', 'checks'],
} as const;

export const $SimpleHealthResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'ok',
      description: 'Health status',
    },
    timestamp: {
      type: 'string',
      example: '2025-12-16T10:00:00.000Z',
      description: 'ISO timestamp',
    },
  },
  required: ['status', 'timestamp'],
} as const;

export const $StatusResponseDto = {
  type: 'object',
  properties: {
    status: {
      type: 'string',
      example: 'ok',
      description: 'Status',
    },
  },
  required: ['status'],
} as const;

export const $Version = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    metricsId: {
      type: 'string',
      nullable: true,
    },
    predecessorId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'createdAt', 'jobId', 'userId'],
} as const;

export const $VersionWithUploadLinks = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    metricsId: {
      type: 'string',
      nullable: true,
    },
    predecessorId: {
      type: 'string',
      nullable: true,
    },
    jobJson: {
      type: 'string',
    },
    jobDoc: {
      type: 'string',
    },
  },
  required: ['id', 'createdAt', 'jobId', 'userId', 'jobJson', 'jobDoc'],
} as const;

export const $VersionUploadLinks = {
  type: 'object',
  properties: {
    jobJson: {
      type: 'string',
    },
    jobDoc: {
      type: 'string',
    },
  },
  required: ['jobJson', 'jobDoc'],
} as const;

export const $VersionIdWithUploadLinks = {
  type: 'object',
  properties: {
    versionId: {
      type: 'string',
    },
    uploadLinks: {
      $ref: '#/components/schemas/VersionUploadLinks',
    },
  },
  required: ['versionId', 'uploadLinks'],
} as const;

export const $MetricsDto = {
  type: 'object',
  properties: {
    editsCount: {
      type: 'number',
    },
    startedEditingAt: {
      format: 'date-time',
      type: 'string',
    },
    finishedEditingAt: {
      format: 'date-time',
      type: 'string',
    },
    pagesCount: {
      type: 'number',
    },
  },
  required: ['editsCount', 'startedEditingAt', 'finishedEditingAt', 'pagesCount'],
} as const;

export const $CreateVersionBodyDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    predecessorId: {
      type: 'string',
    },
    metrics: {
      $ref: '#/components/schemas/MetricsDto',
    },
    isJobCompleted: {
      type: 'boolean',
    },
    getUploadLinksOnly: {
      type: 'boolean',
    },
    uploadedVersionId: {
      type: 'string',
    },
  },
  required: ['jobId', 'userId', 'metrics'],
} as const;

export const $CreateInitialVersionBodyDto = {
  type: 'object',
  properties: {
    getUploadLinksOnly: {
      type: 'boolean',
    },
    uploadedVersionId: {
      type: 'string',
    },
  },
} as const;

export const $PrismaJobFilesVersionDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    jobId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    metricsId: {
      type: 'string',
      nullable: true,
    },
    predecessorId: {
      type: 'string',
      nullable: true,
    },
    jobFilesCheckoutEventId: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['id', 'createdAt', 'jobId', 'userId'],
} as const;

export const $PrismaJobFilesCheckoutEventDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    jobStatus: {
      type: 'string',
    },
    initialVersionId: {
      type: 'string',
      nullable: true,
    },
    finalVersionId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    finalizedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['id', 'userId', 'jobId', 'jobStatus', 'createdAt'],
} as const;

export const $CourseResponseDtoEnrollment = {
  type: 'object',
  properties: {
    type: {
      type: 'string',
    },
    role: {
      type: 'string',
    },
    role_id: {
      type: 'number',
    },
    user_id: {
      type: 'number',
    },
    limit_privileges_to_course_section: {
      type: 'boolean',
    },
  },
  required: ['type', 'role', 'role_id', 'user_id', 'limit_privileges_to_course_section'],
} as const;

export const $CourseResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'number',
    },
    account_id: {
      type: 'number',
    },
    root_account_id: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    uuid: {
      type: 'string',
    },
    start_at: {
      type: 'string',
    },
    enrollment_term_id: {
      type: 'number',
    },
    grading_standard_id: {
      type: 'string',
      nullable: true,
    },
    is_public: {
      type: 'boolean',
    },
    created_at: {
      type: 'string',
    },
    course_code: {
      type: 'string',
    },
    default_view: {
      type: 'string',
    },
    license: {
      type: 'string',
    },
    grade_passback_setting: {
      type: 'string',
      nullable: true,
    },
    end_at: {
      type: 'string',
      nullable: true,
    },
    public_syllabus: {
      type: 'boolean',
    },
    public_syllabus_to_auth: {
      type: 'boolean',
    },
    storage_quota_mb: {
      type: 'number',
    },
    is_public_to_auth_users: {
      type: 'boolean',
    },
    homeroom_course: {
      type: 'boolean',
    },
    course_color: {
      type: 'string',
      nullable: true,
    },
    friendly_name: {
      type: 'string',
      nullable: true,
    },
    apply_assignment_group_weights: {
      type: 'boolean',
    },
    total_students: {
      type: 'number',
    },
    time_zone: {
      type: 'string',
    },
    blueprint: {
      type: 'boolean',
    },
    sis_course_id: {
      type: 'string',
      nullable: true,
    },
    sis_import_id: {
      type: 'string',
      nullable: true,
    },
    integration_id: {
      type: 'string',
      nullable: true,
    },
    hide_final_grades: {
      type: 'boolean',
    },
    workflow_state: {
      type: 'string',
    },
    course_format: {
      type: 'string',
    },
    restrict_enrollments_to_course_dates: {
      type: 'boolean',
    },
    overridden_course_visibility: {
      type: 'string',
    },
    calendar: {
      type: 'object',
      properties: {
        ics: {
          type: 'string',
        },
      },
      required: ['ics'],
    },
    enrollments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CourseResponseDtoEnrollment',
      },
    },
  },
  required: [
    'id',
    'account_id',
    'root_account_id',
    'name',
    'uuid',
    'start_at',
    'enrollment_term_id',
    'is_public',
    'created_at',
    'course_code',
    'default_view',
    'license',
    'public_syllabus',
    'public_syllabus_to_auth',
    'storage_quota_mb',
    'is_public_to_auth_users',
    'homeroom_course',
    'apply_assignment_group_weights',
    'total_students',
    'time_zone',
    'blueprint',
    'hide_final_grades',
    'workflow_state',
    'course_format',
    'restrict_enrollments_to_course_dates',
    'overridden_course_visibility',
    'calendar',
    'enrollments',
  ],
} as const;

export const $PrismaCanvasStudentLicenseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    membershipId: {
      type: 'string',
      nullable: true,
    },
    expirationDate: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'createdAt', 'expirationDate'],
} as const;

export const $CourseStudentResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'number',
    },
    name: {
      type: 'string',
    },
    created_at: {
      type: 'string',
    },
    sortable_name: {
      type: 'string',
    },
    short_name: {
      type: 'string',
    },
    sis_user_id: {
      type: 'string',
      nullable: true,
    },
    integration_id: {
      type: 'string',
      nullable: true,
    },
    sis_import_id: {
      type: 'string',
      nullable: true,
    },
    login_id: {
      type: 'string',
      nullable: true,
    },
    registeredInASW: {
      type: 'boolean',
    },
    hasMembership: {
      type: 'boolean',
    },
    licenses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaCanvasStudentLicenseDto',
      },
    },
    farthestExpirationDate: {
      type: 'number',
    },
  },
  required: ['id', 'name', 'created_at', 'sortable_name', 'short_name'],
} as const;

export const $CreateUserBodyDto = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
    },
    lastName: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    organization: {
      type: 'string',
    },
    team: {
      type: 'string',
    },
    license: {
      type: 'string',
    },
  },
  required: ['name', 'lastName', 'email', 'phone', 'organization', 'team', 'license'],
} as const;

export const $GetAllPromptsResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    version: {
      type: 'number',
    },
    slug: {
      type: 'string',
    },
    systemPrompt: {
      type: 'string',
    },
    template: {
      type: 'string',
    },
    variables: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'version', 'slug', 'systemPrompt', 'template', 'variables', 'createdAt', 'updatedAt'],
} as const;

export const $PrismaPromptDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    version: {
      type: 'number',
    },
    slug: {
      type: 'string',
    },
    systemPrompt: {
      type: 'string',
    },
    template: {
      type: 'string',
    },
    variables: {
      type: 'string',
    },
    agentic: {
      type: 'boolean',
      nullable: true,
    },
    defaultModel: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: [
    'id',
    'version',
    'slug',
    'systemPrompt',
    'template',
    'variables',
    'agentic',
    'defaultModel',
    'createdAt',
    'updatedAt',
  ],
} as const;

export const $UpdateTemplateBodyDto = {
  type: 'object',
  properties: {
    slug: {
      enum: [
        'ANALYZE_PREPROCESSING_ERROR',
        'ANALYZE_TRANSCRIPT_SUBMITTER_ERROR',
        'ANALYZE_TRANSCRIPT_PREPARER_ERROR',
        'NOTICE_EXTRACTOR_LEGAL_DATA',
        'NOTICE_EXTRACTOR_SOURCE_MAPPING',
        'NOTICE_EXTRACTOR_KEYTERMS',
        'AGENTIC_METADATA_STRUCTURED',
        'AGENTIC_PREFLIGHT_PLANNER',
        'AGENTIC_CONTEXT_EXTRACTION',
        'AGENTIC_NAME_SPELLING_CORRECTION',
        'AGENTIC_LEGAL_ENTITIES',
        'AGENTIC_DATES_TIMES',
        'AGENTIC_NUMERIC_FORMATTING',
        'AGENTIC_CONTRACTIONS_ORTHOGRAPHY',
        'AGENTIC_ACRONYMS_INSTITUTIONS',
        'AGENTIC_ENTITY_FORMATTING',
        'AGENTIC_PUNCTUATION',
        'AGENTIC_PUNCTUATION_GUARDRAIL',
        'AGENTIC_FINAL_VALIDATOR',
        'AGENTIC_GUARDRAIL_RETRY',
        'AGENTIC_REPORTER_SUMMARY',
        'AGENTIC_FOREIGN_LANGUAGE_REMOVAL',
        'AGENTIC_DIARIZATION_ERROR_CORRECTION',
        'AGENTIC_SPEAKER_RECONCILIATION',
        'AGENTIC_POLISH',
        'AGENTIC_TRANSCRIPT_ANALYSIS_TIMESTAMPS',
        'AGENTIC_TRANSCRIPT_ISSUE_INVESTIGATION',
        'AGENTIC_ERROR_PREFLIGHT_PLANNER',
        'AGENTIC_ERROR_ANALYSIS',
        'AGENTIC_ERROR_LOGS_ANALYSIS',
        'AGENTIC_ERROR_SOURCE_CODE_ANALYSIS',
        'AGENTIC_ERROR_AUDIO_PREPROCESSING_ANALYSIS',
        'AGENTIC_ERROR_INFRASTRUCTURE_ANALYSIS',
        'AGENTIC_ERROR_APPLY_SUGGESTIONS',
      ],
      type: 'string',
    },
    systemPrompt: {
      type: 'string',
    },
    template: {
      type: 'string',
    },
  },
  required: ['slug', 'systemPrompt', 'template'],
} as const;

export const $UpdateTemplateResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    version: {
      type: 'number',
    },
    slug: {
      type: 'string',
    },
    systemPrompt: {
      type: 'string',
    },
    template: {
      type: 'string',
    },
    variables: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'version', 'slug', 'systemPrompt', 'template', 'variables', 'createdAt', 'updatedAt'],
} as const;

export const $UpdateDefaultModelBodyDto = {
  type: 'object',
  properties: {
    model: {
      type: 'string',
    },
  },
  required: ['model'],
} as const;

export const $PrismaPromptConfigDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    organizationId: {
      type: 'string',
    },
    promptSlug: {
      type: 'string',
    },
    model: {
      type: 'string',
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'organizationId', 'promptSlug', 'model', 'createdAt', 'updatedAt'],
} as const;

export const $PipelineCurrentAttemptDto = {
  type: 'object',
  properties: {
    attemptId: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    jobName: {
      type: 'string',
    },
    jobStatus: {
      type: 'string',
    },
    attemptStatus: {
      type: 'string',
    },
    autoRetried: {
      type: 'boolean',
    },
    startedAt: {
      type: 'string',
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    durationMs: {
      type: 'number',
      description: 'Elapsed time in milliseconds since attempt started',
    },
    workspaceId: {
      type: 'string',
    },
    latestEventStage: {
      type: 'string',
      nullable: true,
    },
    latestEventStatus: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['attemptId', 'jobId', 'jobName', 'jobStatus', 'attemptStatus', 'autoRetried', 'startedAt', 'durationMs'],
} as const;

export const $PaginatedPipelineCurrentAttemptResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineCurrentAttemptDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $PipelineJobSubmissionBucketResponseDto = {
  type: 'object',
  properties: {
    hour: {
      type: 'string',
      format: 'date-time',
    },
    jobCount: {
      type: 'number',
    },
    totalDurationSeconds: {
      type: 'number',
      description: 'Sum of job durations for the hour in seconds',
    },
  },
  required: ['hour', 'jobCount', 'totalDurationSeconds'],
} as const;

export const $PipelineEventDurationStatsResponseDto = {
  type: 'object',
  properties: {
    service: {
      type: 'string',
    },
    stage: {
      type: 'string',
    },
    count: {
      type: 'number',
    },
    avgDurationSeconds: {
      type: 'number',
    },
    p50DurationSeconds: {
      type: 'number',
    },
    p90DurationSeconds: {
      type: 'number',
    },
    p95DurationSeconds: {
      type: 'number',
    },
  },
  required: [
    'service',
    'stage',
    'count',
    'avgDurationSeconds',
    'p50DurationSeconds',
    'p90DurationSeconds',
    'p95DurationSeconds',
  ],
} as const;

export const $PipelineErroredJobDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    jobName: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    statusChangeDate: {
      type: 'string',
      format: 'date-time',
    },
    erroredDurationSeconds: {
      type: 'number',
      description: 'Seconds elapsed since job entered error status',
    },
    latestAttemptId: {
      type: 'string',
      nullable: true,
    },
    latestAttemptStatus: {
      type: 'string',
      nullable: true,
    },
    latestAttemptAutoRetried: {
      type: 'boolean',
      nullable: true,
    },
    latestAttemptStartedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    latestAttemptCompletedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['jobId', 'jobName', 'workspaceId', 'status', 'statusChangeDate', 'erroredDurationSeconds'],
} as const;

export const $PaginatedPipelineErroredJobResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineErroredJobDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $PipelineProcessingJobDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    jobName: {
      type: 'string',
    },
    workspaceId: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    statusChangeDate: {
      type: 'string',
      format: 'date-time',
    },
    processingStartedAt: {
      type: 'string',
      format: 'date-time',
      description: 'Timestamp used to calculate processing duration',
    },
    processingDurationSeconds: {
      type: 'number',
      description: 'Seconds elapsed since job entered processing status',
    },
    latestAttemptId: {
      type: 'string',
      nullable: true,
    },
    latestAttemptStatus: {
      type: 'string',
      nullable: true,
    },
    latestAttemptAutoRetried: {
      type: 'boolean',
      nullable: true,
    },
    latestAttemptStartedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
    latestAttemptCompletedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: [
    'jobId',
    'jobName',
    'workspaceId',
    'status',
    'statusChangeDate',
    'processingStartedAt',
    'processingDurationSeconds',
  ],
} as const;

export const $PaginatedPipelineProcessingJobResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineProcessingJobDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $PipelineManualJobUpdateResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    jobStatus: {
      type: 'string',
    },
    attemptId: {
      type: 'string',
      nullable: true,
    },
    attemptStatus: {
      type: 'string',
      nullable: true,
    },
  },
  required: ['jobId', 'jobStatus'],
} as const;

export const $PipelineAttemptUpdateResponseDto = {
  type: 'object',
  properties: {
    attemptId: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    completedAt: {
      type: 'string',
      nullable: true,
      format: 'date-time',
    },
  },
  required: ['attemptId', 'jobId', 'status'],
} as const;

export const $PipelineJobRemovalUpdateBodyDto = {
  type: 'object',
  properties: {
    removed: {
      type: 'boolean',
      description: 'Flag indicating whether the job should be marked as deleted',
    },
  },
  required: ['removed'],
} as const;

export const $PipelineJobRemovalResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    removed: {
      type: 'boolean',
    },
  },
  required: ['jobId', 'removed'],
} as const;

export const $PipelinePerformanceTrendPointResponseDto = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
      format: 'date',
    },
    service: {
      type: 'string',
    },
    stage: {
      type: 'string',
    },
    completedCount: {
      type: 'number',
    },
    failedCount: {
      type: 'number',
    },
    skippedCount: {
      type: 'number',
    },
    sumStageSecondsCompleted: {
      type: 'number',
    },
    sumAudioSecondsCompleted: {
      type: 'number',
    },
    weightedRatio: {
      type: 'number',
      nullable: true,
    },
  },
  required: [
    'date',
    'service',
    'stage',
    'completedCount',
    'failedCount',
    'skippedCount',
    'sumStageSecondsCompleted',
    'sumAudioSecondsCompleted',
  ],
} as const;

export const $PipelinePerformanceTrendsResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelinePerformanceTrendPointResponseDto',
      },
    },
  },
  required: ['data'],
} as const;

export const $PipelineWatchlistItemResponseDto = {
  type: 'object',
  properties: {
    jobId: {
      type: 'string',
    },
    service: {
      type: 'string',
      nullable: true,
    },
    stage: {
      type: 'string',
      nullable: true,
    },
    audioDurationSeconds: {
      type: 'number',
      nullable: true,
    },
    timeInStageSeconds: {
      type: 'number',
    },
    status: {
      type: 'string',
    },
  },
  required: ['jobId', 'timeInStageSeconds', 'status'],
} as const;

export const $PipelineWatchlistResponseDto = {
  type: 'object',
  properties: {
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PipelineWatchlistItemResponseDto',
      },
    },
  },
  required: ['data'],
} as const;

export const $PipelineEventBodyDto = {
  type: 'object',
  properties: {
    event: {
      enum: [
        'JOB_SUBMITTED',
        'PREPROCESSING',
        'PREPROCESSING_FAILED',
        'AUDIO_TRANSCRIPTION_WEBHOOK_SENDING',
        'AUDIO_TRANSCRIPTION_COMPLETED',
        'AUDIO_TRANSCRIPTION_FAILED',
        'TRANSCRIPT_SUBMISSION',
        'TRANSCRIPT_SUBMISSION_COMPLETED',
        'TRANSCRIPT_SUBMISSION_FAILED',
        'TRANSCRIPT_SUBMISSION_REMEDIATION_REQUIRED',
        'ASR_REMEDIATION_HANDOFF_FAILED',
        'RESET_ACTOR',
        'LLM_ANALYSIS',
        'LLM_ANALYSIS_FAILED',
        'TRANSCRIPT_PREPARATION',
        'TRANSCRIPT_PREPARATION_FAILED',
        'REGENERATE_WITH_NEW_CLOUD_LAYOUT',
        'REGENERATE_ENHANCED_TRANSCRIPT',
        'SLACK_ACTION_AFTER_ERROR_ANALYSIS',
        'SUGGESTIONS_APPLIED',
      ],
      type: 'string',
      description: 'Pipeline event name',
    },
    payload: {
      type: 'object',
      additionalProperties: true,
      description: 'Event payload as emitted by the reporting stage',
    },
  },
  required: ['event', 'payload'],
} as const;

export const $InternalResubmitJobBodyDto = {
  type: 'object',
  properties: {
    actorId: {
      type: 'string',
      description: 'User id to attribute the resubmit to. Defaults to the job creator when omitted.',
    },
  },
} as const;

export const $TranscriptReviewProposalResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    sessionId: {
      type: 'string',
      nullable: true,
      description: 'null for preview-only proposals',
    },
    sequence: {
      type: 'number',
    },
    status: {
      enum: ['PENDING', 'ACCEPTED', 'REJECTED', 'STALE', 'FAILED'],
      type: 'string',
    },
    source: {
      enum: ['FIXTURE', 'LLM', 'CHAT'],
      type: 'string',
    },
    agentName: {
      type: 'string',
    },
    prompt: {
      type: 'string',
      nullable: true,
    },
    targetRevision: {
      type: 'number',
    },
    patch: {
      type: 'object',
      additionalProperties: true,
    },
    changedLines: {
      type: 'array',
      items: {
        type: 'number',
      },
    },
    applyErrors: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    metadata: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
  },
  required: [
    'id',
    'sequence',
    'status',
    'source',
    'agentName',
    'targetRevision',
    'patch',
    'changedLines',
    'applyErrors',
    'createdAt',
  ],
} as const;

export const $TranscriptReviewSessionResponseDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    jobId: {
      type: 'string',
    },
    userId: {
      type: 'string',
    },
    sourceVersionId: {
      type: 'string',
      nullable: true,
    },
    publishedVersionId: {
      type: 'string',
      nullable: true,
    },
    status: {
      enum: ['DRAFT', 'PUBLISHING', 'PUBLISHED'],
      type: 'string',
    },
    title: {
      type: 'string',
    },
    sourceTranscript: {
      type: 'string',
    },
    draftTranscript: {
      type: 'string',
    },
    currentRevision: {
      type: 'number',
    },
    proposals: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TranscriptReviewProposalResponseDto',
      },
    },
    createdAt: {
      format: 'date-time',
      type: 'string',
    },
    updatedAt: {
      format: 'date-time',
      type: 'string',
    },
  },
  required: [
    'id',
    'jobId',
    'userId',
    'status',
    'title',
    'sourceTranscript',
    'draftTranscript',
    'currentRevision',
    'proposals',
    'createdAt',
    'updatedAt',
  ],
} as const;

export const $CreateTranscriptReviewSessionBodyDto = {
  type: 'object',
  properties: {
    sourceVersionId: {
      type: 'string',
    },
    title: {
      type: 'string',
    },
    transcript: {
      type: 'string',
    },
  },
} as const;

export const $TranscriptReviewFixturesSummaryResponseDto = {
  type: 'object',
  properties: {
    hasArtifacts: {
      type: 'boolean',
    },
    chunkCount: {
      type: 'number',
    },
    eventCount: {
      type: 'number',
    },
  },
  required: ['hasArtifacts', 'chunkCount', 'eventCount'],
} as const;

export const $TranscriptReviewFixtureChunkResponseDto = {
  type: 'object',
  properties: {
    index: {
      type: 'number',
    },
    startLine: {
      type: 'number',
    },
    endLine: {
      type: 'number',
    },
    eventCount: {
      type: 'number',
    },
    baseText: {
      type: 'string',
    },
    finalText: {
      type: 'string',
    },
  },
  required: ['index', 'startLine', 'endLine', 'eventCount', 'baseText', 'finalText'],
} as const;

export const $TranscriptReviewFixtureManifestResponseDto = {
  type: 'object',
  properties: {
    chunks: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TranscriptReviewFixtureChunkResponseDto',
      },
    },
    eventCount: {
      type: 'number',
    },
    transcript: {
      type: 'string',
    },
  },
  required: ['chunks', 'eventCount', 'transcript'],
} as const;

export const $TranscriptReviewFixtureEventsResponseDto = {
  type: 'object',
  properties: {
    chunkIndex: {
      type: 'number',
    },
    eventCount: {
      type: 'number',
    },
    events: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
  },
  required: ['chunkIndex', 'eventCount', 'events'],
} as const;

export const $TranscriptReviewFixturesResponseDto = {
  type: 'object',
  properties: {
    chunks: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TranscriptReviewFixtureChunkResponseDto',
      },
    },
    events: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
    transcript: {
      type: 'string',
    },
  },
  required: ['chunks', 'events', 'transcript'],
} as const;

export const $ImportTranscriptReviewEventsBodyDto = {
  type: 'object',
  properties: {
    events: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
  },
  required: ['events'],
} as const;

export const $DecideTranscriptReviewProposalBodyDto = {
  type: 'object',
  properties: {
    decision: {
      enum: ['ACCEPTED', 'REJECTED'],
      type: 'string',
    },
  },
  required: ['decision'],
} as const;

export const $RequestTranscriptReviewEditBodyDto = {
  type: 'object',
  properties: {
    prompt: {
      type: 'string',
      maxLength: 10000,
    },
    lineNumbers: {
      type: 'array',
      items: {
        type: 'number',
      },
    },
    startLine: {
      type: 'number',
    },
    endLine: {
      type: 'number',
    },
    targetRevision: {
      type: 'number',
      default: 0,
    },
    chunkLineCount: {
      type: 'number',
      default: 80,
    },
    editMode: {
      type: 'string',
    },
  },
  required: ['prompt'],
} as const;

export const $PreviewTranscriptReviewEditBodyDto = {
  type: 'object',
  properties: {
    transcript: {
      type: 'string',
      maxLength: 2000000,
    },
    prompt: {
      type: 'string',
      maxLength: 10000,
    },
    lineNumbers: {
      type: 'array',
      items: {
        type: 'number',
      },
    },
    startLine: {
      type: 'number',
    },
    endLine: {
      type: 'number',
    },
    targetRevision: {
      type: 'number',
      default: 0,
    },
    chunkLineCount: {
      type: 'number',
      default: 80,
    },
    editMode: {
      type: 'string',
    },
  },
  required: ['transcript', 'prompt'],
} as const;

export const $PublishTranscriptReviewSessionResponseDto = {
  type: 'object',
  properties: {
    versionId: {
      type: 'string',
    },
    session: {
      $ref: '#/components/schemas/TranscriptReviewSessionResponseDto',
    },
  },
  required: ['versionId', 'session'],
} as const;

export const $PrismaAuditLogDto = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    entityType: {
      type: 'string',
    },
    entityId: {
      type: 'string',
    },
    action: {
      enum: ['CREATE', 'UPDATE', 'DELETE'],
      type: 'string',
    },
    operation: {
      type: 'string',
    },
    businessAction: {
      type: 'string',
      nullable: true,
    },
    before: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    after: {
      type: 'object',
      additionalProperties: true,
      nullable: true,
    },
    changedFields: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    actorType: {
      enum: [
        'USER',
        'ORGANIZATION_API_KEY',
        'INTERNAL_API_KEY',
        'SERVICE_CREDENTIAL',
        'STRIPE_WEBHOOK',
        'CRON',
        'QUEUE',
        'UNKNOWN',
      ],
      type: 'string',
    },
    actorUserId: {
      type: 'string',
      nullable: true,
    },
    actorLabel: {
      type: 'string',
      nullable: true,
    },
    organizationId: {
      type: 'string',
      nullable: true,
    },
    requestId: {
      type: 'string',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      format: 'date-time',
    },
  },
  required: ['id', 'entityType', 'entityId', 'action', 'operation', 'changedFields', 'actorType', 'createdAt'],
} as const;

export const $PaginatedAuditLogResponseDto = {
  type: 'object',
  properties: {
    count: {
      type: 'number',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PrismaAuditLogDto',
      },
    },
  },
  required: ['count', 'data'],
} as const;

export const $AuditLogEntityTypesResponseDto = {
  type: 'object',
  properties: {
    entityTypes: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['entityTypes'],
} as const;

export const $TranscriptionSettingsResponseDto = {
  type: 'object',
  properties: {
    foreignLanguageRemovalAvailable: {
      type: 'boolean',
      description: 'Whether the selected ASR model supports foreign-language removal',
    },
  },
  required: ['foreignLanguageRemovalAvailable'],
} as const;
